//#region rolldown:runtime
var __create = Object.create;
var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function() {
	return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export$1 = (all) => {
	let target = {};
	for (var name in all) __defProp$1(target, name, {
		get: all[name],
		enumerable: true
	});
	return target;
};
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
		key = keys[i];
		if (!__hasOwnProp.call(to, key) && key !== except) __defProp$1(to, key, {
			get: ((k) => from[k]).bind(null, key),
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp$1(target, "default", {
	value: mod,
	enumerable: true
}) : target, mod));

//#endregion
//#region ../../node_modules/.pnpm/markdown-it-footnote@4.0.0/node_modules/markdown-it-footnote/index.mjs
function render_footnote_anchor_name(tokens, idx, options, env) {
	const n = Number(tokens[idx].meta.id + 1).toString();
	let prefix = "";
	if (typeof env.docId === "string") prefix = `-${env.docId}-`;
	return prefix + n;
}
function render_footnote_caption(tokens, idx) {
	let n = Number(tokens[idx].meta.id + 1).toString();
	if (tokens[idx].meta.subId > 0) n += `:${tokens[idx].meta.subId}`;
	return `[${n}]`;
}
function render_footnote_ref(tokens, idx, options, env, slf) {
	const id = slf.rules.footnote_anchor_name(tokens, idx, options, env, slf);
	const caption = slf.rules.footnote_caption(tokens, idx, options, env, slf);
	let refid = id;
	if (tokens[idx].meta.subId > 0) refid += `:${tokens[idx].meta.subId}`;
	return `<sup class="footnote-ref"><a href="#fn${id}" id="fnref${refid}">${caption}</a></sup>`;
}
function render_footnote_block_open(tokens, idx, options) {
	return (options.xhtmlOut ? "<hr class=\"footnotes-sep\" />\n" : "<hr class=\"footnotes-sep\">\n") + "<section class=\"footnotes\">\n<ol class=\"footnotes-list\">\n";
}
function render_footnote_block_close() {
	return "</ol>\n</section>\n";
}
function render_footnote_open(tokens, idx, options, env, slf) {
	let id = slf.rules.footnote_anchor_name(tokens, idx, options, env, slf);
	if (tokens[idx].meta.subId > 0) id += `:${tokens[idx].meta.subId}`;
	return `<li id="fn${id}" class="footnote-item">`;
}
function render_footnote_close() {
	return "</li>\n";
}
function render_footnote_anchor(tokens, idx, options, env, slf) {
	let id = slf.rules.footnote_anchor_name(tokens, idx, options, env, slf);
	if (tokens[idx].meta.subId > 0) id += `:${tokens[idx].meta.subId}`;
	return ` <a href="#fnref${id}" class="footnote-backref">\u21a9\uFE0E</a>`;
}
function footnote_plugin(md) {
	const parseLinkLabel$1 = md.helpers.parseLinkLabel;
	const isSpace$8 = md.utils.isSpace;
	md.renderer.rules.footnote_ref = render_footnote_ref;
	md.renderer.rules.footnote_block_open = render_footnote_block_open;
	md.renderer.rules.footnote_block_close = render_footnote_block_close;
	md.renderer.rules.footnote_open = render_footnote_open;
	md.renderer.rules.footnote_close = render_footnote_close;
	md.renderer.rules.footnote_anchor = render_footnote_anchor;
	md.renderer.rules.footnote_caption = render_footnote_caption;
	md.renderer.rules.footnote_anchor_name = render_footnote_anchor_name;
	function footnote_def(state, startLine, endLine, silent) {
		const start = state.bMarks[startLine] + state.tShift[startLine];
		const max = state.eMarks[startLine];
		if (start + 4 > max) return false;
		if (state.src.charCodeAt(start) !== 91) return false;
		if (state.src.charCodeAt(start + 1) !== 94) return false;
		let pos;
		for (pos = start + 2; pos < max; pos++) {
			if (state.src.charCodeAt(pos) === 32) return false;
			if (state.src.charCodeAt(pos) === 93) break;
		}
		if (pos === start + 2) return false;
		if (pos + 1 >= max || state.src.charCodeAt(++pos) !== 58) return false;
		if (silent) return true;
		pos++;
		if (!state.env.footnotes) state.env.footnotes = {};
		if (!state.env.footnotes.refs) state.env.footnotes.refs = {};
		const label = state.src.slice(start + 2, pos - 2);
		state.env.footnotes.refs[`:${label}`] = -1;
		const token_fref_o = new state.Token("footnote_reference_open", "", 1);
		token_fref_o.meta = { label };
		token_fref_o.level = state.level++;
		state.tokens.push(token_fref_o);
		const oldBMark = state.bMarks[startLine];
		const oldTShift = state.tShift[startLine];
		const oldSCount = state.sCount[startLine];
		const oldParentType = state.parentType;
		const posAfterColon = pos;
		const initial = state.sCount[startLine] + pos - (state.bMarks[startLine] + state.tShift[startLine]);
		let offset = initial;
		while (pos < max) {
			const ch = state.src.charCodeAt(pos);
			if (isSpace$8(ch)) if (ch === 9) offset += 4 - offset % 4;
			else offset++;
			else break;
			pos++;
		}
		state.tShift[startLine] = pos - posAfterColon;
		state.sCount[startLine] = offset - initial;
		state.bMarks[startLine] = posAfterColon;
		state.blkIndent += 4;
		state.parentType = "footnote";
		if (state.sCount[startLine] < state.blkIndent) state.sCount[startLine] += state.blkIndent;
		state.md.block.tokenize(state, startLine, endLine, true);
		state.parentType = oldParentType;
		state.blkIndent -= 4;
		state.tShift[startLine] = oldTShift;
		state.sCount[startLine] = oldSCount;
		state.bMarks[startLine] = oldBMark;
		const token_fref_c = new state.Token("footnote_reference_close", "", -1);
		token_fref_c.level = --state.level;
		state.tokens.push(token_fref_c);
		return true;
	}
	function footnote_inline(state, silent) {
		const max = state.posMax;
		const start = state.pos;
		if (start + 2 >= max) return false;
		if (state.src.charCodeAt(start) !== 94) return false;
		if (state.src.charCodeAt(start + 1) !== 91) return false;
		const labelStart = start + 2;
		const labelEnd = parseLinkLabel$1(state, start + 1);
		if (labelEnd < 0) return false;
		if (!silent) {
			if (!state.env.footnotes) state.env.footnotes = {};
			if (!state.env.footnotes.list) state.env.footnotes.list = [];
			const footnoteId = state.env.footnotes.list.length;
			const tokens = [];
			state.md.inline.parse(state.src.slice(labelStart, labelEnd), state.md, state.env, tokens);
			const token = state.push("footnote_ref", "", 0);
			token.meta = { id: footnoteId };
			state.env.footnotes.list[footnoteId] = {
				content: state.src.slice(labelStart, labelEnd),
				tokens
			};
		}
		state.pos = labelEnd + 1;
		state.posMax = max;
		return true;
	}
	function footnote_ref(state, silent) {
		const max = state.posMax;
		const start = state.pos;
		if (start + 3 > max) return false;
		if (!state.env.footnotes || !state.env.footnotes.refs) return false;
		if (state.src.charCodeAt(start) !== 91) return false;
		if (state.src.charCodeAt(start + 1) !== 94) return false;
		let pos;
		for (pos = start + 2; pos < max; pos++) {
			if (state.src.charCodeAt(pos) === 32) return false;
			if (state.src.charCodeAt(pos) === 10) return false;
			if (state.src.charCodeAt(pos) === 93) break;
		}
		if (pos === start + 2) return false;
		if (pos >= max) return false;
		pos++;
		const label = state.src.slice(start + 2, pos - 1);
		if (typeof state.env.footnotes.refs[`:${label}`] === "undefined") return false;
		if (!silent) {
			if (!state.env.footnotes.list) state.env.footnotes.list = [];
			let footnoteId;
			if (state.env.footnotes.refs[`:${label}`] < 0) {
				footnoteId = state.env.footnotes.list.length;
				state.env.footnotes.list[footnoteId] = {
					label,
					count: 0
				};
				state.env.footnotes.refs[`:${label}`] = footnoteId;
			} else footnoteId = state.env.footnotes.refs[`:${label}`];
			const footnoteSubId = state.env.footnotes.list[footnoteId].count;
			state.env.footnotes.list[footnoteId].count++;
			const token = state.push("footnote_ref", "", 0);
			token.meta = {
				id: footnoteId,
				subId: footnoteSubId,
				label
			};
		}
		state.pos = pos;
		state.posMax = max;
		return true;
	}
	function footnote_tail(state) {
		let tokens;
		let current;
		let currentLabel;
		let insideRef = false;
		const refTokens = {};
		if (!state.env.footnotes) return;
		state.tokens = state.tokens.filter(function(tok) {
			if (tok.type === "footnote_reference_open") {
				insideRef = true;
				current = [];
				currentLabel = tok.meta.label;
				return false;
			}
			if (tok.type === "footnote_reference_close") {
				insideRef = false;
				refTokens[":" + currentLabel] = current;
				return false;
			}
			if (insideRef) current.push(tok);
			return !insideRef;
		});
		if (!state.env.footnotes.list) return;
		const list$1 = state.env.footnotes.list;
		state.tokens.push(new state.Token("footnote_block_open", "", 1));
		for (let i = 0, l = list$1.length; i < l; i++) {
			const token_fo = new state.Token("footnote_open", "", 1);
			token_fo.meta = {
				id: i,
				label: list$1[i].label
			};
			state.tokens.push(token_fo);
			if (list$1[i].tokens) {
				tokens = [];
				const token_po = new state.Token("paragraph_open", "p", 1);
				token_po.block = true;
				tokens.push(token_po);
				const token_i = new state.Token("inline", "", 0);
				token_i.children = list$1[i].tokens;
				token_i.content = list$1[i].content;
				tokens.push(token_i);
				const token_pc = new state.Token("paragraph_close", "p", -1);
				token_pc.block = true;
				tokens.push(token_pc);
			} else if (list$1[i].label) tokens = refTokens[`:${list$1[i].label}`];
			if (tokens) state.tokens = state.tokens.concat(tokens);
			let lastParagraph;
			if (state.tokens[state.tokens.length - 1].type === "paragraph_close") lastParagraph = state.tokens.pop();
			else lastParagraph = null;
			const t = list$1[i].count > 0 ? list$1[i].count : 1;
			for (let j = 0; j < t; j++) {
				const token_a = new state.Token("footnote_anchor", "", 0);
				token_a.meta = {
					id: i,
					subId: j,
					label: list$1[i].label
				};
				state.tokens.push(token_a);
			}
			if (lastParagraph) state.tokens.push(lastParagraph);
			state.tokens.push(new state.Token("footnote_close", "", -1));
		}
		state.tokens.push(new state.Token("footnote_block_close", "", -1));
	}
	md.block.ruler.before("reference", "footnote_def", footnote_def, { alt: ["paragraph", "reference"] });
	md.inline.ruler.after("image", "footnote_inline", footnote_inline);
	md.inline.ruler.after("footnote_inline", "footnote_ref", footnote_ref);
	md.core.ruler.after("inline", "footnote_tail", footnote_tail);
}

//#endregion
//#region ../../node_modules/.pnpm/markdown-it-ins@4.0.0/node_modules/markdown-it-ins/index.mjs
function ins_plugin(md) {
	function tokenize(state, silent) {
		const start = state.pos;
		const marker = state.src.charCodeAt(start);
		if (silent) return false;
		if (marker !== 43) return false;
		const scanned = state.scanDelims(state.pos, true);
		let len = scanned.length;
		const ch = String.fromCharCode(marker);
		if (len < 2) return false;
		if (len % 2) {
			const token = state.push("text", "", 0);
			token.content = ch;
			len--;
		}
		for (let i = 0; i < len; i += 2) {
			const token = state.push("text", "", 0);
			token.content = ch + ch;
			if (!scanned.can_open && !scanned.can_close) continue;
			state.delimiters.push({
				marker,
				length: 0,
				jump: i / 2,
				token: state.tokens.length - 1,
				end: -1,
				open: scanned.can_open,
				close: scanned.can_close
			});
		}
		state.pos += scanned.length;
		return true;
	}
	function postProcess$2(state, delimiters) {
		let token;
		const loneMarkers = [];
		const max = delimiters.length;
		for (let i = 0; i < max; i++) {
			const startDelim = delimiters[i];
			if (startDelim.marker !== 43) continue;
			if (startDelim.end === -1) continue;
			const endDelim = delimiters[startDelim.end];
			token = state.tokens[startDelim.token];
			token.type = "ins_open";
			token.tag = "ins";
			token.nesting = 1;
			token.markup = "++";
			token.content = "";
			token = state.tokens[endDelim.token];
			token.type = "ins_close";
			token.tag = "ins";
			token.nesting = -1;
			token.markup = "++";
			token.content = "";
			if (state.tokens[endDelim.token - 1].type === "text" && state.tokens[endDelim.token - 1].content === "+") loneMarkers.push(endDelim.token - 1);
		}
		while (loneMarkers.length) {
			const i = loneMarkers.pop();
			let j = i + 1;
			while (j < state.tokens.length && state.tokens[j].type === "ins_close") j++;
			j--;
			if (i !== j) {
				token = state.tokens[j];
				state.tokens[j] = state.tokens[i];
				state.tokens[i] = token;
			}
		}
	}
	md.inline.ruler.before("emphasis", "ins", tokenize);
	md.inline.ruler2.before("emphasis", "ins", function(state) {
		const tokens_meta = state.tokens_meta;
		const max = (state.tokens_meta || []).length;
		postProcess$2(state, state.delimiters);
		for (let curr = 0; curr < max; curr++) if (tokens_meta[curr] && tokens_meta[curr].delimiters) postProcess$2(state, tokens_meta[curr].delimiters);
	});
}

//#endregion
//#region ../../node_modules/.pnpm/markdown-it-mark@4.0.0/node_modules/markdown-it-mark/index.mjs
function ins_plugin$1(md) {
	function tokenize(state, silent) {
		const start = state.pos;
		const marker = state.src.charCodeAt(start);
		if (silent) return false;
		if (marker !== 61) return false;
		const scanned = state.scanDelims(state.pos, true);
		let len = scanned.length;
		const ch = String.fromCharCode(marker);
		if (len < 2) return false;
		if (len % 2) {
			const token = state.push("text", "", 0);
			token.content = ch;
			len--;
		}
		for (let i = 0; i < len; i += 2) {
			const token = state.push("text", "", 0);
			token.content = ch + ch;
			if (!scanned.can_open && !scanned.can_close) continue;
			state.delimiters.push({
				marker,
				length: 0,
				jump: i / 2,
				token: state.tokens.length - 1,
				end: -1,
				open: scanned.can_open,
				close: scanned.can_close
			});
		}
		state.pos += scanned.length;
		return true;
	}
	function postProcess$2(state, delimiters) {
		const loneMarkers = [];
		const max = delimiters.length;
		for (let i = 0; i < max; i++) {
			const startDelim = delimiters[i];
			if (startDelim.marker !== 61) continue;
			if (startDelim.end === -1) continue;
			const endDelim = delimiters[startDelim.end];
			const token_o = state.tokens[startDelim.token];
			token_o.type = "mark_open";
			token_o.tag = "mark";
			token_o.nesting = 1;
			token_o.markup = "==";
			token_o.content = "";
			const token_c = state.tokens[endDelim.token];
			token_c.type = "mark_close";
			token_c.tag = "mark";
			token_c.nesting = -1;
			token_c.markup = "==";
			token_c.content = "";
			if (state.tokens[endDelim.token - 1].type === "text" && state.tokens[endDelim.token - 1].content === "=") loneMarkers.push(endDelim.token - 1);
		}
		while (loneMarkers.length) {
			const i = loneMarkers.pop();
			let j = i + 1;
			while (j < state.tokens.length && state.tokens[j].type === "mark_close") j++;
			j--;
			if (i !== j) {
				const token = state.tokens[j];
				state.tokens[j] = state.tokens[i];
				state.tokens[i] = token;
			}
		}
	}
	md.inline.ruler.before("emphasis", "mark", tokenize);
	md.inline.ruler2.before("emphasis", "mark", function(state) {
		let curr;
		const tokens_meta = state.tokens_meta;
		const max = (state.tokens_meta || []).length;
		postProcess$2(state, state.delimiters);
		for (curr = 0; curr < max; curr++) if (tokens_meta[curr] && tokens_meta[curr].delimiters) postProcess$2(state, tokens_meta[curr].delimiters);
	});
}

//#endregion
//#region ../../node_modules/.pnpm/markdown-it-sub@2.0.0/node_modules/markdown-it-sub/index.mjs
const UNESCAPE_RE$1 = /\\([ \\!"#$%&'()*+,./:;<=>?@[\]^_`{|}~-])/g;
function subscript(state, silent) {
	const max = state.posMax;
	const start = state.pos;
	if (state.src.charCodeAt(start) !== 126) return false;
	if (silent) return false;
	if (start + 2 >= max) return false;
	state.pos = start + 1;
	let found = false;
	while (state.pos < max) {
		if (state.src.charCodeAt(state.pos) === 126) {
			found = true;
			break;
		}
		state.md.inline.skipToken(state);
	}
	if (!found || start + 1 === state.pos) {
		state.pos = start;
		return false;
	}
	const content = state.src.slice(start + 1, state.pos);
	if (content.match(/(^|[^\\])(\\\\)*\s/)) {
		state.pos = start;
		return false;
	}
	state.posMax = state.pos;
	state.pos = start + 1;
	const token_so = state.push("sub_open", "sub", 1);
	token_so.markup = "~";
	const token_t = state.push("text", "", 0);
	token_t.content = content.replace(UNESCAPE_RE$1, "$1");
	const token_sc = state.push("sub_close", "sub", -1);
	token_sc.markup = "~";
	state.pos = state.posMax + 1;
	state.posMax = max;
	return true;
}
function sub_plugin(md) {
	md.inline.ruler.after("emphasis", "sub", subscript);
}

//#endregion
//#region ../../node_modules/.pnpm/markdown-it-sup@2.0.0/node_modules/markdown-it-sup/index.mjs
const UNESCAPE_RE = /\\([ \\!"#$%&'()*+,./:;<=>?@[\]^_`{|}~-])/g;
function superscript(state, silent) {
	const max = state.posMax;
	const start = state.pos;
	if (state.src.charCodeAt(start) !== 94) return false;
	if (silent) return false;
	if (start + 2 >= max) return false;
	state.pos = start + 1;
	let found = false;
	while (state.pos < max) {
		if (state.src.charCodeAt(state.pos) === 94) {
			found = true;
			break;
		}
		state.md.inline.skipToken(state);
	}
	if (!found || start + 1 === state.pos) {
		state.pos = start;
		return false;
	}
	const content = state.src.slice(start + 1, state.pos);
	if (content.match(/(^|[^\\])(\\\\)*\s/)) {
		state.pos = start;
		return false;
	}
	state.posMax = state.pos;
	state.pos = start + 1;
	const token_so = state.push("sup_open", "sup", 1);
	token_so.markup = "^";
	const token_t = state.push("text", "", 0);
	token_t.content = content.replace(UNESCAPE_RE, "$1");
	const token_sc = state.push("sup_close", "sup", -1);
	token_sc.markup = "^";
	state.pos = state.posMax + 1;
	state.posMax = max;
	return true;
}
function sup_plugin(md) {
	md.inline.ruler.after("emphasis", "sup", superscript);
}

//#endregion
//#region ../../node_modules/.pnpm/markdown-it-task-checkbox@1.0.6/node_modules/markdown-it-task-checkbox/index.js
var require_markdown_it_task_checkbox = /* @__PURE__ */ __commonJS({ "../../node_modules/.pnpm/markdown-it-task-checkbox@1.0.6/node_modules/markdown-it-task-checkbox/index.js": ((exports, module) => {
	module.exports = function(md, options) {
		options = Object.assign({}, {
			disabled: true,
			divWrap: false,
			divClass: "checkbox",
			idPrefix: "cbx_",
			ulClass: "task-list",
			liClass: "task-list-item"
		}, options);
		md.core.ruler.after("inline", "github-task-lists", function(state) {
			var tokens = state.tokens;
			var lastId = 0;
			for (var i = 2; i < tokens.length; i++) if (isTodoItem(tokens, i)) {
				todoify(tokens[i], lastId, options, state.Token);
				lastId += 1;
				attrSet$1(tokens[i - 2], "class", options.liClass);
				attrSet$1(tokens[parentToken(tokens, i - 2)], "class", options.ulClass);
			}
		});
	};
	function attrSet$1(token, name, value) {
		var index = token.attrIndex(name);
		var attr = [name, value];
		if (index < 0) token.attrPush(attr);
		else token.attrs[index] = attr;
	}
	function parentToken(tokens, index) {
		var targetLevel = tokens[index].level - 1;
		for (var i = index - 1; i >= 0; i--) if (tokens[i].level === targetLevel) return i;
		return -1;
	}
	function isTodoItem(tokens, index) {
		return isInline(tokens[index]) && isParagraph(tokens[index - 1]) && isListItem(tokens[index - 2]) && startsWithTodoMarkdown(tokens[index]);
	}
	function todoify(token, lastId, options, TokenConstructor) {
		var id = options.idPrefix + lastId;
		token.children[0].content = token.children[0].content.slice(3);
		token.children.unshift(beginLabel(id, TokenConstructor));
		token.children.push(endLabel(TokenConstructor));
		token.children.unshift(makeCheckbox(token, id, options, TokenConstructor));
		if (options.divWrap) {
			token.children.unshift(beginWrap(options, TokenConstructor));
			token.children.push(endWrap(TokenConstructor));
		}
	}
	function makeCheckbox(token, id, options, TokenConstructor) {
		var checkbox = new TokenConstructor("checkbox_input", "input", 0);
		checkbox.attrs = [["type", "checkbox"], ["id", id]];
		if (/^\[[xX]\][ \u00A0]/.test(token.content) === true) checkbox.attrs.push(["checked", "true"]);
		if (options.disabled === true) checkbox.attrs.push(["disabled", "true"]);
		return checkbox;
	}
	function beginLabel(id, TokenConstructor) {
		var label = new TokenConstructor("label_open", "label", 1);
		label.attrs = [["for", id]];
		return label;
	}
	function endLabel(TokenConstructor) {
		return new TokenConstructor("label_close", "label", -1);
	}
	function beginWrap(options, TokenConstructor) {
		var token = new TokenConstructor("checkbox_open", "div", 0);
		token.attrs = [["class", options.divClass]];
		return token;
	}
	function endWrap(TokenConstructor) {
		return new TokenConstructor("checkbox_close", "div", -1);
	}
	function isInline(token) {
		return token.type === "inline";
	}
	function isParagraph(token) {
		return token.type === "paragraph_open";
	}
	function isListItem(token) {
		return token.type === "list_item_open";
	}
	function startsWithTodoMarkdown(token) {
		return /^\[[xX \u00A0]\][ \u00A0]/.test(token.content);
	}
}) });

//#endregion
//#region ../../node_modules/.pnpm/markdown-it-ts@0.0.3/node_modules/markdown-it-ts/dist/chunk-Bp6m_JJh.js
var import_markdown_it_task_checkbox = /* @__PURE__ */ __toESM(require_markdown_it_task_checkbox(), 1);
var __defProp = Object.defineProperty;
var __export = (all) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	return target;
};

//#endregion
//#region ../../node_modules/.pnpm/uc.micro@2.1.0/node_modules/uc.micro/properties/Any/regex.mjs
var regex_default = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

//#endregion
//#region ../../node_modules/.pnpm/uc.micro@2.1.0/node_modules/uc.micro/categories/Cc/regex.mjs
var regex_default$1 = /[\0-\x1F\x7F-\x9F]/;

//#endregion
//#region ../../node_modules/.pnpm/uc.micro@2.1.0/node_modules/uc.micro/categories/Cf/regex.mjs
var regex_default$4 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

//#endregion
//#region ../../node_modules/.pnpm/uc.micro@2.1.0/node_modules/uc.micro/categories/P/regex.mjs
var regex_default$3 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

//#endregion
//#region ../../node_modules/.pnpm/uc.micro@2.1.0/node_modules/uc.micro/categories/S/regex.mjs
var regex_default$5 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;

//#endregion
//#region ../../node_modules/.pnpm/uc.micro@2.1.0/node_modules/uc.micro/categories/Z/regex.mjs
var regex_default$2 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

//#endregion
//#region ../../node_modules/.pnpm/uc.micro@2.1.0/node_modules/uc.micro/index.mjs
var uc_exports = /* @__PURE__ */ __export$1({
	Any: () => regex_default,
	Cc: () => regex_default$1,
	Cf: () => regex_default$4,
	P: () => regex_default$3,
	S: () => regex_default$5,
	Z: () => regex_default$2
});

//#endregion
//#region ../../node_modules/.pnpm/linkify-it@5.0.0/node_modules/linkify-it/lib/re.mjs
function re_default(opts) {
	const re = {};
	opts = opts || {};
	re.src_Any = regex_default.source;
	re.src_Cc = regex_default$1.source;
	re.src_Z = regex_default$2.source;
	re.src_P = regex_default$3.source;
	re.src_ZPCc = [
		re.src_Z,
		re.src_P,
		re.src_Cc
	].join("|");
	re.src_ZCc = [re.src_Z, re.src_Cc].join("|");
	const text_separators = "[><｜]";
	re.src_pseudo_letter = "(?:(?!" + text_separators + "|" + re.src_ZPCc + ")" + re.src_Any + ")";
	re.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
	re.src_auth = "(?:(?:(?!" + re.src_ZCc + "|[@/\\[\\]()]).)+@)?";
	re.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?";
	re.src_host_terminator = "(?=$|" + text_separators + "|" + re.src_ZPCc + ")(?!" + (opts["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + re.src_ZPCc + "))";
	re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + "|[><｜]|[()[\\]{}.,\"'?!\\-;]).|\\[(?:(?!" + re.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + re.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + re.src_ZCc + "|[}]).)*\\}|\\\"(?:(?!" + re.src_ZCc + "|[\"]).)+\\\"|\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|\\'(?=" + re.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + re.src_ZCc + "|[.]|$)|" + (opts["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + ",(?!" + re.src_ZCc + "|$)|;(?!" + re.src_ZCc + "|$)|\\!+(?!" + re.src_ZCc + "|[!]|$)|\\?(?!" + re.src_ZCc + "|[?]|$))+|\\/)?";
	re.src_email_name = "[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\\"\\.a-zA-Z0-9_]*";
	re.src_xn = "xn--[a-z0-9\\-]{1,59}";
	re.src_domain_root = "(?:" + re.src_xn + "|" + re.src_pseudo_letter + "{1,63})";
	re.src_domain = "(?:" + re.src_xn + "|(?:" + re.src_pseudo_letter + ")|(?:" + re.src_pseudo_letter + "(?:-|" + re.src_pseudo_letter + "){0,61}" + re.src_pseudo_letter + "))";
	re.src_host = "(?:(?:(?:(?:" + re.src_domain + ")\\.)*" + re.src_domain + "))";
	re.tpl_host_fuzzy = "(?:" + re.src_ip4 + "|(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%)))";
	re.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))";
	re.src_host_strict = re.src_host + re.src_host_terminator;
	re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
	re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
	re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
	re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
	re.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + re.src_ZPCc + "|>|$))";
	re.tpl_email_fuzzy = "(^|" + text_separators + "|\"|\\(|" + re.src_ZCc + ")(" + re.src_email_name + "@" + re.tpl_host_fuzzy_strict + ")";
	re.tpl_link_fuzzy = "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + re.src_ZPCc + "))((?![$+<=>^`|｜])" + re.tpl_host_port_fuzzy_strict + re.src_path + ")";
	re.tpl_link_no_ip_fuzzy = "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + re.src_ZPCc + "))((?![$+<=>^`|｜])" + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ")";
	return re;
}

//#endregion
//#region ../../node_modules/.pnpm/linkify-it@5.0.0/node_modules/linkify-it/index.mjs
function assign$1(obj) {
	Array.prototype.slice.call(arguments, 1).forEach(function(source) {
		if (!source) return;
		Object.keys(source).forEach(function(key) {
			obj[key] = source[key];
		});
	});
	return obj;
}
function _class$1(obj) {
	return Object.prototype.toString.call(obj);
}
function isString$1(obj) {
	return _class$1(obj) === "[object String]";
}
function isObject(obj) {
	return _class$1(obj) === "[object Object]";
}
function isRegExp(obj) {
	return _class$1(obj) === "[object RegExp]";
}
function isFunction(obj) {
	return _class$1(obj) === "[object Function]";
}
function escapeRE$1(str) {
	return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
const defaultOptions = {
	fuzzyLink: true,
	fuzzyEmail: true,
	fuzzyIP: false
};
function isOptionsObj(obj) {
	return Object.keys(obj || {}).reduce(function(acc, k) {
		return acc || defaultOptions.hasOwnProperty(k);
	}, false);
}
const defaultSchemas = {
	"http:": { validate: function(text$1, pos, self) {
		const tail = text$1.slice(pos);
		if (!self.re.http) self.re.http = new RegExp("^\\/\\/" + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, "i");
		if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
		return 0;
	} },
	"https:": "http:",
	"ftp:": "http:",
	"//": { validate: function(text$1, pos, self) {
		const tail = text$1.slice(pos);
		if (!self.re.no_http) self.re.no_http = new RegExp("^" + self.re.src_auth + "(?:localhost|(?:(?:" + self.re.src_domain + ")\\.)+" + self.re.src_domain_root + ")" + self.re.src_port + self.re.src_host_terminator + self.re.src_path, "i");
		if (self.re.no_http.test(tail)) {
			if (pos >= 3 && text$1[pos - 3] === ":") return 0;
			if (pos >= 3 && text$1[pos - 3] === "/") return 0;
			return tail.match(self.re.no_http)[0].length;
		}
		return 0;
	} },
	"mailto:": { validate: function(text$1, pos, self) {
		const tail = text$1.slice(pos);
		if (!self.re.mailto) self.re.mailto = new RegExp("^" + self.re.src_email_name + "@" + self.re.src_host_strict, "i");
		if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
		return 0;
	} }
};
const tlds_2ch_src_re = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
const tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
function resetScanCache(self) {
	self.__index__ = -1;
	self.__text_cache__ = "";
}
function createValidator(re) {
	return function(text$1, pos) {
		const tail = text$1.slice(pos);
		if (re.test(tail)) return tail.match(re)[0].length;
		return 0;
	};
}
function createNormalizer() {
	return function(match, self) {
		self.normalize(match);
	};
}
function compile(self) {
	const re = self.re = re_default(self.__opts__);
	const tlds = self.__tlds__.slice();
	self.onCompile();
	if (!self.__tlds_replaced__) tlds.push(tlds_2ch_src_re);
	tlds.push(re.src_xn);
	re.src_tlds = tlds.join("|");
	function untpl(tpl) {
		return tpl.replace("%TLDS%", re.src_tlds);
	}
	re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), "i");
	re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), "i");
	re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), "i");
	re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), "i");
	const aliases = [];
	self.__compiled__ = {};
	function schemaError(name, val) {
		throw new Error("(LinkifyIt) Invalid schema \"" + name + "\": " + val);
	}
	Object.keys(self.__schemas__).forEach(function(name) {
		const val = self.__schemas__[name];
		if (val === null) return;
		const compiled = {
			validate: null,
			link: null
		};
		self.__compiled__[name] = compiled;
		if (isObject(val)) {
			if (isRegExp(val.validate)) compiled.validate = createValidator(val.validate);
			else if (isFunction(val.validate)) compiled.validate = val.validate;
			else schemaError(name, val);
			if (isFunction(val.normalize)) compiled.normalize = val.normalize;
			else if (!val.normalize) compiled.normalize = createNormalizer();
			else schemaError(name, val);
			return;
		}
		if (isString$1(val)) {
			aliases.push(name);
			return;
		}
		schemaError(name, val);
	});
	aliases.forEach(function(alias) {
		if (!self.__compiled__[self.__schemas__[alias]]) return;
		self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
		self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
	});
	self.__compiled__[""] = {
		validate: null,
		normalize: createNormalizer()
	};
	const slist = Object.keys(self.__compiled__).filter(function(name) {
		return name.length > 0 && self.__compiled__[name];
	}).map(escapeRE$1).join("|");
	self.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + re.src_ZPCc + "))(" + slist + ")", "i");
	self.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + re.src_ZPCc + "))(" + slist + ")", "ig");
	self.re.schema_at_start = RegExp("^" + self.re.schema_search.source, "i");
	self.re.pretest = RegExp("(" + self.re.schema_test.source + ")|(" + self.re.host_fuzzy_test.source + ")|@", "i");
	resetScanCache(self);
}
/**
* class Match
*
* Match result. Single element of array, returned by [[LinkifyIt#match]]
**/
function Match(self, shift) {
	const start = self.__index__;
	const end = self.__last_index__;
	const text$1 = self.__text_cache__.slice(start, end);
	/**
	* Match#schema -> String
	*
	* Prefix (protocol) for matched string.
	**/
	this.schema = self.__schema__.toLowerCase();
	/**
	* Match#index -> Number
	*
	* First position of matched string.
	**/
	this.index = start + shift;
	/**
	* Match#lastIndex -> Number
	*
	* Next position after matched string.
	**/
	this.lastIndex = end + shift;
	/**
	* Match#raw -> String
	*
	* Matched string.
	**/
	this.raw = text$1;
	/**
	* Match#text -> String
	*
	* Notmalized text of matched string.
	**/
	this.text = text$1;
	/**
	* Match#url -> String
	*
	* Normalized url of matched string.
	**/
	this.url = text$1;
}
function createMatch(self, shift) {
	const match = new Match(self, shift);
	self.__compiled__[match.schema].normalize(match, self);
	return match;
}
/**
* class LinkifyIt
**/
/**
* new LinkifyIt(schemas, options)
* - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
* - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
*
* Creates new linkifier instance with optional additional schemas.
* Can be called without `new` keyword for convenience.
*
* By default understands:
*
* - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
* - "fuzzy" links and emails (example.com, foo@bar.com).
*
* `schemas` is an object, where each key/value describes protocol/rule:
*
* - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
*   for example). `linkify-it` makes shure that prefix is not preceeded with
*   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
* - __value__ - rule to check tail after link prefix
*   - _String_ - just alias to existing rule
*   - _Object_
*     - _validate_ - validator function (should return matched length on success),
*       or `RegExp`.
*     - _normalize_ - optional function to normalize text & url of matched result
*       (for example, for @twitter mentions).
*
* `options`:
*
* - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
* - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
*   like version numbers. Default `false`.
* - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
*
**/
function LinkifyIt(schemas, options) {
	if (!(this instanceof LinkifyIt)) return new LinkifyIt(schemas, options);
	if (!options) {
		if (isOptionsObj(schemas)) {
			options = schemas;
			schemas = {};
		}
	}
	this.__opts__ = assign$1({}, defaultOptions, options);
	this.__index__ = -1;
	this.__last_index__ = -1;
	this.__schema__ = "";
	this.__text_cache__ = "";
	this.__schemas__ = assign$1({}, defaultSchemas, schemas);
	this.__compiled__ = {};
	this.__tlds__ = tlds_default;
	this.__tlds_replaced__ = false;
	this.re = {};
	compile(this);
}
/** chainable
* LinkifyIt#add(schema, definition)
* - schema (String): rule name (fixed pattern prefix)
* - definition (String|RegExp|Object): schema definition
*
* Add new rule definition. See constructor description for details.
**/
LinkifyIt.prototype.add = function add(schema, definition) {
	this.__schemas__[schema] = definition;
	compile(this);
	return this;
};
/** chainable
* LinkifyIt#set(options)
* - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
*
* Set recognition options for links without schema.
**/
LinkifyIt.prototype.set = function set(options) {
	this.__opts__ = assign$1(this.__opts__, options);
	return this;
};
/**
* LinkifyIt#test(text) -> Boolean
*
* Searches linkifiable pattern and returns `true` on success or `false` on fail.
**/
LinkifyIt.prototype.test = function test(text$1) {
	this.__text_cache__ = text$1;
	this.__index__ = -1;
	if (!text$1.length) return false;
	let m, ml, me, len, shift, next, re, tld_pos, at_pos;
	if (this.re.schema_test.test(text$1)) {
		re = this.re.schema_search;
		re.lastIndex = 0;
		while ((m = re.exec(text$1)) !== null) {
			len = this.testSchemaAt(text$1, m[2], re.lastIndex);
			if (len) {
				this.__schema__ = m[2];
				this.__index__ = m.index + m[1].length;
				this.__last_index__ = m.index + m[0].length + len;
				break;
			}
		}
	}
	if (this.__opts__.fuzzyLink && this.__compiled__["http:"]) {
		tld_pos = text$1.search(this.re.host_fuzzy_test);
		if (tld_pos >= 0) {
			if (this.__index__ < 0 || tld_pos < this.__index__) {
				if ((ml = text$1.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
					shift = ml.index + ml[1].length;
					if (this.__index__ < 0 || shift < this.__index__) {
						this.__schema__ = "";
						this.__index__ = shift;
						this.__last_index__ = ml.index + ml[0].length;
					}
				}
			}
		}
	}
	if (this.__opts__.fuzzyEmail && this.__compiled__["mailto:"]) {
		at_pos = text$1.indexOf("@");
		if (at_pos >= 0) {
			if ((me = text$1.match(this.re.email_fuzzy)) !== null) {
				shift = me.index + me[1].length;
				next = me.index + me[0].length;
				if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
					this.__schema__ = "mailto:";
					this.__index__ = shift;
					this.__last_index__ = next;
				}
			}
		}
	}
	return this.__index__ >= 0;
};
/**
* LinkifyIt#pretest(text) -> Boolean
*
* Very quick check, that can give false positives. Returns true if link MAY BE
* can exists. Can be used for speed optimization, when you need to check that
* link NOT exists.
**/
LinkifyIt.prototype.pretest = function pretest(text$1) {
	return this.re.pretest.test(text$1);
};
/**
* LinkifyIt#testSchemaAt(text, name, position) -> Number
* - text (String): text to scan
* - name (String): rule (schema) name
* - position (Number): text offset to check from
*
* Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
* at given position. Returns length of found pattern (0 on fail).
**/
LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text$1, schema, pos) {
	if (!this.__compiled__[schema.toLowerCase()]) return 0;
	return this.__compiled__[schema.toLowerCase()].validate(text$1, pos, this);
};
/**
* LinkifyIt#match(text) -> Array|null
*
* Returns array of found link descriptions or `null` on fail. We strongly
* recommend to use [[LinkifyIt#test]] first, for best speed.
*
* ##### Result match description
*
* - __schema__ - link schema, can be empty for fuzzy links, or `//` for
*   protocol-neutral  links.
* - __index__ - offset of matched text
* - __lastIndex__ - index of next char after mathch end
* - __raw__ - matched text
* - __text__ - normalized text
* - __url__ - link, generated from matched text
**/
LinkifyIt.prototype.match = function match(text$1) {
	const result = [];
	let shift = 0;
	if (this.__index__ >= 0 && this.__text_cache__ === text$1) {
		result.push(createMatch(this, shift));
		shift = this.__last_index__;
	}
	let tail = shift ? text$1.slice(shift) : text$1;
	while (this.test(tail)) {
		result.push(createMatch(this, shift));
		tail = tail.slice(this.__last_index__);
		shift += this.__last_index__;
	}
	if (result.length) return result;
	return null;
};
/**
* LinkifyIt#matchAtStart(text) -> Match|null
*
* Returns fully-formed (not fuzzy) link if it starts at the beginning
* of the string, and null otherwise.
**/
LinkifyIt.prototype.matchAtStart = function matchAtStart(text$1) {
	this.__text_cache__ = text$1;
	this.__index__ = -1;
	if (!text$1.length) return null;
	const m = this.re.schema_at_start.exec(text$1);
	if (!m) return null;
	const len = this.testSchemaAt(text$1, m[2], m[0].length);
	if (!len) return null;
	this.__schema__ = m[2];
	this.__index__ = m.index + m[1].length;
	this.__last_index__ = m.index + m[0].length + len;
	return createMatch(this, 0);
};
/** chainable
* LinkifyIt#tlds(list [, keepOld]) -> this
* - list (Array): list of tlds
* - keepOld (Boolean): merge with current list if `true` (`false` by default)
*
* Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
* to avoid false positives. By default this algorythm used:
*
* - hostname with any 2-letter root zones are ok.
* - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
*   are ok.
* - encoded (`xn--...`) root zones are ok.
*
* If list is replaced, then exact match for 2-chars root zones will be checked.
**/
LinkifyIt.prototype.tlds = function tlds(list$1, keepOld) {
	list$1 = Array.isArray(list$1) ? list$1 : [list$1];
	if (!keepOld) {
		this.__tlds__ = list$1.slice();
		this.__tlds_replaced__ = true;
		compile(this);
		return this;
	}
	this.__tlds__ = this.__tlds__.concat(list$1).sort().filter(function(el, idx, arr) {
		return el !== arr[idx - 1];
	}).reverse();
	compile(this);
	return this;
};
/**
* LinkifyIt#normalize(match)
*
* Default normalizer (if schema does not define it's own).
**/
LinkifyIt.prototype.normalize = function normalize$1(match) {
	if (!match.schema) match.url = "http://" + match.url;
	if (match.schema === "mailto:" && !/^mailto:/i.test(match.url)) match.url = "mailto:" + match.url;
};
/**
* LinkifyIt#onCompile()
*
* Override to modify basic RegExp-s.
**/
LinkifyIt.prototype.onCompile = function onCompile() {};
var linkify_it_default = LinkifyIt;

//#endregion
//#region ../../node_modules/.pnpm/entities@4.5.0/node_modules/entities/lib/esm/generated/decode-data-html.js
var decode_data_html_default = new Uint16Array("ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻\"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻\xA0ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌".split("").map((c) => c.charCodeAt(0)));

//#endregion
//#region ../../node_modules/.pnpm/entities@4.5.0/node_modules/entities/lib/esm/generated/decode-data-xml.js
var decode_data_xml_default = new Uint16Array("Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((c) => c.charCodeAt(0)));

//#endregion
//#region ../../node_modules/.pnpm/entities@4.5.0/node_modules/entities/lib/esm/decode_codepoint.js
var _a;
const decodeMap = new Map([
	[0, 65533],
	[128, 8364],
	[130, 8218],
	[131, 402],
	[132, 8222],
	[133, 8230],
	[134, 8224],
	[135, 8225],
	[136, 710],
	[137, 8240],
	[138, 352],
	[139, 8249],
	[140, 338],
	[142, 381],
	[145, 8216],
	[146, 8217],
	[147, 8220],
	[148, 8221],
	[149, 8226],
	[150, 8211],
	[151, 8212],
	[152, 732],
	[153, 8482],
	[154, 353],
	[155, 8250],
	[156, 339],
	[158, 382],
	[159, 376]
]);
/**
* Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
*/
const fromCodePoint$2 = (_a = String.fromCodePoint) !== null && _a !== void 0 ? _a : function(codePoint) {
	let output = "";
	if (codePoint > 65535) {
		codePoint -= 65536;
		output += String.fromCharCode(codePoint >>> 10 & 1023 | 55296);
		codePoint = 56320 | codePoint & 1023;
	}
	output += String.fromCharCode(codePoint);
	return output;
};
/**
* Replace the given code point with a replacement character if it is a
* surrogate or is outside the valid range. Otherwise return the code
* point unchanged.
*/
function replaceCodePoint(codePoint) {
	var _a$1;
	if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) return 65533;
	return (_a$1 = decodeMap.get(codePoint)) !== null && _a$1 !== void 0 ? _a$1 : codePoint;
}

//#endregion
//#region ../../node_modules/.pnpm/entities@4.5.0/node_modules/entities/lib/esm/decode.js
var CharCodes;
(function(CharCodes$1) {
	CharCodes$1[CharCodes$1["NUM"] = 35] = "NUM";
	CharCodes$1[CharCodes$1["SEMI"] = 59] = "SEMI";
	CharCodes$1[CharCodes$1["EQUALS"] = 61] = "EQUALS";
	CharCodes$1[CharCodes$1["ZERO"] = 48] = "ZERO";
	CharCodes$1[CharCodes$1["NINE"] = 57] = "NINE";
	CharCodes$1[CharCodes$1["LOWER_A"] = 97] = "LOWER_A";
	CharCodes$1[CharCodes$1["LOWER_F"] = 102] = "LOWER_F";
	CharCodes$1[CharCodes$1["LOWER_X"] = 120] = "LOWER_X";
	CharCodes$1[CharCodes$1["LOWER_Z"] = 122] = "LOWER_Z";
	CharCodes$1[CharCodes$1["UPPER_A"] = 65] = "UPPER_A";
	CharCodes$1[CharCodes$1["UPPER_F"] = 70] = "UPPER_F";
	CharCodes$1[CharCodes$1["UPPER_Z"] = 90] = "UPPER_Z";
})(CharCodes || (CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */
const TO_LOWER_BIT = 32;
var BinTrieFlags;
(function(BinTrieFlags$1) {
	BinTrieFlags$1[BinTrieFlags$1["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
	BinTrieFlags$1[BinTrieFlags$1["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
	BinTrieFlags$1[BinTrieFlags$1["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})(BinTrieFlags || (BinTrieFlags = {}));
function isNumber(code$1) {
	return code$1 >= CharCodes.ZERO && code$1 <= CharCodes.NINE;
}
function isHexadecimalCharacter(code$1) {
	return code$1 >= CharCodes.UPPER_A && code$1 <= CharCodes.UPPER_F || code$1 >= CharCodes.LOWER_A && code$1 <= CharCodes.LOWER_F;
}
function isAsciiAlphaNumeric(code$1) {
	return code$1 >= CharCodes.UPPER_A && code$1 <= CharCodes.UPPER_Z || code$1 >= CharCodes.LOWER_A && code$1 <= CharCodes.LOWER_Z || isNumber(code$1);
}
/**
* Checks if the given character is a valid end character for an entity in an attribute.
*
* Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
* See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
*/
function isEntityInAttributeInvalidEnd(code$1) {
	return code$1 === CharCodes.EQUALS || isAsciiAlphaNumeric(code$1);
}
var EntityDecoderState;
(function(EntityDecoderState$1) {
	EntityDecoderState$1[EntityDecoderState$1["EntityStart"] = 0] = "EntityStart";
	EntityDecoderState$1[EntityDecoderState$1["NumericStart"] = 1] = "NumericStart";
	EntityDecoderState$1[EntityDecoderState$1["NumericDecimal"] = 2] = "NumericDecimal";
	EntityDecoderState$1[EntityDecoderState$1["NumericHex"] = 3] = "NumericHex";
	EntityDecoderState$1[EntityDecoderState$1["NamedEntity"] = 4] = "NamedEntity";
})(EntityDecoderState || (EntityDecoderState = {}));
var DecodingMode;
(function(DecodingMode$1) {
	/** Entities in text nodes that can end with any character. */
	DecodingMode$1[DecodingMode$1["Legacy"] = 0] = "Legacy";
	/** Only allow entities terminated with a semicolon. */
	DecodingMode$1[DecodingMode$1["Strict"] = 1] = "Strict";
	/** Entities in attributes have limitations on ending characters. */
	DecodingMode$1[DecodingMode$1["Attribute"] = 2] = "Attribute";
})(DecodingMode || (DecodingMode = {}));
/**
* Token decoder with support of writing partial entities.
*/
var EntityDecoder = class {
	constructor(decodeTree, emitCodePoint, errors$1) {
		this.decodeTree = decodeTree;
		this.emitCodePoint = emitCodePoint;
		this.errors = errors$1;
		/** The current state of the decoder. */
		this.state = EntityDecoderState.EntityStart;
		/** Characters that were consumed while parsing an entity. */
		this.consumed = 1;
		/**
		* The result of the entity.
		*
		* Either the result index of a numeric entity, or the codepoint of a
		* numeric entity.
		*/
		this.result = 0;
		/** The current index in the decode tree. */
		this.treeIndex = 0;
		/** The number of characters that were consumed in excess. */
		this.excess = 1;
		/** The mode in which the decoder is operating. */
		this.decodeMode = DecodingMode.Strict;
	}
	/** Resets the instance to make it reusable. */
	startEntity(decodeMode) {
		this.decodeMode = decodeMode;
		this.state = EntityDecoderState.EntityStart;
		this.result = 0;
		this.treeIndex = 0;
		this.excess = 1;
		this.consumed = 1;
	}
	/**
	* Write an entity to the decoder. This can be called multiple times with partial entities.
	* If the entity is incomplete, the decoder will return -1.
	*
	* Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
	* entity is incomplete, and resume when the next string is written.
	*
	* @param string The string containing the entity (or a continuation of the entity).
	* @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
	* @returns The number of characters that were consumed, or -1 if the entity is incomplete.
	*/
	write(str, offset) {
		switch (this.state) {
			case EntityDecoderState.EntityStart:
				if (str.charCodeAt(offset) === CharCodes.NUM) {
					this.state = EntityDecoderState.NumericStart;
					this.consumed += 1;
					return this.stateNumericStart(str, offset + 1);
				}
				this.state = EntityDecoderState.NamedEntity;
				return this.stateNamedEntity(str, offset);
			case EntityDecoderState.NumericStart: return this.stateNumericStart(str, offset);
			case EntityDecoderState.NumericDecimal: return this.stateNumericDecimal(str, offset);
			case EntityDecoderState.NumericHex: return this.stateNumericHex(str, offset);
			case EntityDecoderState.NamedEntity: return this.stateNamedEntity(str, offset);
		}
	}
	/**
	* Switches between the numeric decimal and hexadecimal states.
	*
	* Equivalent to the `Numeric character reference state` in the HTML spec.
	*
	* @param str The string containing the entity (or a continuation of the entity).
	* @param offset The current offset.
	* @returns The number of characters that were consumed, or -1 if the entity is incomplete.
	*/
	stateNumericStart(str, offset) {
		if (offset >= str.length) return -1;
		if ((str.charCodeAt(offset) | TO_LOWER_BIT) === CharCodes.LOWER_X) {
			this.state = EntityDecoderState.NumericHex;
			this.consumed += 1;
			return this.stateNumericHex(str, offset + 1);
		}
		this.state = EntityDecoderState.NumericDecimal;
		return this.stateNumericDecimal(str, offset);
	}
	addToNumericResult(str, start, end, base$1) {
		if (start !== end) {
			const digitCount = end - start;
			this.result = this.result * Math.pow(base$1, digitCount) + parseInt(str.substr(start, digitCount), base$1);
			this.consumed += digitCount;
		}
	}
	/**
	* Parses a hexadecimal numeric entity.
	*
	* Equivalent to the `Hexademical character reference state` in the HTML spec.
	*
	* @param str The string containing the entity (or a continuation of the entity).
	* @param offset The current offset.
	* @returns The number of characters that were consumed, or -1 if the entity is incomplete.
	*/
	stateNumericHex(str, offset) {
		const startIdx = offset;
		while (offset < str.length) {
			const char = str.charCodeAt(offset);
			if (isNumber(char) || isHexadecimalCharacter(char)) offset += 1;
			else {
				this.addToNumericResult(str, startIdx, offset, 16);
				return this.emitNumericEntity(char, 3);
			}
		}
		this.addToNumericResult(str, startIdx, offset, 16);
		return -1;
	}
	/**
	* Parses a decimal numeric entity.
	*
	* Equivalent to the `Decimal character reference state` in the HTML spec.
	*
	* @param str The string containing the entity (or a continuation of the entity).
	* @param offset The current offset.
	* @returns The number of characters that were consumed, or -1 if the entity is incomplete.
	*/
	stateNumericDecimal(str, offset) {
		const startIdx = offset;
		while (offset < str.length) {
			const char = str.charCodeAt(offset);
			if (isNumber(char)) offset += 1;
			else {
				this.addToNumericResult(str, startIdx, offset, 10);
				return this.emitNumericEntity(char, 2);
			}
		}
		this.addToNumericResult(str, startIdx, offset, 10);
		return -1;
	}
	/**
	* Validate and emit a numeric entity.
	*
	* Implements the logic from the `Hexademical character reference start
	* state` and `Numeric character reference end state` in the HTML spec.
	*
	* @param lastCp The last code point of the entity. Used to see if the
	*               entity was terminated with a semicolon.
	* @param expectedLength The minimum number of characters that should be
	*                       consumed. Used to validate that at least one digit
	*                       was consumed.
	* @returns The number of characters that were consumed.
	*/
	emitNumericEntity(lastCp, expectedLength) {
		var _a$1;
		if (this.consumed <= expectedLength) {
			(_a$1 = this.errors) === null || _a$1 === void 0 || _a$1.absenceOfDigitsInNumericCharacterReference(this.consumed);
			return 0;
		}
		if (lastCp === CharCodes.SEMI) this.consumed += 1;
		else if (this.decodeMode === DecodingMode.Strict) return 0;
		this.emitCodePoint(replaceCodePoint(this.result), this.consumed);
		if (this.errors) {
			if (lastCp !== CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
			this.errors.validateNumericCharacterReference(this.result);
		}
		return this.consumed;
	}
	/**
	* Parses a named entity.
	*
	* Equivalent to the `Named character reference state` in the HTML spec.
	*
	* @param str The string containing the entity (or a continuation of the entity).
	* @param offset The current offset.
	* @returns The number of characters that were consumed, or -1 if the entity is incomplete.
	*/
	stateNamedEntity(str, offset) {
		const { decodeTree } = this;
		let current = decodeTree[this.treeIndex];
		let valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
		for (; offset < str.length; offset++, this.excess++) {
			const char = str.charCodeAt(offset);
			this.treeIndex = determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
			if (this.treeIndex < 0) return this.result === 0 || this.decodeMode === DecodingMode.Attribute && (valueLength === 0 || isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
			current = decodeTree[this.treeIndex];
			valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
			if (valueLength !== 0) {
				if (char === CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
				if (this.decodeMode !== DecodingMode.Strict) {
					this.result = this.treeIndex;
					this.consumed += this.excess;
					this.excess = 0;
				}
			}
		}
		return -1;
	}
	/**
	* Emit a named entity that was not terminated with a semicolon.
	*
	* @returns The number of characters consumed.
	*/
	emitNotTerminatedNamedEntity() {
		var _a$1;
		const { result, decodeTree } = this;
		const valueLength = (decodeTree[result] & BinTrieFlags.VALUE_LENGTH) >> 14;
		this.emitNamedEntityData(result, valueLength, this.consumed);
		(_a$1 = this.errors) === null || _a$1 === void 0 || _a$1.missingSemicolonAfterCharacterReference();
		return this.consumed;
	}
	/**
	* Emit a named entity.
	*
	* @param result The index of the entity in the decode tree.
	* @param valueLength The number of bytes in the entity.
	* @param consumed The number of characters consumed.
	*
	* @returns The number of characters consumed.
	*/
	emitNamedEntityData(result, valueLength, consumed) {
		const { decodeTree } = this;
		this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
		if (valueLength === 3) this.emitCodePoint(decodeTree[result + 2], consumed);
		return consumed;
	}
	/**
	* Signal to the parser that the end of the input was reached.
	*
	* Remaining data will be emitted and relevant errors will be produced.
	*
	* @returns The number of characters consumed.
	*/
	end() {
		var _a$1;
		switch (this.state) {
			case EntityDecoderState.NamedEntity: return this.result !== 0 && (this.decodeMode !== DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
			case EntityDecoderState.NumericDecimal: return this.emitNumericEntity(0, 2);
			case EntityDecoderState.NumericHex: return this.emitNumericEntity(0, 3);
			case EntityDecoderState.NumericStart:
				(_a$1 = this.errors) === null || _a$1 === void 0 || _a$1.absenceOfDigitsInNumericCharacterReference(this.consumed);
				return 0;
			case EntityDecoderState.EntityStart: return 0;
		}
	}
};
/**
* Creates a function that decodes entities in a string.
*
* @param decodeTree The decode tree.
* @returns A function that decodes entities in a string.
*/
function getDecoder(decodeTree) {
	let ret = "";
	const decoder = new EntityDecoder(decodeTree, (str) => ret += fromCodePoint$2(str));
	return function decodeWithTrie(str, decodeMode) {
		let lastIndex = 0;
		let offset = 0;
		while ((offset = str.indexOf("&", offset)) >= 0) {
			ret += str.slice(lastIndex, offset);
			decoder.startEntity(decodeMode);
			const len = decoder.write(str, offset + 1);
			if (len < 0) {
				lastIndex = offset + decoder.end();
				break;
			}
			lastIndex = offset + len;
			offset = len === 0 ? lastIndex + 1 : lastIndex;
		}
		const result = ret + str.slice(lastIndex);
		ret = "";
		return result;
	};
}
/**
* Determines the branch of the current node that is taken given the current
* character. This function is used to traverse the trie.
*
* @param decodeTree The trie.
* @param current The current node.
* @param nodeIdx The index right after the current node and its value.
* @param char The current character.
* @returns The index of the next node, or -1 if no branch is taken.
*/
function determineBranch(decodeTree, current, nodeIdx, char) {
	const branchCount = (current & BinTrieFlags.BRANCH_LENGTH) >> 7;
	const jumpOffset = current & BinTrieFlags.JUMP_TABLE;
	if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
	if (jumpOffset) {
		const value = char - jumpOffset;
		return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
	}
	let lo = nodeIdx;
	let hi = lo + branchCount - 1;
	while (lo <= hi) {
		const mid = lo + hi >>> 1;
		const midVal = decodeTree[mid];
		if (midVal < char) lo = mid + 1;
		else if (midVal > char) hi = mid - 1;
		else return decodeTree[mid + branchCount];
	}
	return -1;
}
const htmlDecoder = getDecoder(decode_data_html_default);
const xmlDecoder = getDecoder(decode_data_xml_default);
/**
* Decodes an HTML string.
*
* @param str The string to decode.
* @param mode The decoding mode.
* @returns The decoded string.
*/
function decodeHTML(str, mode = DecodingMode.Legacy) {
	return htmlDecoder(str, mode);
}

//#endregion
//#region ../../node_modules/.pnpm/mdurl@2.0.0/node_modules/mdurl/lib/decode.mjs
const decodeCache = {};
function getDecodeCache(exclude) {
	let cache = decodeCache[exclude];
	if (cache) return cache;
	cache = decodeCache[exclude] = [];
	for (let i = 0; i < 128; i++) {
		const ch = String.fromCharCode(i);
		cache.push(ch);
	}
	for (let i = 0; i < exclude.length; i++) {
		const ch = exclude.charCodeAt(i);
		cache[ch] = "%" + ("0" + ch.toString(16).toUpperCase()).slice(-2);
	}
	return cache;
}
function decode$1(string, exclude) {
	if (typeof exclude !== "string") exclude = decode$1.defaultChars;
	const cache = getDecodeCache(exclude);
	return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
		let result = "";
		for (let i = 0, l = seq.length; i < l; i += 3) {
			const b1 = parseInt(seq.slice(i + 1, i + 3), 16);
			if (b1 < 128) {
				result += cache[b1];
				continue;
			}
			if ((b1 & 224) === 192 && i + 3 < l) {
				const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
				if ((b2 & 192) === 128) {
					const chr = b1 << 6 & 1984 | b2 & 63;
					if (chr < 128) result += "��";
					else result += String.fromCharCode(chr);
					i += 3;
					continue;
				}
			}
			if ((b1 & 240) === 224 && i + 6 < l) {
				const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
				const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
				if ((b2 & 192) === 128 && (b3 & 192) === 128) {
					const chr = b1 << 12 & 61440 | b2 << 6 & 4032 | b3 & 63;
					if (chr < 2048 || chr >= 55296 && chr <= 57343) result += "���";
					else result += String.fromCharCode(chr);
					i += 6;
					continue;
				}
			}
			if ((b1 & 248) === 240 && i + 9 < l) {
				const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
				const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
				const b4 = parseInt(seq.slice(i + 10, i + 12), 16);
				if ((b2 & 192) === 128 && (b3 & 192) === 128 && (b4 & 192) === 128) {
					let chr = b1 << 18 & 1835008 | b2 << 12 & 258048 | b3 << 6 & 4032 | b4 & 63;
					if (chr < 65536 || chr > 1114111) result += "����";
					else {
						chr -= 65536;
						result += String.fromCharCode(55296 + (chr >> 10), 56320 + (chr & 1023));
					}
					i += 9;
					continue;
				}
			}
			result += "�";
		}
		return result;
	});
}
decode$1.defaultChars = ";/?:@&=+$,#";
decode$1.componentChars = "";
var decode_default = decode$1;

//#endregion
//#region ../../node_modules/.pnpm/mdurl@2.0.0/node_modules/mdurl/lib/encode.mjs
const encodeCache = {};
function getEncodeCache(exclude) {
	let cache = encodeCache[exclude];
	if (cache) return cache;
	cache = encodeCache[exclude] = [];
	for (let i = 0; i < 128; i++) {
		const ch = String.fromCharCode(i);
		if (/^[0-9a-z]$/i.test(ch)) cache.push(ch);
		else cache.push("%" + ("0" + i.toString(16).toUpperCase()).slice(-2));
	}
	for (let i = 0; i < exclude.length; i++) cache[exclude.charCodeAt(i)] = exclude[i];
	return cache;
}
function encode$1(string, exclude, keepEscaped) {
	if (typeof exclude !== "string") {
		keepEscaped = exclude;
		exclude = encode$1.defaultChars;
	}
	if (typeof keepEscaped === "undefined") keepEscaped = true;
	const cache = getEncodeCache(exclude);
	let result = "";
	for (let i = 0, l = string.length; i < l; i++) {
		const code$1 = string.charCodeAt(i);
		if (keepEscaped && code$1 === 37 && i + 2 < l) {
			if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
				result += string.slice(i, i + 3);
				i += 2;
				continue;
			}
		}
		if (code$1 < 128) {
			result += cache[code$1];
			continue;
		}
		if (code$1 >= 55296 && code$1 <= 57343) {
			if (code$1 >= 55296 && code$1 <= 56319 && i + 1 < l) {
				const nextCode = string.charCodeAt(i + 1);
				if (nextCode >= 56320 && nextCode <= 57343) {
					result += encodeURIComponent(string[i] + string[i + 1]);
					i++;
					continue;
				}
			}
			result += "%EF%BF%BD";
			continue;
		}
		result += encodeURIComponent(string[i]);
	}
	return result;
}
encode$1.defaultChars = ";/?:@&=+$,-_.!~*'()#";
encode$1.componentChars = "-_.!~*'()";
var encode_default = encode$1;

//#endregion
//#region ../../node_modules/.pnpm/mdurl@2.0.0/node_modules/mdurl/lib/format.mjs
function format(url) {
	let result = "";
	result += url.protocol || "";
	result += url.slashes ? "//" : "";
	result += url.auth ? url.auth + "@" : "";
	if (url.hostname && url.hostname.indexOf(":") !== -1) result += "[" + url.hostname + "]";
	else result += url.hostname || "";
	result += url.port ? ":" + url.port : "";
	result += url.pathname || "";
	result += url.search || "";
	result += url.hash || "";
	return result;
}

//#endregion
//#region ../../node_modules/.pnpm/mdurl@2.0.0/node_modules/mdurl/lib/parse.mjs
function Url() {
	this.protocol = null;
	this.slashes = null;
	this.auth = null;
	this.port = null;
	this.hostname = null;
	this.hash = null;
	this.search = null;
	this.pathname = null;
}
const protocolPattern = /^([a-z0-9.+-]+:)/i;
const portPattern = /:[0-9]*$/;
const simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/;
const unwise = [
	"{",
	"}",
	"|",
	"\\",
	"^",
	"`"
].concat([
	"<",
	">",
	"\"",
	"`",
	" ",
	"\r",
	"\n",
	"	"
]);
const autoEscape = ["'"].concat(unwise);
const nonHostChars = [
	"%",
	"/",
	"?",
	";",
	"#"
].concat(autoEscape);
const hostEndingChars = [
	"/",
	"?",
	"#"
];
const hostnameMaxLen = 255;
const hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/;
const hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/;
const hostlessProtocol = {
	javascript: true,
	"javascript:": true
};
const slashedProtocol = {
	http: true,
	https: true,
	ftp: true,
	gopher: true,
	file: true,
	"http:": true,
	"https:": true,
	"ftp:": true,
	"gopher:": true,
	"file:": true
};
function urlParse(url, slashesDenoteHost) {
	if (url && url instanceof Url) return url;
	const u = new Url();
	u.parse(url, slashesDenoteHost);
	return u;
}
Url.prototype.parse = function(url, slashesDenoteHost) {
	let lowerProto, hec, slashes;
	let rest = url;
	rest = rest.trim();
	if (!slashesDenoteHost && url.split("#").length === 1) {
		const simplePath = simplePathPattern.exec(rest);
		if (simplePath) {
			this.pathname = simplePath[1];
			if (simplePath[2]) this.search = simplePath[2];
			return this;
		}
	}
	let proto = protocolPattern.exec(rest);
	if (proto) {
		proto = proto[0];
		lowerProto = proto.toLowerCase();
		this.protocol = proto;
		rest = rest.substr(proto.length);
	}
	if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
		slashes = rest.substr(0, 2) === "//";
		if (slashes && !(proto && hostlessProtocol[proto])) {
			rest = rest.substr(2);
			this.slashes = true;
		}
	}
	if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
		let hostEnd = -1;
		for (let i = 0; i < hostEndingChars.length; i++) {
			hec = rest.indexOf(hostEndingChars[i]);
			if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
		}
		let auth, atSign;
		if (hostEnd === -1) atSign = rest.lastIndexOf("@");
		else atSign = rest.lastIndexOf("@", hostEnd);
		if (atSign !== -1) {
			auth = rest.slice(0, atSign);
			rest = rest.slice(atSign + 1);
			this.auth = auth;
		}
		hostEnd = -1;
		for (let i = 0; i < nonHostChars.length; i++) {
			hec = rest.indexOf(nonHostChars[i]);
			if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
		}
		if (hostEnd === -1) hostEnd = rest.length;
		if (rest[hostEnd - 1] === ":") hostEnd--;
		const host = rest.slice(0, hostEnd);
		rest = rest.slice(hostEnd);
		this.parseHost(host);
		this.hostname = this.hostname || "";
		const ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
		if (!ipv6Hostname) {
			const hostparts = this.hostname.split(/\./);
			for (let i = 0, l = hostparts.length; i < l; i++) {
				const part = hostparts[i];
				if (!part) continue;
				if (!part.match(hostnamePartPattern)) {
					let newpart = "";
					for (let j = 0, k = part.length; j < k; j++) if (part.charCodeAt(j) > 127) newpart += "x";
					else newpart += part[j];
					if (!newpart.match(hostnamePartPattern)) {
						const validParts = hostparts.slice(0, i);
						const notHost = hostparts.slice(i + 1);
						const bit = part.match(hostnamePartStart);
						if (bit) {
							validParts.push(bit[1]);
							notHost.unshift(bit[2]);
						}
						if (notHost.length) rest = notHost.join(".") + rest;
						this.hostname = validParts.join(".");
						break;
					}
				}
			}
		}
		if (this.hostname.length > hostnameMaxLen) this.hostname = "";
		if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	}
	const hash = rest.indexOf("#");
	if (hash !== -1) {
		this.hash = rest.substr(hash);
		rest = rest.slice(0, hash);
	}
	const qm = rest.indexOf("?");
	if (qm !== -1) {
		this.search = rest.substr(qm);
		rest = rest.slice(0, qm);
	}
	if (rest) this.pathname = rest;
	if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "";
	return this;
};
Url.prototype.parseHost = function(host) {
	let port = portPattern.exec(host);
	if (port) {
		port = port[0];
		if (port !== ":") this.port = port.substr(1);
		host = host.substr(0, host.length - port.length);
	}
	if (host) this.hostname = host;
};
var parse_default = urlParse;

//#endregion
//#region ../../node_modules/.pnpm/mdurl@2.0.0/node_modules/mdurl/index.mjs
var mdurl_exports = /* @__PURE__ */ __export$1({
	decode: () => decode_default,
	encode: () => encode_default,
	format: () => format,
	parse: () => parse_default
});

//#endregion
//#region ../../node_modules/.pnpm/punycode.js@2.3.1/node_modules/punycode.js/punycode.js
var require_punycode = /* @__PURE__ */ __commonJS({ "../../node_modules/.pnpm/punycode.js@2.3.1/node_modules/punycode.js/punycode.js": ((exports, module) => {
	/** Highest positive signed 32-bit float value */
	const maxInt = 2147483647;
	/** Bootstring parameters */
	const base = 36;
	const tMin = 1;
	const tMax = 26;
	const skew = 38;
	const damp = 700;
	const initialBias = 72;
	const initialN = 128;
	const delimiter = "-";
	/** Regular expressions */
	const regexPunycode = /^xn--/;
	const regexNonASCII = /[^\0-\x7F]/;
	const regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g;
	/** Error messages */
	const errors = {
		"overflow": "Overflow: input needs wider integers to process",
		"not-basic": "Illegal input >= 0x80 (not a basic code point)",
		"invalid-input": "Invalid input"
	};
	/** Convenience shortcuts */
	const baseMinusTMin = base - tMin;
	const floor = Math.floor;
	const stringFromCharCode = String.fromCharCode;
	/**
	* A generic error utility function.
	* @private
	* @param {String} type The error type.
	* @returns {Error} Throws a `RangeError` with the applicable error message.
	*/
	function error(type) {
		throw new RangeError(errors[type]);
	}
	/**
	* A generic `Array#map` utility function.
	* @private
	* @param {Array} array The array to iterate over.
	* @param {Function} callback The function that gets called for every array
	* item.
	* @returns {Array} A new array of values returned by the callback function.
	*/
	function map(array, callback) {
		const result = [];
		let length = array.length;
		while (length--) result[length] = callback(array[length]);
		return result;
	}
	/**
	* A simple `Array#map`-like wrapper to work with domain name strings or email
	* addresses.
	* @private
	* @param {String} domain The domain name or email address.
	* @param {Function} callback The function that gets called for every
	* character.
	* @returns {String} A new string of characters returned by the callback
	* function.
	*/
	function mapDomain(domain, callback) {
		const parts = domain.split("@");
		let result = "";
		if (parts.length > 1) {
			result = parts[0] + "@";
			domain = parts[1];
		}
		domain = domain.replace(regexSeparators, ".");
		const encoded = map(domain.split("."), callback).join(".");
		return result + encoded;
	}
	/**
	* Creates an array containing the numeric code points of each Unicode
	* character in the string. While JavaScript uses UCS-2 internally,
	* this function will convert a pair of surrogate halves (each of which
	* UCS-2 exposes as separate characters) into a single code point,
	* matching UTF-16.
	* @see `punycode.ucs2.encode`
	* @see <https://mathiasbynens.be/notes/javascript-encoding>
	* @memberOf punycode.ucs2
	* @name decode
	* @param {String} string The Unicode input string (UCS-2).
	* @returns {Array} The new array of code points.
	*/
	function ucs2decode(string) {
		const output = [];
		let counter = 0;
		const length = string.length;
		while (counter < length) {
			const value = string.charCodeAt(counter++);
			if (value >= 55296 && value <= 56319 && counter < length) {
				const extra = string.charCodeAt(counter++);
				if ((extra & 64512) == 56320) output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
				else {
					output.push(value);
					counter--;
				}
			} else output.push(value);
		}
		return output;
	}
	/**
	* Creates a string based on an array of numeric code points.
	* @see `punycode.ucs2.decode`
	* @memberOf punycode.ucs2
	* @name encode
	* @param {Array} codePoints The array of numeric code points.
	* @returns {String} The new Unicode string (UCS-2).
	*/
	const ucs2encode = (codePoints) => String.fromCodePoint(...codePoints);
	/**
	* Converts a basic code point into a digit/integer.
	* @see `digitToBasic()`
	* @private
	* @param {Number} codePoint The basic numeric code point value.
	* @returns {Number} The numeric value of a basic code point (for use in
	* representing integers) in the range `0` to `base - 1`, or `base` if
	* the code point does not represent a value.
	*/
	const basicToDigit = function(codePoint) {
		if (codePoint >= 48 && codePoint < 58) return 26 + (codePoint - 48);
		if (codePoint >= 65 && codePoint < 91) return codePoint - 65;
		if (codePoint >= 97 && codePoint < 123) return codePoint - 97;
		return base;
	};
	/**
	* Converts a digit/integer into a basic code point.
	* @see `basicToDigit()`
	* @private
	* @param {Number} digit The numeric value of a basic code point.
	* @returns {Number} The basic code point whose value (when used for
	* representing integers) is `digit`, which needs to be in the range
	* `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	* used; else, the lowercase form is used. The behavior is undefined
	* if `flag` is non-zero and `digit` has no uppercase form.
	*/
	const digitToBasic = function(digit, flag) {
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	};
	/**
	* Bias adaptation function as per section 3.4 of RFC 3492.
	* https://tools.ietf.org/html/rfc3492#section-3.4
	* @private
	*/
	const adapt = function(delta, numPoints, firstTime) {
		let k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (; delta > baseMinusTMin * tMax >> 1; k += base) delta = floor(delta / baseMinusTMin);
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	};
	/**
	* Converts a Punycode string of ASCII-only symbols to a string of Unicode
	* symbols.
	* @memberOf punycode
	* @param {String} input The Punycode string of ASCII-only symbols.
	* @returns {String} The resulting string of Unicode symbols.
	*/
	const decode = function(input) {
		const output = [];
		const inputLength = input.length;
		let i = 0;
		let n = initialN;
		let bias = initialBias;
		let basic = input.lastIndexOf(delimiter);
		if (basic < 0) basic = 0;
		for (let j = 0; j < basic; ++j) {
			if (input.charCodeAt(j) >= 128) error("not-basic");
			output.push(input.charCodeAt(j));
		}
		for (let index = basic > 0 ? basic + 1 : 0; index < inputLength;) {
			const oldi = i;
			for (let w = 1, k = base;; k += base) {
				if (index >= inputLength) error("invalid-input");
				const digit = basicToDigit(input.charCodeAt(index++));
				if (digit >= base) error("invalid-input");
				if (digit > floor((maxInt - i) / w)) error("overflow");
				i += digit * w;
				const t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
				if (digit < t) break;
				const baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) error("overflow");
				w *= baseMinusT;
			}
			const out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);
			if (floor(i / out) > maxInt - n) error("overflow");
			n += floor(i / out);
			i %= out;
			output.splice(i++, 0, n);
		}
		return String.fromCodePoint(...output);
	};
	/**
	* Converts a string of Unicode symbols (e.g. a domain name label) to a
	* Punycode string of ASCII-only symbols.
	* @memberOf punycode
	* @param {String} input The string of Unicode symbols.
	* @returns {String} The resulting Punycode string of ASCII-only symbols.
	*/
	const encode = function(input) {
		const output = [];
		input = ucs2decode(input);
		const inputLength = input.length;
		let n = initialN;
		let delta = 0;
		let bias = initialBias;
		for (const currentValue of input) if (currentValue < 128) output.push(stringFromCharCode(currentValue));
		const basicLength = output.length;
		let handledCPCount = basicLength;
		if (basicLength) output.push(delimiter);
		while (handledCPCount < inputLength) {
			let m = maxInt;
			for (const currentValue of input) if (currentValue >= n && currentValue < m) m = currentValue;
			const handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
			delta += (m - n) * handledCPCountPlusOne;
			n = m;
			for (const currentValue of input) {
				if (currentValue < n && ++delta > maxInt) error("overflow");
				if (currentValue === n) {
					let q = delta;
					for (let k = base;; k += base) {
						const t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
						if (q < t) break;
						const qMinusT = q - t;
						const baseMinusT = base - t;
						output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
						q = floor(qMinusT / baseMinusT);
					}
					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
					delta = 0;
					++handledCPCount;
				}
			}
			++delta;
			++n;
		}
		return output.join("");
	};
	/**
	* Converts a Punycode string representing a domain name or an email address
	* to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	* it doesn't matter if you call it on a string that has already been
	* converted to Unicode.
	* @memberOf punycode
	* @param {String} input The Punycoded domain name or email address to
	* convert to Unicode.
	* @returns {String} The Unicode representation of the given Punycode
	* string.
	*/
	const toUnicode = function(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
		});
	};
	/**
	* Converts a Unicode string representing a domain name or an email address to
	* Punycode. Only the non-ASCII parts of the domain name will be converted,
	* i.e. it doesn't matter if you call it with a domain that's already in
	* ASCII.
	* @memberOf punycode
	* @param {String} input The domain name or email address to convert, as a
	* Unicode string.
	* @returns {String} The Punycode representation of the given domain name or
	* email address.
	*/
	const toASCII = function(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
		});
	};
	/** Define the public API */
	const punycode$1 = {
		"version": "2.3.1",
		"ucs2": {
			"decode": ucs2decode,
			"encode": ucs2encode
		},
		"decode": decode,
		"encode": encode,
		"toASCII": toASCII,
		"toUnicode": toUnicode
	};
	module.exports = punycode$1;
}) });

//#endregion
//#region ../../node_modules/.pnpm/markdown-it-ts@0.0.3/node_modules/markdown-it-ts/dist/index.js
var import_punycode = /* @__PURE__ */ __toESM(require_punycode(), 1);
var utils_exports = /* @__PURE__ */ __export({
	arrayReplaceAt: () => arrayReplaceAt,
	assign: () => assign,
	countLines: () => countLines,
	escapeHtml: () => escapeHtml$1,
	escapeRE: () => escapeRE,
	fromCodePoint: () => fromCodePoint$1,
	has: () => has,
	isMdAsciiPunct: () => isMdAsciiPunct,
	isPunctChar: () => isPunctChar,
	isSpace: () => isSpace$7,
	isString: () => isString,
	isValidEntityCode: () => isValidEntityCode$1,
	isWhiteSpace: () => isWhiteSpace,
	lib: () => lib,
	mdurl: () => mdurl_exports,
	normalizeReference: () => normalizeReference$1,
	ucmicro: () => uc_exports,
	unescapeAll: () => unescapeAll$1,
	unescapeMd: () => unescapeMd
});
function _class(obj) {
	return Object.prototype.toString.call(obj);
}
function isString(obj) {
	return _class(obj) === "[object String]";
}
const _hasOwnProperty = Object.prototype.hasOwnProperty;
function has(object, key) {
	return _hasOwnProperty.call(object, key);
}
function assign(obj, ...sources) {
	sources.forEach((source) => {
		if (!source) return;
		if (typeof source !== "object") throw new TypeError(`${String(source)}must be object`);
		Object.keys(source).forEach((key) => {
			obj[key] = source[key];
		});
	});
	return obj;
}
function isSpace$7(code$1) {
	return code$1 === 9 || code$1 === 32;
}
function isWhiteSpace(code$1) {
	if (code$1 >= 8192 && code$1 <= 8202) return true;
	switch (code$1) {
		case 9:
		case 10:
		case 11:
		case 12:
		case 13:
		case 32:
		case 160:
		case 5760:
		case 8239:
		case 8287:
		case 12288: return true;
	}
	return false;
}
function isPunctChar(ch) {
	return regex_default$3.test(ch) || regex_default$5.test(ch);
}
function isMdAsciiPunct(ch) {
	switch (ch) {
		case 33:
		case 34:
		case 35:
		case 36:
		case 37:
		case 38:
		case 39:
		case 40:
		case 41:
		case 42:
		case 43:
		case 44:
		case 45:
		case 46:
		case 47:
		case 58:
		case 59:
		case 60:
		case 61:
		case 62:
		case 63:
		case 64:
		case 91:
		case 92:
		case 93:
		case 94:
		case 95:
		case 96:
		case 123:
		case 124:
		case 125:
		case 126: return true;
		default: return false;
	}
}
function normalizeReference$1(str) {
	str = str.trim().replace(/\s+/g, " ");
	if ("ẞ".toLowerCase() === "Ṿ") str = str.replace(/ẞ/g, "ß");
	return str.toLowerCase().toUpperCase();
}
function arrayReplaceAt(src, pos, newElements) {
	return [
		...src.slice(0, pos),
		...newElements,
		...src.slice(pos + 1)
	];
}
function isValidEntityCode$1(c) {
	if (c >= 55296 && c <= 57343) return false;
	if (c >= 64976 && c <= 65007) return false;
	if ((c & 65535) === 65535 || (c & 65535) === 65534) return false;
	if (c >= 0 && c <= 8) return false;
	if (c === 11) return false;
	if (c >= 14 && c <= 31) return false;
	if (c >= 127 && c <= 159) return false;
	if (c > 1114111) return false;
	return true;
}
function fromCodePoint$1(c) {
	if (c > 65535) {
		c -= 65536;
		const surrogate1 = 55296 + (c >> 10);
		const surrogate2 = 56320 + (c & 1023);
		return String.fromCharCode(surrogate1, surrogate2);
	}
	return String.fromCharCode(c);
}
const UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-\./:;<=>?@[\\\]^_`{|}~])/g;
const UNESCAPE_ALL_RE$1 = new RegExp(`${UNESCAPE_MD_RE.source}|${/&([a-z#][a-z0-9]{1,31});/gi.source}`, "gi");
const DIGITAL_ENTITY_TEST_RE$1 = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function replaceEntityPattern(match, name) {
	if (name.charCodeAt(0) === 35 && DIGITAL_ENTITY_TEST_RE$1.test(name)) {
		const code$1 = name[1].toLowerCase() === "x" ? Number.parseInt(name.slice(2), 16) : Number.parseInt(name.slice(1), 10);
		if (isValidEntityCode$1(code$1)) return fromCodePoint$1(code$1);
		return match;
	}
	const decoded = decodeHTML(match);
	if (decoded !== match) return decoded;
	return match;
}
function unescapeMd(str) {
	if (!str.includes("\\")) return str;
	return str.replace(UNESCAPE_MD_RE, "$1");
}
function unescapeAll$1(str) {
	if (!str.includes("\\") && !str.includes("&")) return str;
	return str.replace(UNESCAPE_ALL_RE$1, (match, escaped, entity$1) => {
		if (escaped) return escaped;
		return replaceEntityPattern(match, entity$1);
	});
}
const HTML_ESCAPE_TEST_RE$1 = /[&<>"]/;
const HTML_ESCAPE_REPLACE_RE$1 = /[&<>"]/g;
const HTML_REPLACEMENTS$1 = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;"
};
function replaceUnsafeChar$1(ch) {
	return HTML_REPLACEMENTS$1[ch];
}
function escapeHtml$1(str) {
	if (HTML_ESCAPE_TEST_RE$1.test(str)) return str.replace(HTML_ESCAPE_REPLACE_RE$1, replaceUnsafeChar$1);
	return str;
}
const REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function escapeRE(str) {
	return str.replace(REGEXP_ESCAPE_RE, "\\$&");
}
const lib = {
	mdurl: mdurl_exports,
	ucmicro: uc_exports
};
function countLines(input) {
	if (input.length === 0) return 0;
	let count = 0;
	let pos = -1;
	while ((pos = input.indexOf("\n", pos + 1)) !== -1) count++;
	return count;
}
/**
* Parse link destination: returns { ok, pos, str }
*/
function parseLinkDestination(str, start, max) {
	let code$1;
	let pos = start;
	const result = {
		ok: false,
		pos: 0,
		str: ""
	};
	if (str.charCodeAt(pos) === 60) {
		pos++;
		while (pos < max) {
			code$1 = str.charCodeAt(pos);
			if (code$1 === 10) return result;
			if (code$1 === 60) return result;
			if (code$1 === 62) {
				result.pos = pos + 1;
				result.str = str.slice(start + 1, pos);
				result.ok = true;
				return result;
			}
			if (code$1 === 92 && pos + 1 < max) {
				pos += 2;
				continue;
			}
			pos++;
		}
		return result;
	}
	let level = 0;
	while (pos < max) {
		code$1 = str.charCodeAt(pos);
		if (code$1 === 32) break;
		if (code$1 < 32 || code$1 === 127) break;
		if (code$1 === 92 && pos + 1 < max) {
			if (str.charCodeAt(pos + 1) === 32) break;
			pos += 2;
			continue;
		}
		if (code$1 === 40) {
			level++;
			if (level > 32) return result;
		}
		if (code$1 === 41) {
			if (level === 0) break;
			level--;
		}
		pos++;
	}
	if (start === pos) return result;
	if (level !== 0) return result;
	result.str = str.slice(start, pos);
	result.pos = pos;
	result.ok = true;
	return result;
}
var parse_link_destination_default = parseLinkDestination;
/**
* Parse link label: returns the end position of label or -1 if not found
* Assumes first character ([) already matches
*/
function parseLinkLabel(state, start, disableNested) {
	let level = 1;
	let found = false;
	let marker;
	let prevPos;
	const max = state.posMax;
	const oldPos = state.pos;
	state.pos = start + 1;
	while (state.pos < max) {
		marker = state.src.charCodeAt(state.pos);
		if (marker === 93) {
			level--;
			if (level === 0) {
				found = true;
				break;
			}
		}
		prevPos = state.pos;
		state.md.inline.skipToken(state);
		if (marker === 91) {
			if (prevPos === state.pos - 1) level++;
			else if (disableNested) {
				state.pos = oldPos;
				return -1;
			}
		}
	}
	let labelEnd = -1;
	if (found) labelEnd = state.pos;
	state.pos = oldPos;
	return labelEnd;
}
var parse_link_label_default = parseLinkLabel;
/**
* Parse link title: returns { ok, can_continue, pos, str, marker }
*/
function parseLinkTitle(str, start, max, prev_state) {
	let code$1;
	let pos = start;
	const state = {
		ok: false,
		can_continue: false,
		pos: 0,
		str: "",
		marker: 0
	};
	if (prev_state) {
		state.str = prev_state.str;
		state.marker = prev_state.marker;
	} else {
		if (pos >= max) return state;
		let marker = str.charCodeAt(pos);
		if (marker !== 34 && marker !== 39 && marker !== 40) return state;
		start++;
		pos++;
		if (marker === 40) marker = 41;
		state.marker = marker;
	}
	while (pos < max) {
		code$1 = str.charCodeAt(pos);
		if (code$1 === state.marker) {
			state.pos = pos + 1;
			state.str += str.slice(start, pos);
			state.ok = true;
			return state;
		} else if (code$1 === 40 && state.marker === 41) return state;
		else if (code$1 === 92 && pos + 1 < max) pos++;
		pos++;
	}
	state.can_continue = true;
	state.str += str.slice(start, pos);
	return state;
}
var parse_link_title_default = parseLinkTitle;
function attrIndex(token, name) {
	if (!token.attrs) return -1;
	for (let i = 0; i < token.attrs.length; i++) if (token.attrs[i][0] === name) return i;
	return -1;
}
function attrPush(token, attrData) {
	if (!token.attrs) token.attrs = [];
	token.attrs.push(attrData);
}
function attrSet(token, name, value) {
	const idx = attrIndex(token, name);
	const attrData = [name, value];
	if (idx < 0) attrPush(token, attrData);
	else token.attrs[idx] = attrData;
}
function attrGet(token, name) {
	const idx = attrIndex(token, name);
	if (idx >= 0) return token.attrs[idx][1];
	return null;
}
function attrJoin(token, name, value) {
	const idx = attrIndex(token, name);
	if (idx < 0) attrPush(token, [name, value]);
	else token.attrs[idx][1] = `${token.attrs[idx][1]} ${value}`;
}
var helpers_exports = /* @__PURE__ */ __export({
	attrGet: () => attrGet,
	attrIndex: () => attrIndex,
	attrJoin: () => attrJoin,
	attrPush: () => attrPush,
	attrSet: () => attrSet,
	parseLinkDestination: () => parseLinkDestination,
	parseLinkLabel: () => parseLinkLabel,
	parseLinkTitle: () => parseLinkTitle
});
const BAD_PROTO_RE = /^(?:vbscript|javascript|file|data):/;
const GOOD_DATA_RE = /^data:image\/(?:gif|png|jpeg|webp);/;
const RECODE_HOSTNAME_FOR = [
	"http:",
	"https:",
	"mailto:"
];
/**
* Validate URL to prevent XSS attacks.
* This validator can prohibit more than really needed to prevent XSS.
* It's a tradeoff to keep code simple and to be secure by default.
*/
function validateLink(url) {
	const str = url.trim().toLowerCase();
	return BAD_PROTO_RE.test(str) ? GOOD_DATA_RE.test(str) : true;
}
/**
* Normalize link URL by encoding hostname to ASCII (punycode)
*/
function normalizeLink(url) {
	const parsed = parse_default(url, true);
	if (parsed.hostname) {
		if (!parsed.protocol || RECODE_HOSTNAME_FOR.includes(parsed.protocol)) try {
			parsed.hostname = import_punycode.default.toASCII(parsed.hostname);
		} catch {}
	}
	return encode_default(format(parsed));
}
/**
* Normalize link text by decoding hostname from punycode to Unicode
*/
function normalizeLinkText(url) {
	const parsed = parse_default(url, true);
	if (parsed.hostname) {
		if (!parsed.protocol || RECODE_HOSTNAME_FOR.includes(parsed.protocol)) try {
			parsed.hostname = import_punycode.default.toUnicode(parsed.hostname);
		} catch {}
	}
	return decode_default(format(parsed), `${decode_default.defaultChars}%`);
}
/**
* class Token
*
* Create new token and fill passed properties.
*/
var Token = class {
	/**
	* Token#type -> String
	*
	* Type of the token (string, e.g. "paragraph_open")
	*/
	type;
	/**
	* Token#tag -> String
	*
	* html tag name, e.g. "p"
	*/
	tag;
	/**
	* Token#attrs -> Array
	*
	* Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
	*/
	attrs;
	/**
	* Token#map -> Array
	*
	* Source map info. Format: `[ line_begin, line_end ]`
	*/
	map;
	/**
	* Token#nesting -> Number
	*
	* Level change (number in {-1, 0, 1} set), where:
	*
	* -  `1` means the tag is opening
	* -  `0` means the tag is self-closing
	* - `-1` means the tag is closing
	*/
	nesting;
	/**
	* Token#level -> Number
	*
	* nesting level, the same as `state.level`
	*/
	level;
	/**
	* Token#children -> Array
	*
	* An array of child nodes (inline and img tokens)
	*/
	children;
	/**
	* Token#content -> String
	*
	* In a case of self-closing tag (code, html, fence, etc.),
	* it has contents of this tag.
	*/
	content;
	/**
	* Token#markup -> String
	*
	* '*' or '_' for emphasis, fence string for fence, etc.
	*/
	markup;
	/**
	* Token#info -> String
	*
	* Additional information:
	*
	* - Info string for "fence" tokens
	* - The value "auto" for autolink "link_open" and "link_close" tokens
	* - The string value of the item marker for ordered-list "list_item_open" tokens
	*/
	info;
	/**
	* Token#meta -> Object
	*
	* A place for plugins to store an arbitrary data
	*/
	meta;
	/**
	* Token#block -> Boolean
	*
	* True for block-level tokens, false for inline tokens.
	* Used in renderer to calculate line breaks
	*/
	block;
	/**
	* Token#hidden -> Boolean
	*
	* If it's true, ignore this element when rendering. Used for tight lists
	* to hide paragraphs.
	*/
	hidden;
	constructor(type, tag, nesting) {
		this.type = type;
		this.tag = tag;
		this.attrs = null;
		this.map = null;
		this.nesting = nesting;
		this.level = 0;
		this.children = null;
		this.content = "";
		this.markup = "";
		this.info = "";
		this.meta = null;
		this.block = false;
		this.hidden = false;
	}
	/**
	* Token.attrIndex(name) -> Number
	*
	* Search attribute index by name.
	*/
	attrIndex(name) {
		if (!this.attrs) return -1;
		const attrs = this.attrs;
		for (let i = 0, len = attrs.length; i < len; i++) if (attrs[i][0] === name) return i;
		return -1;
	}
	/**
	* Token.attrPush(attrData)
	*
	* Add `[ name, value ]` attribute to list. Init attrs if necessary
	*/
	attrPush(attrData) {
		if (this.attrs) this.attrs.push(attrData);
		else this.attrs = [attrData];
	}
	/**
	* Token.attrSet(name, value)
	*
	* Set `name` attribute to `value`. Override old value if exists.
	*/
	attrSet(name, value) {
		const idx = this.attrIndex(name);
		const attrData = [name, value];
		if (idx < 0) this.attrPush(attrData);
		else this.attrs[idx] = attrData;
	}
	/**
	* Token.attrGet(name)
	*
	* Get the value of attribute `name`, or null if it does not exist.
	*/
	attrGet(name) {
		const idx = this.attrIndex(name);
		let value = null;
		if (idx >= 0) value = this.attrs[idx][1];
		return value;
	}
	/**
	* Token.attrJoin(name, value)
	*
	* Join value to existing attribute via space. Or create new attribute if not
	* exists. Useful to operate with token classes.
	*/
	attrJoin(name, value) {
		const idx = this.attrIndex(name);
		if (idx < 0) this.attrPush([name, value]);
		else this.attrs[idx][1] = `${this.attrs[idx][1]} ${value}`;
	}
};
/**
* Core rule: block
* Runs block-level parser on the input.
*/
function block(state) {
	if (state.inlineMode) {
		const token = new Token("inline", "", 0);
		token.content = state.src;
		token.map = [0, 1];
		token.children = [];
		token.level = 0;
		state.tokens.push(token);
	} else if (state.md && state.md.block) state.md.block.parse(state.src, state.md, state.env, state.tokens);
}
/**
* Core rule: inline
* Iterates through tokens and runs inline parser on 'inline' type tokens.
*/
function inline(state) {
	const tokens = state.tokens;
	for (let i = 0, l = tokens.length; i < l; i++) {
		const tok = tokens[i];
		if (tok.type === "inline" && state.md) {
			if (!tok.children) tok.children = [];
			state.md.inline.parse(tok.content, state.md, state.env, tok.children);
		}
	}
}
function isLinkOpen$1(str) {
	return /^<a[>\s]/i.test(str);
}
function isLinkClose$1(str) {
	return /^<\/a\s*>/i.test(str);
}
function linkify(state) {
	const blockTokens = state.tokens;
	if (!state.md?.options?.linkify) return;
	for (let j = 0; j < blockTokens.length; j++) {
		const blockToken = blockTokens[j];
		if (blockToken.type !== "inline" || !state.md.linkify.pretest(blockToken.content)) continue;
		let tokens = blockToken.children || [];
		let htmlLinkLevel = 0;
		for (let i = tokens.length - 1; i >= 0; i--) {
			const currentToken = tokens[i];
			if (currentToken.type === "link_close") {
				i--;
				while (i >= 0 && tokens[i].level !== currentToken.level && tokens[i].type !== "link_open") i--;
				continue;
			}
			if (currentToken.type === "html_inline") {
				if (isLinkOpen$1(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
				if (isLinkClose$1(currentToken.content)) htmlLinkLevel++;
			}
			if (htmlLinkLevel > 0) continue;
			if (currentToken.type !== "text" || !state.md.linkify.test(currentToken.content)) continue;
			const text$1 = currentToken.content;
			let links = state.md.linkify.match(text$1) || [];
			if (links.length === 0) continue;
			const nodes = [];
			let level = currentToken.level;
			let lastPos = 0;
			if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === "text_special") links = links.slice(1);
			for (let ln = 0; ln < links.length; ln++) {
				const link$1 = links[ln];
				const fullUrl = state.md.normalizeLink(link$1.url);
				if (!state.md.validateLink(fullUrl)) continue;
				let urlText = link$1.text;
				if (!link$1.schema) urlText = state.md.normalizeLinkText(`http://${urlText}`).replace(/^http:\/\//, "");
				else if (link$1.schema === "mailto:" && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText(`mailto:${urlText}`).replace(/^mailto:/, "");
				else urlText = state.md.normalizeLinkText(urlText);
				const pos = link$1.index;
				if (pos > lastPos) {
					const textToken$1 = new Token("text", "", 0);
					textToken$1.content = text$1.slice(lastPos, pos);
					textToken$1.level = level;
					nodes.push(textToken$1);
				}
				const tokenOpen = new Token("link_open", "a", 1);
				tokenOpen.attrs = [["href", fullUrl]];
				tokenOpen.level = level++;
				tokenOpen.markup = "linkify";
				tokenOpen.info = "auto";
				nodes.push(tokenOpen);
				const tokenText = new Token("text", "", 0);
				tokenText.content = urlText;
				tokenText.level = level;
				nodes.push(tokenText);
				const tokenClose = new Token("link_close", "a", -1);
				tokenClose.level = --level;
				tokenClose.markup = "linkify";
				tokenClose.info = "auto";
				nodes.push(tokenClose);
				lastPos = link$1.lastIndex;
			}
			if (lastPos === 0) continue;
			if (lastPos < text$1.length) {
				const textToken$1 = new Token("text", "", 0);
				textToken$1.content = text$1.slice(lastPos);
				textToken$1.level = level;
				nodes.push(textToken$1);
			}
			blockToken.children = tokens = arrayReplaceAt(tokens, i, nodes);
		}
	}
}
const NEWLINES_RE = /\r\n?|\n/g;
const NULL_RE = /\0/g;
function normalize(state) {
	if (!state || typeof state.src !== "string") return;
	let str = state.src.replace(NEWLINES_RE, "\n");
	str = str.replace(NULL_RE, "�");
	state.src = str;
}
const RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
const SCOPED_ABBR_TEST_RE = /\((?:c|tm|r)\)/i;
const SCOPED_ABBR_RE = /\((c|tm|r)\)/gi;
const SCOPED_ABBR = {
	c: "©",
	r: "®",
	tm: "™"
};
function replaceFn(_match, name) {
	return SCOPED_ABBR[name.toLowerCase()];
}
function replace_scoped(inlineTokens) {
	let inside_autolink = 0;
	for (let i = inlineTokens.length - 1; i >= 0; i--) {
		const token = inlineTokens[i];
		if (token.type === "text" && !inside_autolink) token.content = token.content.replace(SCOPED_ABBR_RE, replaceFn);
		if (token.type === "link_open" && token.info === "auto") inside_autolink--;
		if (token.type === "link_close" && token.info === "auto") inside_autolink++;
	}
}
function replace_rare(inlineTokens) {
	let inside_autolink = 0;
	for (let i = inlineTokens.length - 1; i >= 0; i--) {
		const token = inlineTokens[i];
		if (token.type === "text" && !inside_autolink) {
			if (RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/gm, "$1—").replace(/(^|\s)--(?=\s|$)/gm, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/gm, "$1–");
		}
		if (token.type === "link_open" && token.info === "auto") inside_autolink--;
		if (token.type === "link_close" && token.info === "auto") inside_autolink++;
	}
}
function replacements(state) {
	if (!state.md?.options?.typographer) return;
	for (let blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {
		const blk = state.tokens[blkIdx];
		if (blk.type !== "inline") continue;
		const blkContent = blk.content || (Array.isArray(blk.children) ? blk.children.map((c) => c.type === "text" ? c.content : "").join("") : "");
		if (SCOPED_ABBR_TEST_RE.test(blkContent)) replace_scoped(blk.children || []);
		if (RARE_RE.test(blkContent)) replace_rare(blk.children || []);
	}
}
var CoreRuler = class {
	rules = [];
	cache = null;
	invalidateCache() {
		this.cache = null;
	}
	push(name, fn) {
		const idx = this.rules.findIndex((r) => r.name === name);
		if (idx >= 0) this.rules.splice(idx, 1);
		this.rules.push({
			name,
			fn,
			enabled: true
		});
		this.invalidateCache();
	}
	at(name, fn) {
		const idx = this.rules.findIndex((r) => r.name === name);
		if (idx < 0) throw new Error(`Parser rule not found: ${name}`);
		this.rules[idx].fn = fn;
		this.invalidateCache();
	}
	before(beforeName, name, fn) {
		const i = this.rules.findIndex((r) => r.name === beforeName);
		if (i < 0) throw new Error(`Parser rule not found: ${beforeName}`);
		const exists = this.rules.findIndex((r) => r.name === name);
		if (exists >= 0) this.rules.splice(exists, 1);
		this.rules.splice(i, 0, {
			name,
			fn,
			enabled: true
		});
		this.invalidateCache();
	}
	after(afterName, name, fn) {
		const i = this.rules.findIndex((r) => r.name === afterName);
		if (i < 0) throw new Error(`Parser rule not found: ${afterName}`);
		const exists = this.rules.findIndex((r) => r.name === name);
		if (exists >= 0) this.rules.splice(exists, 1);
		this.rules.splice(i + 1, 0, {
			name,
			fn,
			enabled: true
		});
		this.invalidateCache();
	}
	enable(names, ignoreInvalid) {
		const list$1 = Array.isArray(names) ? names : [names];
		const changed = [];
		for (const n of list$1) {
			const idx = this.rules.findIndex((r) => r.name === n);
			if (idx < 0) {
				if (!ignoreInvalid) throw new Error(`Rules manager: invalid rule name ${n}`);
				continue;
			}
			if (!this.rules[idx].enabled) {
				this.rules[idx].enabled = true;
				changed.push(n);
			}
		}
		if (changed.length) this.invalidateCache();
		return changed;
	}
	disable(names, ignoreInvalid) {
		const list$1 = Array.isArray(names) ? names : [names];
		const changed = [];
		for (const n of list$1) {
			const idx = this.rules.findIndex((r) => r.name === n);
			if (idx < 0) {
				if (!ignoreInvalid) throw new Error(`Rules manager: invalid rule name ${n}`);
				continue;
			}
			if (this.rules[idx].enabled) {
				this.rules[idx].enabled = false;
				changed.push(n);
			}
		}
		if (changed.length) this.invalidateCache();
		return changed;
	}
	enableOnly(names) {
		const set = new Set(names);
		let changed = false;
		for (const r of this.rules) {
			const next = set.has(r.name);
			if (r.enabled !== next) {
				r.enabled = next;
				changed = true;
			}
		}
		if (changed) this.invalidateCache();
	}
	compileCache() {
		this.cache = this.rules.filter((r) => r.enabled).map((r) => r.fn);
	}
	getRules(_chainName = "") {
		if (!this.cache) this.compileCache();
		return this.cache;
	}
};
const QUOTE_TEST_RE = /['"]/;
const QUOTE_RE = /['"]/g;
const APOSTROPHE = "’";
function replaceAt(str, index, ch) {
	return str.slice(0, index) + ch + str.slice(index + 1);
}
function process_inlines(tokens, state) {
	let j;
	const stack = [];
	const quotes = state.md && state.md.options && state.md.options.quotes || "“”‘’";
	for (let i = 0; i < tokens.length; i++) {
		const token = tokens[i];
		const thisLevel = tokens[i].level;
		for (j = stack.length - 1; j >= 0; j--) if (stack[j].level <= thisLevel) break;
		stack.length = j + 1;
		if (token.type !== "text") continue;
		let text$1 = token.content;
		let pos = 0;
		let max = text$1.length;
		OUTER: while (pos < max) {
			QUOTE_RE.lastIndex = pos;
			const t = QUOTE_RE.exec(text$1);
			if (!t) break;
			let canOpen = true;
			let canClose = true;
			pos = t.index + 1;
			const isSingle = t[0] === "'";
			let lastChar = 32;
			if (t.index - 1 >= 0) lastChar = text$1.charCodeAt(t.index - 1);
			else for (j = i - 1; j >= 0; j--) {
				if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break;
				if (!tokens[j].content) continue;
				lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
				break;
			}
			let nextChar = 32;
			if (pos < max) nextChar = text$1.charCodeAt(pos);
			else for (j = i + 1; j < tokens.length; j++) {
				if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break;
				if (!tokens[j].content) continue;
				nextChar = tokens[j].content.charCodeAt(0);
				break;
			}
			const isLastPunctChar = isMdAsciiPunct(lastChar) || isPunctChar(String.fromCharCode(lastChar));
			const isNextPunctChar = isMdAsciiPunct(nextChar) || isPunctChar(String.fromCharCode(nextChar));
			const isLastWhiteSpace = isWhiteSpace(lastChar);
			const isNextWhiteSpace = isWhiteSpace(nextChar);
			if (isNextWhiteSpace) canOpen = false;
			else if (isNextPunctChar) {
				if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
			}
			if (isLastWhiteSpace) canClose = false;
			else if (isLastPunctChar) {
				if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
			}
			if (nextChar === 34 && t[0] === "\"") {
				if (lastChar >= 48 && lastChar <= 57) canClose = canOpen = false;
			}
			if (canOpen && canClose) {
				canOpen = isLastPunctChar;
				canClose = isNextPunctChar;
			}
			if (!canOpen && !canClose) {
				if (isSingle) token.content = replaceAt(token.content, t.index, APOSTROPHE);
				continue;
			}
			if (canClose) for (j = stack.length - 1; j >= 0; j--) {
				let item = stack[j];
				if (stack[j].level < thisLevel) break;
				if (item.single === isSingle && stack[j].level === thisLevel) {
					item = stack[j];
					let openQuote;
					let closeQuote;
					if (isSingle) {
						openQuote = quotes[2] || "‘";
						closeQuote = quotes[3] || "’";
					} else {
						openQuote = quotes[0] || "“";
						closeQuote = quotes[1] || "”";
					}
					token.content = replaceAt(token.content, t.index, closeQuote);
					tokens[item.token].content = replaceAt(tokens[item.token].content, item.pos, openQuote);
					pos += closeQuote.length - 1;
					if (item.token === i) pos += openQuote.length - 1;
					text$1 = token.content;
					max = text$1.length;
					stack.length = j;
					continue OUTER;
				}
			}
			if (canOpen) stack.push({
				token: i,
				pos: t.index,
				single: isSingle,
				level: thisLevel
			});
			else if (canClose && isSingle) token.content = replaceAt(token.content, t.index, APOSTROPHE);
		}
	}
}
function smartquotes(state) {
	if (!state.md.options.typographer) return;
	for (let blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {
		const inlineToken = state.tokens[blkIdx];
		if (inlineToken.type !== "inline") continue;
		const inlineContent = typeof inlineToken.content === "string" ? inlineToken.content : (inlineToken.children || []).map((t) => t.content || "").join("");
		if (!QUOTE_TEST_RE.test(inlineContent) || !inlineToken.children) continue;
		process_inlines(inlineToken.children, state);
	}
}
function text_join(state) {
	(state.tokens || []).forEach((tk) => {
		if (tk.type === "inline" && Array.isArray(tk.children)) {
			const out = [];
			for (let i = 0; i < tk.children.length; i++) {
				const ch = tk.children[i];
				if (ch.type === "text") {
					let content = ch.content || "";
					while (i + 1 < tk.children.length && tk.children[i + 1].type === "text") {
						i++;
						content += tk.children[i].content || "";
					}
					const textToken$1 = new Token("text", "", 0);
					textToken$1.content = content;
					textToken$1.level = ch.level;
					out.push(textToken$1);
				} else out.push(ch);
			}
			tk.children = out;
		}
	});
}
function isSpace$6(code$1) {
	switch (code$1) {
		case 9:
		case 32: return true;
	}
	return false;
}
function blockquote(state, startLine, endLine, silent) {
	let pos = state.bMarks[startLine] + state.tShift[startLine];
	let max = state.eMarks[startLine];
	const oldLineMax = state.lineMax;
	if (state.sCount[startLine] - state.blkIndent >= 4) return false;
	if (state.src.charCodeAt(pos) !== 62) return false;
	if (silent) return true;
	const oldBMarks = [];
	const oldBSCount = [];
	const oldSCount = [];
	const oldTShift = [];
	const terminatorRules = state.md.block.ruler.getRules("blockquote");
	const oldParentType = state.parentType;
	state.parentType = "blockquote";
	let lastLineEmpty = false;
	let nextLine;
	for (nextLine = startLine; nextLine < endLine; nextLine++) {
		const isOutdented = state.sCount[nextLine] < state.blkIndent;
		pos = state.bMarks[nextLine] + state.tShift[nextLine];
		max = state.eMarks[nextLine];
		if (pos >= max) break;
		if (state.src.charCodeAt(pos++) === 62 && !isOutdented) {
			let initial = state.sCount[nextLine] + 1;
			let spaceAfterMarker;
			let adjustTab;
			if (state.src.charCodeAt(pos) === 32) {
				pos++;
				initial++;
				adjustTab = false;
				spaceAfterMarker = true;
			} else if (state.src.charCodeAt(pos) === 9) {
				spaceAfterMarker = true;
				if ((state.bsCount[nextLine] + initial) % 4 === 3) {
					pos++;
					initial++;
					adjustTab = false;
				} else adjustTab = true;
			} else spaceAfterMarker = false;
			let offset = initial;
			oldBMarks.push(state.bMarks[nextLine]);
			state.bMarks[nextLine] = pos;
			while (pos < max) {
				const ch = state.src.charCodeAt(pos);
				if (isSpace$6(ch)) if (ch === 9) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
				else offset++;
				else break;
				pos++;
			}
			lastLineEmpty = pos >= max;
			oldBSCount.push(state.bsCount[nextLine]);
			state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
			oldSCount.push(state.sCount[nextLine]);
			state.sCount[nextLine] = offset - initial;
			oldTShift.push(state.tShift[nextLine]);
			state.tShift[nextLine] = pos - state.bMarks[nextLine];
			continue;
		}
		if (lastLineEmpty) break;
		let terminate = false;
		for (let i = 0, l = terminatorRules.length; i < l; i++) if (terminatorRules[i](state, nextLine, endLine, true)) {
			terminate = true;
			break;
		}
		if (terminate) {
			state.lineMax = nextLine;
			if (state.blkIndent !== 0) {
				oldBMarks.push(state.bMarks[nextLine]);
				oldBSCount.push(state.bsCount[nextLine]);
				oldTShift.push(state.tShift[nextLine]);
				oldSCount.push(state.sCount[nextLine]);
				state.sCount[nextLine] -= state.blkIndent;
			}
			break;
		}
		oldBMarks.push(state.bMarks[nextLine]);
		oldBSCount.push(state.bsCount[nextLine]);
		oldTShift.push(state.tShift[nextLine]);
		oldSCount.push(state.sCount[nextLine]);
		state.sCount[nextLine] = -1;
	}
	const oldIndent = state.blkIndent;
	state.blkIndent = 0;
	const token_o = state.push("blockquote_open", "blockquote", 1);
	token_o.markup = ">";
	const lines = [startLine, 0];
	token_o.map = lines;
	state.md.block.tokenize(state, startLine, nextLine);
	const token_c = state.push("blockquote_close", "blockquote", -1);
	token_c.markup = ">";
	state.lineMax = oldLineMax;
	state.parentType = oldParentType;
	lines[1] = state.line;
	for (let i = 0; i < oldTShift.length; i++) {
		state.bMarks[i + startLine] = oldBMarks[i];
		state.tShift[i + startLine] = oldTShift[i];
		state.sCount[i + startLine] = oldSCount[i];
		state.bsCount[i + startLine] = oldBSCount[i];
	}
	state.blkIndent = oldIndent;
	return true;
}
function code(state, startLine, endLine) {
	if (state.sCount[startLine] - state.blkIndent < 4) return false;
	let nextLine = startLine + 1;
	let last = nextLine;
	while (nextLine < endLine) {
		if (state.isEmpty(nextLine)) {
			nextLine++;
			continue;
		}
		if (state.sCount[nextLine] - state.blkIndent >= 4) {
			nextLine++;
			last = nextLine;
			continue;
		}
		break;
	}
	state.line = last;
	const token = state.push("code_block", "code", 0);
	token.content = `${state.getLines(startLine, last, 4 + state.blkIndent, false)}\n`;
	token.map = [startLine, state.line];
	return true;
}
function fence(state, startLine, endLine, silent) {
	let pos = state.bMarks[startLine] + state.tShift[startLine];
	let max = state.eMarks[startLine];
	if (state.sCount[startLine] - state.blkIndent >= 4) return false;
	if (pos + 3 > max) return false;
	const marker = state.src.charCodeAt(pos);
	if (marker !== 126 && marker !== 96) return false;
	let mem = pos;
	pos = state.skipChars(pos, marker);
	let len = pos - mem;
	if (len < 3) return false;
	const markup = state.src.slice(mem, pos);
	const params = state.src.slice(pos, max);
	if (marker === 96) {
		if (params.includes(String.fromCharCode(marker))) return false;
	}
	if (silent) return true;
	let nextLine = startLine;
	let haveEndMarker = false;
	for (;;) {
		nextLine++;
		if (nextLine >= endLine) break;
		pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
		max = state.eMarks[nextLine];
		if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
		if (state.src.charCodeAt(pos) !== marker) continue;
		if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
		pos = state.skipChars(pos, marker);
		if (pos - mem < len) continue;
		pos = state.skipSpaces(pos);
		if (pos < max) continue;
		haveEndMarker = true;
		break;
	}
	len = state.sCount[startLine];
	state.line = nextLine + (haveEndMarker ? 1 : 0);
	const token = state.push("fence", "code", 0);
	token.info = params;
	token.content = state.getLines(startLine + 1, nextLine, len, true);
	token.markup = markup;
	token.map = [startLine, state.line];
	return true;
}
function isSpace$5(code$1) {
	switch (code$1) {
		case 9:
		case 32: return true;
	}
	return false;
}
function heading(state, startLine, endLine, silent) {
	let pos = state.bMarks[startLine] + state.tShift[startLine];
	let max = state.eMarks[startLine];
	if (state.sCount[startLine] - state.blkIndent >= 4) return false;
	let ch = state.src.charCodeAt(pos);
	if (ch !== 35 || pos >= max) return false;
	let level = 1;
	ch = state.src.charCodeAt(++pos);
	while (ch === 35 && pos < max && level <= 6) {
		level++;
		ch = state.src.charCodeAt(++pos);
	}
	if (level > 6 || pos < max && !isSpace$5(ch)) return false;
	if (silent) return true;
	max = state.skipSpacesBack(max, pos);
	const tmp = state.skipCharsBack(max, 35, pos);
	if (tmp > pos && isSpace$5(state.src.charCodeAt(tmp - 1))) max = tmp;
	state.line = startLine + 1;
	const token_o = state.push("heading_open", `h${String(level)}`, 1);
	token_o.markup = "########".slice(0, level);
	token_o.map = [startLine, state.line];
	const token_i = state.push("inline", "", 0);
	token_i.content = state.src.slice(pos, max).trim();
	token_i.map = [startLine, state.line];
	token_i.children = [];
	const token_c = state.push("heading_close", `h${String(level)}`, -1);
	token_c.markup = "########".slice(0, level);
	return true;
}
function isSpace$4(code$1) {
	switch (code$1) {
		case 9:
		case 32: return true;
	}
	return false;
}
function hr(state, startLine, endLine, silent) {
	const max = state.eMarks[startLine];
	if (state.sCount[startLine] - state.blkIndent >= 4) return false;
	let pos = state.bMarks[startLine] + state.tShift[startLine];
	const marker = state.src.charCodeAt(pos++);
	if (marker !== 42 && marker !== 45 && marker !== 95) return false;
	let cnt = 1;
	while (pos < max) {
		const ch = state.src.charCodeAt(pos++);
		if (ch !== marker && !isSpace$4(ch)) return false;
		if (ch === marker) cnt++;
	}
	if (cnt < 3) return false;
	if (silent) return true;
	state.line = startLine + 1;
	const token = state.push("hr", "hr", 0);
	token.map = [startLine, state.line];
	token.markup = new Array(cnt + 1).join(String.fromCharCode(marker));
	return true;
}
var html_blocks_default = [
	"address",
	"article",
	"aside",
	"base",
	"basefont",
	"blockquote",
	"body",
	"caption",
	"center",
	"col",
	"colgroup",
	"dd",
	"details",
	"dialog",
	"dir",
	"div",
	"dl",
	"dt",
	"fieldset",
	"figcaption",
	"figure",
	"footer",
	"form",
	"frame",
	"frameset",
	"h1",
	"h2",
	"h3",
	"h4",
	"h5",
	"h6",
	"head",
	"header",
	"hr",
	"html",
	"iframe",
	"legend",
	"li",
	"link",
	"main",
	"menu",
	"menuitem",
	"nav",
	"noframes",
	"ol",
	"optgroup",
	"option",
	"p",
	"param",
	"search",
	"section",
	"summary",
	"table",
	"tbody",
	"td",
	"tfoot",
	"th",
	"thead",
	"title",
	"tr",
	"track",
	"ul"
];
const open_tag = `<[A-Za-z][A-Za-z0-9\\-]*(?:\\s+[a-zA-Z_:][a-zA-Z0-9:._-]*(?:\\s*=\\s*(?:[^"'=<>\`\\x00-\\x20]+|'[^']*'|"[^"]*"))?)*\\s*\\/?>`;
const close_tag = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>";
`${open_tag}${close_tag}`;
const HTML_OPEN_CLOSE_TAG_RE = /* @__PURE__ */ new RegExp(`^(?:${open_tag}|${close_tag})`);
const HTML_SEQUENCES = [
	[
		/^<(script|pre|style|textarea)(?=(\s|>|$))/i,
		/<\/(script|pre|style|textarea)>/i,
		true
	],
	[
		/^<!--/,
		/-->/,
		true
	],
	[
		/^<\?/,
		/\?>/,
		true
	],
	[
		/^<![A-Z]/,
		/>/,
		true
	],
	[
		/^<!\[CDATA\[/,
		/\]\]>/,
		true
	],
	[
		new RegExp(`^</?(${html_blocks_default.join("|")})(?=(\\s|/?>|$))`, "i"),
		/^$/,
		true
	],
	[
		/* @__PURE__ */ new RegExp(`${HTML_OPEN_CLOSE_TAG_RE.source}\\s*$`),
		/^$/,
		false
	]
];
function html_block(state, startLine, endLine, silent) {
	let pos = state.bMarks[startLine] + state.tShift[startLine];
	let max = state.eMarks[startLine];
	if (state.sCount[startLine] - state.blkIndent >= 4) return false;
	if (!state.md.options.html) return false;
	if (state.src.charCodeAt(pos) !== 60) return false;
	let lineText = state.src.slice(pos, max);
	let i = 0;
	for (; i < HTML_SEQUENCES.length; i++) if (HTML_SEQUENCES[i][0].test(lineText)) break;
	if (i === HTML_SEQUENCES.length) return false;
	if (silent) return HTML_SEQUENCES[i][2];
	let nextLine = startLine + 1;
	if (!HTML_SEQUENCES[i][1].test(lineText)) for (; nextLine < endLine; nextLine++) {
		if (state.sCount[nextLine] < state.blkIndent) break;
		pos = state.bMarks[nextLine] + state.tShift[nextLine];
		max = state.eMarks[nextLine];
		lineText = state.src.slice(pos, max);
		if (HTML_SEQUENCES[i][1].test(lineText)) {
			if (lineText.length !== 0) nextLine++;
			break;
		}
	}
	state.line = nextLine;
	const token = state.push("html_block", "", 0);
	token.map = [startLine, nextLine];
	token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
	return true;
}
function lheading(state, startLine, endLine) {
	const terminatorRules = state.md.block.ruler.getRules("paragraph");
	if (state.sCount[startLine] - state.blkIndent >= 4) return false;
	const oldParentType = state.parentType;
	state.parentType = "paragraph";
	let level = 0;
	let marker;
	let nextLine = startLine + 1;
	for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
		if (state.sCount[nextLine] - state.blkIndent > 3) continue;
		if (state.sCount[nextLine] >= state.blkIndent) {
			let pos = state.bMarks[nextLine] + state.tShift[nextLine];
			const max = state.eMarks[nextLine];
			if (pos < max) {
				marker = state.src.charCodeAt(pos);
				if (marker === 45 || marker === 61) {
					pos = state.skipChars(pos, marker);
					pos = state.skipSpaces(pos);
					if (pos >= max) {
						level = marker === 61 ? 1 : 2;
						break;
					}
				}
			}
		}
		if (state.sCount[nextLine] < 0) continue;
		let terminate = false;
		for (let i = 0, l = terminatorRules.length; i < l; i++) if (terminatorRules[i](state, nextLine, endLine, true)) {
			terminate = true;
			break;
		}
		if (terminate) break;
	}
	if (!level) return false;
	const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
	state.line = nextLine + 1;
	const token_o = state.push("heading_open", `h${String(level)}`, 1);
	token_o.markup = String.fromCharCode(marker);
	token_o.map = [startLine, state.line];
	const token_i = state.push("inline", "", 0);
	token_i.content = content;
	token_i.map = [startLine, state.line - 1];
	token_i.children = [];
	const token_c = state.push("heading_close", `h${String(level)}`, -1);
	token_c.markup = String.fromCharCode(marker);
	state.parentType = oldParentType;
	return true;
}
function isSpace$3(code$1) {
	switch (code$1) {
		case 9:
		case 32: return true;
	}
	return false;
}
function skipBulletListMarker(state, startLine) {
	const max = state.eMarks[startLine];
	let pos = state.bMarks[startLine] + state.tShift[startLine];
	const marker = state.src.charCodeAt(pos++);
	if (marker !== 42 && marker !== 45 && marker !== 43) return -1;
	if (pos < max) {
		if (!isSpace$3(state.src.charCodeAt(pos))) return -1;
	}
	return pos;
}
function skipOrderedListMarker(state, startLine) {
	const start = state.bMarks[startLine] + state.tShift[startLine];
	const max = state.eMarks[startLine];
	let pos = start;
	if (pos + 1 >= max) return -1;
	let ch = state.src.charCodeAt(pos++);
	if (ch < 48 || ch > 57) return -1;
	for (;;) {
		if (pos >= max) return -1;
		ch = state.src.charCodeAt(pos++);
		if (ch >= 48 && ch <= 57) {
			if (pos - start >= 10) return -1;
			continue;
		}
		if (ch === 41 || ch === 46) break;
		return -1;
	}
	if (pos < max) {
		ch = state.src.charCodeAt(pos);
		if (!isSpace$3(ch)) return -1;
	}
	return pos;
}
function markTightParagraphs(state, idx) {
	const level = state.level + 2;
	for (let i = idx + 2, l = state.tokens.length - 2; i < l; i++) if (state.tokens[i].level === level && state.tokens[i].type === "paragraph_open") {
		state.tokens[i + 2].hidden = true;
		state.tokens[i].hidden = true;
		i += 2;
	}
}
function list(state, startLine, endLine, silent) {
	let max;
	let pos;
	let start = 0;
	let nextLine = startLine;
	let tight = true;
	if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
	if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
	let isTerminatingParagraph = false;
	if (silent && state.parentType === "paragraph") {
		if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
	}
	let isOrdered;
	let markerValue;
	let posAfterMarker;
	if ((posAfterMarker = skipOrderedListMarker(state, nextLine)) >= 0) {
		isOrdered = true;
		start = state.bMarks[nextLine] + state.tShift[nextLine];
		markerValue = Number(state.src.slice(start, posAfterMarker - 1));
		if (isTerminatingParagraph && markerValue !== 1) return false;
	} else if ((posAfterMarker = skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
	else return false;
	if (isTerminatingParagraph) {
		if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
	}
	if (silent) return true;
	const markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
	const listTokIdx = state.tokens.length;
	if (isOrdered) {
		const token = state.push("ordered_list_open", "ol", 1);
		if (markerValue !== void 0 && markerValue !== 1) token.attrs = [["start", String(markerValue)]];
	} else state.push("bullet_list_open", "ul", 1);
	const listLines = [nextLine, 0];
	state.tokens[state.tokens.length - 1].map = listLines;
	state.tokens[state.tokens.length - 1].markup = String.fromCharCode(markerCharCode);
	let prevEmptyEnd = false;
	const terminatorRules = state.md.block.ruler.getRules("list");
	const oldParentType = state.parentType;
	state.parentType = "list";
	while (nextLine < endLine) {
		pos = posAfterMarker;
		max = state.eMarks[nextLine];
		const initial = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
		let offset = initial;
		while (pos < max) {
			const ch = state.src.charCodeAt(pos);
			if (ch === 9) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
			else if (ch === 32) offset++;
			else break;
			pos++;
		}
		const contentStart = pos;
		let indentAfterMarker;
		if (contentStart >= max) indentAfterMarker = 1;
		else indentAfterMarker = offset - initial;
		if (indentAfterMarker > 4) indentAfterMarker = 1;
		const indent = initial + indentAfterMarker;
		const token = state.push("list_item_open", "li", 1);
		token.markup = String.fromCharCode(markerCharCode);
		const itemLines = [nextLine, 0];
		token.map = itemLines;
		if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
		const oldTight = state.tight;
		const oldTShift = state.tShift[nextLine];
		const oldSCount = state.sCount[nextLine];
		const oldListIndent = state.listIndent;
		state.listIndent = state.blkIndent;
		state.blkIndent = indent;
		state.tight = true;
		state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
		state.sCount[nextLine] = offset;
		if (contentStart >= max && state.isEmpty(nextLine + 1)) state.line = Math.min(state.line + 2, endLine);
		else state.md.block.tokenize(state, nextLine, endLine, true);
		if (!state.tight || prevEmptyEnd) tight = false;
		prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
		state.blkIndent = state.listIndent;
		state.listIndent = oldListIndent;
		state.tShift[nextLine] = oldTShift;
		state.sCount[nextLine] = oldSCount;
		state.tight = oldTight;
		state.push("list_item_close", "li", -1).markup = String.fromCharCode(markerCharCode);
		nextLine = state.line;
		itemLines[1] = nextLine;
		if (nextLine >= endLine) break;
		if (state.sCount[nextLine] < state.blkIndent) break;
		if (state.sCount[nextLine] - state.blkIndent >= 4) break;
		let terminate = false;
		for (let i = 0, l = terminatorRules.length; i < l; i++) if (terminatorRules[i](state, nextLine, endLine, true)) {
			terminate = true;
			break;
		}
		if (terminate) break;
		if (isOrdered) {
			posAfterMarker = skipOrderedListMarker(state, nextLine);
			if (posAfterMarker < 0) break;
			start = state.bMarks[nextLine] + state.tShift[nextLine];
		} else {
			posAfterMarker = skipBulletListMarker(state, nextLine);
			if (posAfterMarker < 0) break;
		}
		if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
	}
	if (isOrdered) state.push("ordered_list_close", "ol", -1).markup = String.fromCharCode(markerCharCode);
	else state.push("bullet_list_close", "ul", -1).markup = String.fromCharCode(markerCharCode);
	listLines[1] = nextLine;
	state.line = nextLine;
	state.parentType = oldParentType;
	if (tight) markTightParagraphs(state, listTokIdx);
	return true;
}
function paragraph(state, startLine, endLine) {
	const terminatorRules = state.md.block.ruler.getRules("paragraph");
	const oldParentType = state.parentType;
	let nextLine = startLine + 1;
	state.parentType = "paragraph";
	for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
		if (state.sCount[nextLine] - state.blkIndent > 3) continue;
		if (state.sCount[nextLine] < 0) continue;
		let terminate = false;
		for (let i = 0, l = terminatorRules.length; i < l; i++) if (terminatorRules[i](state, nextLine, endLine, true)) {
			terminate = true;
			break;
		}
		if (terminate) break;
	}
	const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
	state.line = nextLine;
	const token_o = state.push("paragraph_open", "p", 1);
	token_o.map = [startLine, state.line];
	const token_i = state.push("inline", "", 0);
	token_i.content = content;
	token_i.map = [startLine, state.line];
	token_i.children = [];
	state.push("paragraph_close", "p", -1);
	state.parentType = oldParentType;
	return true;
}
function isSpace$2(code$1) {
	switch (code$1) {
		case 9:
		case 32: return true;
	}
	return false;
}
function normalizeReference(str) {
	str = str.trim().replace(/\s+/g, " ");
	if ("ẞ".toLowerCase() === "Ṿ".toLowerCase()) str = str.toLowerCase();
	return str.toLowerCase().toUpperCase().toLowerCase();
}
function reference(state, startLine, _endLine, silent) {
	let pos = state.bMarks[startLine] + state.tShift[startLine];
	let max = state.eMarks[startLine];
	let nextLine = startLine + 1;
	if (state.sCount[startLine] - state.blkIndent >= 4) return false;
	if (state.src.charCodeAt(pos) !== 91) return false;
	function getNextLine(nextLine$1) {
		const endLine = state.lineMax;
		if (nextLine$1 >= endLine || state.isEmpty(nextLine$1)) return null;
		let isContinuation = false;
		if (state.sCount[nextLine$1] - state.blkIndent > 3) isContinuation = true;
		if (state.sCount[nextLine$1] < 0) isContinuation = true;
		if (!isContinuation) {
			const terminatorRules = state.md.block.ruler.getRules("reference");
			const oldParentType = state.parentType;
			state.parentType = "reference";
			let terminate = false;
			for (let i = 0, l = terminatorRules.length; i < l; i++) if (terminatorRules[i](state, nextLine$1, endLine, true)) {
				terminate = true;
				break;
			}
			state.parentType = oldParentType;
			if (terminate) return null;
		}
		const pos$1 = state.bMarks[nextLine$1] + state.tShift[nextLine$1];
		const max$1 = state.eMarks[nextLine$1];
		return state.src.slice(pos$1, max$1 + 1);
	}
	let str = state.src.slice(pos, max + 1);
	max = str.length;
	let labelEnd = -1;
	for (pos = 1; pos < max; pos++) {
		const ch = str.charCodeAt(pos);
		if (ch === 91) return false;
		else if (ch === 93) {
			labelEnd = pos;
			break;
		} else if (ch === 10) {
			const lineContent = getNextLine(nextLine);
			if (lineContent !== null) {
				str += lineContent;
				max = str.length;
				nextLine++;
			}
		} else if (ch === 92) {
			pos++;
			if (pos < max && str.charCodeAt(pos) === 10) {
				const lineContent = getNextLine(nextLine);
				if (lineContent !== null) {
					str += lineContent;
					max = str.length;
					nextLine++;
				}
			}
		}
	}
	if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 58) return false;
	for (pos = labelEnd + 2; pos < max; pos++) {
		const ch = str.charCodeAt(pos);
		if (ch === 10) {
			const lineContent = getNextLine(nextLine);
			if (lineContent !== null) {
				str += lineContent;
				max = str.length;
				nextLine++;
			}
		} else if (isSpace$2(ch)) {} else break;
	}
	const destRes = state.md.helpers.parseLinkDestination(str, pos, max);
	if (!destRes.ok) return false;
	const href = state.md.normalizeLink(destRes.str);
	if (!state.md.validateLink(href)) return false;
	pos = destRes.pos;
	const destEndPos = pos;
	const destEndLineNo = nextLine;
	const start = pos;
	for (; pos < max; pos++) {
		const ch = str.charCodeAt(pos);
		if (ch === 10) {
			const lineContent = getNextLine(nextLine);
			if (lineContent !== null) {
				str += lineContent;
				max = str.length;
				nextLine++;
			}
		} else if (isSpace$2(ch)) {} else break;
	}
	let titleRes = state.md.helpers.parseLinkTitle(str, pos, max);
	while (titleRes.can_continue) {
		const lineContent = getNextLine(nextLine);
		if (lineContent === null) break;
		str += lineContent;
		pos = max;
		max = str.length;
		nextLine++;
		titleRes = state.md.helpers.parseLinkTitle(str, pos, max, titleRes);
	}
	let title;
	if (pos < max && start !== pos && titleRes.ok) {
		title = titleRes.str;
		pos = titleRes.pos;
	} else {
		title = "";
		pos = destEndPos;
		nextLine = destEndLineNo;
	}
	while (pos < max) {
		if (!isSpace$2(str.charCodeAt(pos))) break;
		pos++;
	}
	if (pos < max && str.charCodeAt(pos) !== 10) {
		if (title) {
			title = "";
			pos = destEndPos;
			nextLine = destEndLineNo;
			while (pos < max) {
				if (!isSpace$2(str.charCodeAt(pos))) break;
				pos++;
			}
		}
	}
	if (pos < max && str.charCodeAt(pos) !== 10) return false;
	const label = normalizeReference(str.slice(1, labelEnd));
	if (!label) return false;
	if (silent) return true;
	if (typeof state.env.references === "undefined") state.env.references = {};
	if (typeof state.env.references[label] === "undefined") state.env.references[label] = {
		title,
		href
	};
	state.line = nextLine;
	return true;
}
function isSpace$1(code$1) {
	switch (code$1) {
		case 9:
		case 32: return true;
	}
	return false;
}
const MAX_AUTOCOMPLETED_CELLS = 65536;
function getLine(state, line) {
	const pos = state.bMarks[line] + state.tShift[line];
	const max = state.eMarks[line];
	return state.src.slice(pos, max);
}
function escapedSplit(str) {
	const result = [];
	const max = str.length;
	let pos = 0;
	let ch = str.charCodeAt(pos);
	let isEscaped = false;
	let lastPos = 0;
	let current = "";
	while (pos < max) {
		if (ch === 124) if (!isEscaped) {
			result.push(current + str.substring(lastPos, pos));
			current = "";
			lastPos = pos + 1;
		} else {
			current += str.substring(lastPos, pos - 1);
			lastPos = pos;
		}
		isEscaped = ch === 92;
		pos++;
		ch = str.charCodeAt(pos);
	}
	result.push(current + str.substring(lastPos));
	return result;
}
function table(state, startLine, endLine, silent) {
	if (startLine + 2 > endLine) return false;
	let nextLine = startLine + 1;
	if (state.sCount[nextLine] < state.blkIndent) return false;
	if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
	let pos = state.bMarks[nextLine] + state.tShift[nextLine];
	if (pos >= state.eMarks[nextLine]) return false;
	const firstCh = state.src.charCodeAt(pos++);
	if (firstCh !== 124 && firstCh !== 45 && firstCh !== 58) return false;
	if (pos >= state.eMarks[nextLine]) return false;
	const secondCh = state.src.charCodeAt(pos++);
	if (secondCh !== 124 && secondCh !== 45 && secondCh !== 58 && !isSpace$1(secondCh)) return false;
	if (firstCh === 45 && isSpace$1(secondCh)) return false;
	while (pos < state.eMarks[nextLine]) {
		const ch = state.src.charCodeAt(pos);
		if (ch !== 124 && ch !== 45 && ch !== 58 && !isSpace$1(ch)) return false;
		pos++;
	}
	let lineText = getLine(state, startLine + 1);
	let columns = lineText.split("|");
	const aligns = [];
	for (let i = 0; i < columns.length; i++) {
		const t = columns[i].trim();
		if (!t) if (i === 0 || i === columns.length - 1) continue;
		else return false;
		if (!/^:?-+:?$/.test(t)) return false;
		if (t.charCodeAt(t.length - 1) === 58) aligns.push(t.charCodeAt(0) === 58 ? "center" : "right");
		else if (t.charCodeAt(0) === 58) aligns.push("left");
		else aligns.push("");
	}
	lineText = getLine(state, startLine).trim();
	if (!lineText.includes("|")) return false;
	if (state.sCount[startLine] - state.blkIndent >= 4) return false;
	columns = escapedSplit(lineText);
	if (columns.length && columns[0] === "") columns.shift();
	if (columns.length && columns[columns.length - 1] === "") columns.pop();
	const columnCount = columns.length;
	if (columnCount === 0 || columnCount !== aligns.length) return false;
	if (silent) return true;
	const oldParentType = state.parentType;
	state.parentType = "table";
	const terminatorRules = state.md.block.ruler.getRules("blockquote");
	const token_to = state.push("table_open", "table", 1);
	const tableLines = [startLine, 0];
	token_to.map = tableLines;
	const token_tho = state.push("thead_open", "thead", 1);
	token_tho.map = [startLine, startLine + 1];
	const token_htro = state.push("tr_open", "tr", 1);
	token_htro.map = [startLine, startLine + 1];
	for (let i = 0; i < columns.length; i++) {
		const token_ho = state.push("th_open", "th", 1);
		if (aligns[i]) token_ho.attrs = [["style", `text-align:${aligns[i]}`]];
		const token_il = state.push("inline", "", 0);
		token_il.content = columns[i].trim();
		token_il.children = [];
		state.push("th_close", "th", -1);
	}
	state.push("tr_close", "tr", -1);
	state.push("thead_close", "thead", -1);
	let tbodyLines;
	let autocompletedCells = 0;
	for (nextLine = startLine + 2; nextLine < endLine; nextLine++) {
		if (state.sCount[nextLine] < state.blkIndent) break;
		let terminate = false;
		for (let i = 0, l = terminatorRules.length; i < l; i++) if (terminatorRules[i](state, nextLine, endLine, true)) {
			terminate = true;
			break;
		}
		if (terminate) break;
		lineText = getLine(state, nextLine).trim();
		if (!lineText) break;
		if (state.sCount[nextLine] - state.blkIndent >= 4) break;
		columns = escapedSplit(lineText);
		if (columns.length && columns[0] === "") columns.shift();
		if (columns.length && columns[columns.length - 1] === "") columns.pop();
		autocompletedCells += columnCount - columns.length;
		if (autocompletedCells > MAX_AUTOCOMPLETED_CELLS) break;
		if (nextLine === startLine + 2) {
			const token_tbo = state.push("tbody_open", "tbody", 1);
			token_tbo.map = tbodyLines = [startLine + 2, 0];
		}
		const token_tro = state.push("tr_open", "tr", 1);
		token_tro.map = [nextLine, nextLine + 1];
		for (let i = 0; i < columnCount; i++) {
			const token_tdo = state.push("td_open", "td", 1);
			if (aligns[i]) token_tdo.attrs = [["style", `text-align:${aligns[i]}`]];
			const token_il = state.push("inline", "", 0);
			token_il.content = columns[i] ? columns[i].trim() : "";
			token_il.children = [];
			state.push("td_close", "td", -1);
		}
		state.push("tr_close", "tr", -1);
	}
	if (tbodyLines) {
		state.push("tbody_close", "tbody", -1);
		tbodyLines[1] = nextLine;
	}
	state.push("table_close", "table", -1);
	tableLines[1] = nextLine;
	state.parentType = oldParentType;
	state.line = nextLine;
	return true;
}
/**
* Block-level rule management with Ruler pattern
*/
var BlockRuler = class {
	_rules = [];
	cache = null;
	invalidateCache() {
		this.cache = null;
	}
	push(name, fn, options) {
		this._rules.push({
			name,
			enabled: true,
			fn,
			alt: options?.alt || []
		});
		this.invalidateCache();
	}
	before(beforeName, name, fn, options) {
		const i = this._rules.findIndex((r) => r.name === beforeName);
		if (i < 0) throw new Error(`Parser rule not found: ${beforeName}`);
		const exists = this._rules.findIndex((r) => r.name === name);
		if (exists >= 0) this._rules.splice(exists, 1);
		this._rules.splice(i, 0, {
			name,
			enabled: true,
			fn,
			alt: options?.alt || []
		});
		this.invalidateCache();
	}
	after(afterName, name, fn, options) {
		const i = this._rules.findIndex((r) => r.name === afterName);
		if (i < 0) throw new Error(`Parser rule not found: ${afterName}`);
		const exists = this._rules.findIndex((r) => r.name === name);
		if (exists >= 0) this._rules.splice(exists, 1);
		this._rules.splice(i + 1, 0, {
			name,
			enabled: true,
			fn,
			alt: options?.alt || []
		});
		this.invalidateCache();
	}
	getRules(chainName) {
		const chain = chainName || "";
		if (!this.cache) this.compileCache();
		return this.cache.get(chain) ?? [];
	}
	at(name, fn, options) {
		const index = this._rules.findIndex((r) => r.name === name);
		if (index === -1) throw new Error(`Parser rule not found: ${name}`);
		this._rules[index].fn = fn;
		if (options?.alt) this._rules[index].alt = options.alt;
		this.invalidateCache();
	}
	enable(names, ignoreInvalid) {
		const nameList = Array.isArray(names) ? names : [names];
		const result = [];
		nameList.forEach((name) => {
			const idx = this._rules.findIndex((r) => r.name === name);
			if (idx === -1) {
				if (ignoreInvalid) return;
				throw new Error(`Rules manager: invalid rule name ${name}`);
			}
			if (!this._rules[idx].enabled) {
				this._rules[idx].enabled = true;
				result.push(name);
			}
		});
		if (result.length) this.invalidateCache();
		return result;
	}
	disable(names, ignoreInvalid) {
		const nameList = Array.isArray(names) ? names : [names];
		const result = [];
		nameList.forEach((name) => {
			const idx = this._rules.findIndex((r) => r.name === name);
			if (idx === -1) {
				if (ignoreInvalid) return;
				throw new Error(`Rules manager: invalid rule name ${name}`);
			}
			if (this._rules[idx].enabled) {
				this._rules[idx].enabled = false;
				result.push(name);
			}
		});
		if (result.length) this.invalidateCache();
		return result;
	}
	enableOnly(names) {
		const allow = new Set(names);
		let changed = false;
		for (const r of this._rules) {
			const next = allow.has(r.name);
			if (r.enabled !== next) {
				r.enabled = next;
				changed = true;
			}
		}
		if (changed) this.invalidateCache();
	}
	compileCache() {
		const chains = new Set([""]);
		for (const rule of this._rules) {
			if (!rule.enabled) continue;
			for (const alt of rule.alt) chains.add(alt);
		}
		const cache = /* @__PURE__ */ new Map();
		for (const chain of chains) {
			const bucket = [];
			for (const rule of this._rules) {
				if (!rule.enabled) continue;
				if (chain !== "" && !rule.alt.includes(chain)) continue;
				bucket.push(rule.fn);
			}
			cache.set(chain, bucket);
		}
		this.cache = cache;
	}
};
function isSpace(code$1) {
	switch (code$1) {
		case 9:
		case 32: return true;
	}
	return false;
}
var StateBlock = class {
	src;
	md;
	env;
	tokens;
	Token;
	bMarks = [];
	eMarks = [];
	tShift = [];
	sCount = [];
	bsCount = [];
	blkIndent = 0;
	line = 0;
	lineMax = 0;
	tight = false;
	ddIndent = -1;
	listIndent = -1;
	parentType = "root";
	level = 0;
	constructor(src, md, env, tokens) {
		this.src = src;
		this.md = md;
		this.env = env;
		this.tokens = tokens;
		this.Token = Token;
		const s = this.src;
		let indent = 0;
		let offset = 0;
		let start = 0;
		let indent_found = false;
		for (let pos = 0, len = s.length; pos < len; pos++) {
			const ch = s.charCodeAt(pos);
			if (!indent_found) if (isSpace(ch)) {
				indent++;
				if (ch === 9) offset += 4 - offset % 4;
				else offset++;
				continue;
			} else indent_found = true;
			if (ch === 10 || pos === len - 1) {
				if (ch !== 10) pos++;
				this.bMarks.push(start);
				this.eMarks.push(pos);
				this.tShift.push(indent);
				this.sCount.push(offset);
				this.bsCount.push(0);
				indent_found = false;
				indent = 0;
				offset = 0;
				start = pos + 1;
			}
		}
		this.bMarks.push(s.length);
		this.eMarks.push(s.length);
		this.tShift.push(0);
		this.sCount.push(0);
		this.bsCount.push(0);
		this.lineMax = this.bMarks.length - 1;
	}
	push(type, tag, nesting) {
		const token = new Token(type, tag, nesting);
		token.level = this.level;
		token.content = "";
		token.block = true;
		if (nesting < 0) this.level--;
		token.level = this.level;
		if (nesting > 0) this.level++;
		this.tokens.push(token);
		return token;
	}
	isEmpty(line) {
		return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
	}
	skipEmptyLines(from) {
		for (let max = this.lineMax; from < max; from++) if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
		return from;
	}
	skipSpaces(pos) {
		for (let max = this.src.length; pos < max; pos++) if (!isSpace(this.src.charCodeAt(pos))) break;
		return pos;
	}
	skipSpacesBack(pos, min) {
		if (pos <= min) return pos;
		while (pos > min) if (!isSpace(this.src.charCodeAt(--pos))) return pos + 1;
		return pos;
	}
	skipChars(pos, code$1) {
		for (let max = this.src.length; pos < max; pos++) if (this.src.charCodeAt(pos) !== code$1) break;
		return pos;
	}
	skipCharsBack(pos, code$1, min) {
		if (pos <= min) return pos;
		while (pos > min) if (code$1 !== this.src.charCodeAt(--pos)) return pos + 1;
		return pos;
	}
	getLines(begin, end, indent, keepLastLF) {
		if (begin >= end) return "";
		const queue = new Array(end - begin);
		for (let i = 0, line = begin; line < end; line++, i++) {
			let lineIndent = 0;
			const lineStart = this.bMarks[line];
			let first = lineStart;
			let last;
			if (line + 1 < end || keepLastLF) last = this.eMarks[line] + 1;
			else last = this.eMarks[line];
			while (first < last && lineIndent < indent) {
				const ch = this.src.charCodeAt(first);
				if (isSpace(ch)) if (ch === 9) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
				else lineIndent++;
				else if (first - lineStart < this.tShift[line]) lineIndent++;
				else break;
				first++;
			}
			if (lineIndent > indent) queue[i] = new Array(lineIndent - indent + 1).join(" ") + this.src.slice(first, last);
			else queue[i] = this.src.slice(first, last);
		}
		return queue.join("");
	}
};
const _rules = [
	[
		"table",
		table,
		["paragraph", "reference"]
	],
	["code", code],
	[
		"fence",
		fence,
		[
			"paragraph",
			"reference",
			"blockquote",
			"list"
		]
	],
	[
		"blockquote",
		blockquote,
		[
			"paragraph",
			"reference",
			"blockquote",
			"list"
		]
	],
	[
		"hr",
		hr,
		[
			"paragraph",
			"reference",
			"blockquote",
			"list"
		]
	],
	[
		"list",
		list,
		[
			"paragraph",
			"reference",
			"blockquote"
		]
	],
	["reference", reference],
	[
		"html_block",
		html_block,
		[
			"paragraph",
			"reference",
			"blockquote"
		]
	],
	[
		"heading",
		heading,
		[
			"paragraph",
			"reference",
			"blockquote"
		]
	],
	["lheading", lheading],
	["paragraph", paragraph]
];
var ParserBlock = class {
	ruler;
	constructor() {
		this.ruler = new BlockRuler();
		for (let i = 0; i < _rules.length; i++) this.ruler.push(_rules[i][0], _rules[i][1], { alt: (_rules[i][2] || []).slice() });
	}
	/**
	* Generate tokens for input range
	*/
	tokenize(state, startLine, endLine) {
		const rules = this.ruler.getRules("");
		const len = rules.length;
		const maxNesting = state.md.options.maxNesting;
		let line = startLine;
		let hasEmptyLines = false;
		while (line < endLine) {
			state.line = line = state.skipEmptyLines(line);
			if (line >= endLine) break;
			if (state.sCount[line] < state.blkIndent) break;
			if (state.level >= maxNesting) {
				state.line = endLine;
				break;
			}
			const prevLine = state.line;
			let ok = false;
			for (let i = 0; i < len; i++) {
				ok = rules[i](state, line, endLine, false);
				if (ok) {
					if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
					break;
				}
			}
			if (!ok) throw new Error("none of the block rules matched");
			state.tight = !hasEmptyLines;
			if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
			line = state.line;
			if (line < endLine && state.isEmpty(line)) {
				hasEmptyLines = true;
				line++;
				state.line = line;
			}
		}
	}
	/**
	* ParserBlock.parse(src, md, env, outTokens)
	*
	* Process input string and push block tokens into `outTokens`
	*/
	parse(src, md, env, outTokens) {
		if (!src) return;
		const state = new StateBlock(src, md, env, outTokens);
		this.tokenize(state, state.line, state.lineMax);
	}
};
/**
* Process autolinks '<protocol:...>'
*/
const EMAIL_RE = /^[\w.!#$%&'*+/=?^`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i;
const AUTOLINK_RE = /^[a-z][a-z0-9+.-]{1,31}:[^<>\x00-\x20]*$/i;
function autolink(state, silent) {
	let pos = state.pos;
	if (state.src.charCodeAt(pos) !== 60) return false;
	const start = state.pos;
	const max = state.posMax;
	for (;;) {
		if (++pos >= max) return false;
		const ch = state.src.charCodeAt(pos);
		if (ch === 60) return false;
		if (ch === 62) break;
	}
	const url = state.src.slice(start + 1, pos);
	if (AUTOLINK_RE.test(url)) {
		const fullUrl = state.md.normalizeLink(url);
		if (!state.md.validateLink(fullUrl)) return false;
		if (!silent) {
			const token_o = state.push("link_open", "a", 1);
			token_o.attrs = [["href", fullUrl]];
			token_o.markup = "autolink";
			token_o.info = "auto";
			const token_t = state.push("text", "", 0);
			token_t.content = state.md.normalizeLinkText(url);
			const token_c = state.push("link_close", "a", -1);
			token_c.markup = "autolink";
			token_c.info = "auto";
		}
		state.pos += url.length + 2;
		return true;
	}
	if (EMAIL_RE.test(url)) {
		const fullUrl = state.md.normalizeLink(`mailto:${url}`);
		if (!state.md.validateLink(fullUrl)) return false;
		if (!silent) {
			const token_o = state.push("link_open", "a", 1);
			token_o.attrs = [["href", fullUrl]];
			token_o.markup = "autolink";
			token_o.info = "auto";
			const token_t = state.push("text", "", 0);
			token_t.content = state.md.normalizeLinkText(url);
			const token_c = state.push("link_close", "a", -1);
			token_c.markup = "autolink";
			token_c.info = "auto";
		}
		state.pos += url.length + 2;
		return true;
	}
	return false;
}
var autolink_default = autolink;
/**
* Parse backticks (inline code)
*/
function backticks(state, silent) {
	let pos = state.pos;
	if (state.src.charCodeAt(pos) !== 96) return false;
	const start = pos;
	pos++;
	const max = state.posMax;
	while (pos < max && state.src.charCodeAt(pos) === 96) pos++;
	const marker = state.src.slice(start, pos);
	const openerLength = marker.length;
	if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
		if (!silent) state.pending += marker;
		state.pos += openerLength;
		return true;
	}
	let matchEnd = pos;
	let matchStart;
	while ((matchStart = state.src.indexOf("`", matchEnd)) !== -1) {
		matchEnd = matchStart + 1;
		while (matchEnd < max && state.src.charCodeAt(matchEnd) === 96) matchEnd++;
		const closerLength = matchEnd - matchStart;
		if (closerLength === openerLength) {
			if (!silent) {
				const token = state.push("code_inline", "code", 0);
				token.markup = marker;
				token.content = state.src.slice(pos, matchStart).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
			}
			state.pos = matchEnd;
			return true;
		}
		state.backticks[closerLength] = matchStart;
	}
	state.backticksScanned = true;
	if (!silent) state.pending += marker;
	state.pos += openerLength;
	return true;
}
var backticks_default = backticks;
function processDelimiters(delimiters) {
	const openersBottom = {};
	const max = delimiters.length;
	if (!max) return;
	let headerIdx = 0;
	let lastTokenIdx = -2;
	const jumps = [];
	for (let closerIdx = 0; closerIdx < max; closerIdx++) {
		const closer = delimiters[closerIdx];
		jumps.push(0);
		if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
		lastTokenIdx = closer.token;
		closer.length = closer.length || 0;
		if (!closer.close) continue;
		if (!Object.prototype.hasOwnProperty.call(openersBottom, closer.marker)) openersBottom[closer.marker] = [
			-1,
			-1,
			-1,
			-1,
			-1,
			-1
		];
		const minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
		let openerIdx = headerIdx - jumps[headerIdx] - 1;
		let newMinOpenerIdx = openerIdx;
		for (; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1) {
			const opener = delimiters[openerIdx];
			if (opener.marker !== closer.marker) continue;
			if (opener.open && opener.end < 0) {
				let isOddMatch = false;
				if (opener.close || closer.open) {
					if ((opener.length + closer.length) % 3 === 0) {
						if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
					}
				}
				if (!isOddMatch) {
					const lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
					jumps[closerIdx] = closerIdx - openerIdx + lastJump;
					jumps[openerIdx] = lastJump;
					closer.open = false;
					opener.end = closerIdx;
					opener.close = false;
					newMinOpenerIdx = -1;
					lastTokenIdx = -2;
					break;
				}
			}
		}
		if (newMinOpenerIdx !== -1) openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
	}
}
function balance_pairs(state) {
	const tokens_meta = state.tokens_meta;
	const max = state.tokens_meta.length;
	processDelimiters(state.delimiters);
	for (let curr = 0; curr < max; curr++) if (tokens_meta[curr] && tokens_meta[curr].delimiters) processDelimiters(tokens_meta[curr].delimiters);
}
var balance_pairs_default = balance_pairs;
function emphasis_tokenize(state, silent) {
	const start = state.pos;
	const marker = state.src.charCodeAt(start);
	if (silent) return false;
	if (marker !== 95 && marker !== 42) return false;
	const scanned = state.scanDelims(state.pos, marker === 42);
	if (!scanned || scanned.length === 0) return false;
	for (let i = 0; i < scanned.length; i++) {
		const token = state.push("text", "", 0);
		token.content = String.fromCharCode(marker);
		state.delimiters.push({
			marker,
			length: scanned.length,
			token: state.tokens.length - 1,
			end: -1,
			open: scanned.can_open,
			close: scanned.can_close
		});
	}
	state.pos += scanned.length;
	return true;
}
function postProcess$1(state, delimiters) {
	const max = delimiters.length;
	for (let i = max - 1; i >= 0; i--) {
		const startDelim = delimiters[i];
		if (startDelim.marker !== 95 && startDelim.marker !== 42) continue;
		if (startDelim.end === -1) continue;
		const endDelim = delimiters[startDelim.end];
		const isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && delimiters[startDelim.end + 1].token === endDelim.token + 1;
		const ch = String.fromCharCode(startDelim.marker);
		const token_o = state.tokens[startDelim.token];
		token_o.type = isStrong ? "strong_open" : "em_open";
		token_o.tag = isStrong ? "strong" : "em";
		token_o.nesting = 1;
		token_o.markup = isStrong ? ch + ch : ch;
		token_o.content = "";
		const token_c = state.tokens[endDelim.token];
		token_c.type = isStrong ? "strong_close" : "em_close";
		token_c.tag = isStrong ? "strong" : "em";
		token_c.nesting = -1;
		token_c.markup = isStrong ? ch + ch : ch;
		token_c.content = "";
		if (isStrong) {
			state.tokens[delimiters[i - 1].token].content = "";
			state.tokens[delimiters[startDelim.end + 1].token].content = "";
			i--;
		}
	}
}
function emphasis_postProcess(state) {
	const tokens_meta = state.tokens_meta;
	const max = state.tokens_meta.length;
	postProcess$1(state, state.delimiters);
	for (let curr = 0; curr < max; curr++) if (tokens_meta[curr] && tokens_meta[curr].delimiters) postProcess$1(state, tokens_meta[curr].delimiters);
}
const emphasis = {
	tokenize: emphasis_tokenize,
	postProcess: emphasis_postProcess
};
/**
* Process html entity - &#123;, &#xAF;, &quot;, ...
*/
const DIGITAL_RE = /^&#(x[a-f0-9]{1,6}|\d{1,7});/i;
const NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
const entities = {
	amp: "&",
	lt: "<",
	gt: ">",
	quot: "\"",
	apos: "'",
	nbsp: "\xA0"
};
function isValidEntityCode(code$1) {
	if (code$1 >= 55296 && code$1 <= 57343) return false;
	if (code$1 >= 1114111) return false;
	return true;
}
function fromCodePoint(code$1) {
	return String.fromCodePoint(code$1);
}
function decodeHTML$1(str) {
	const match = str.match(/^&([a-z][a-z0-9]{1,31});/i);
	if (match && entities[match[1]]) return entities[match[1]];
	return str;
}
function entity(state, silent) {
	const pos = state.pos;
	const max = state.posMax;
	if (state.src.charCodeAt(pos) !== 38) return false;
	if (pos + 1 >= max) return false;
	if (state.src.charCodeAt(pos + 1) === 35) {
		const match = state.src.slice(pos).match(DIGITAL_RE);
		if (match) {
			if (!silent) {
				const code$1 = match[1][0].toLowerCase() === "x" ? Number.parseInt(match[1].slice(1), 16) : Number.parseInt(match[1], 10);
				const token = state.push("text_special", "", 0);
				token.content = isValidEntityCode(code$1) ? fromCodePoint(code$1) : fromCodePoint(65533);
				token.markup = match[0];
				token.info = "entity";
			}
			state.pos += match[0].length;
			return true;
		}
	} else {
		const match = state.src.slice(pos).match(NAMED_RE);
		if (match) {
			const decoded = decodeHTML$1(match[0]);
			if (decoded !== match[0]) {
				if (!silent) {
					const token = state.push("text_special", "", 0);
					token.content = decoded;
					token.markup = match[0];
					token.info = "entity";
				}
				state.pos += match[0].length;
				return true;
			}
		}
	}
	return false;
}
var entity_default = entity;
/**
* Inline rule: escape
* Process escaped characters
*/
const ESCAPED = (() => {
	const table$1 = new Array(256).fill(0);
	const chars = "\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-";
	for (let i = 0; i < 32; i++) table$1[chars.charCodeAt(i)] = 1;
	return table$1;
})();
function escape(state, silent) {
	const { pos, posMax, src } = state;
	if (src.charCodeAt(pos) !== 92) return false;
	const pos_next = pos + 1;
	if (pos_next >= posMax) return false;
	const ch = src.charCodeAt(pos_next);
	if (ch === 10) {
		if (!silent) state.push("hardbreak", "br", 0);
		state.pos += 2;
		return true;
	}
	let escapedStr = src[pos_next];
	let nextPos = pos_next;
	if (ch >= 55296 && ch <= 56319 && pos_next + 1 < posMax) {
		const ch2 = src.charCodeAt(pos_next + 1);
		if (ch2 >= 56320 && ch2 <= 57343) {
			escapedStr += src[pos_next + 1];
			nextPos++;
		}
	}
	const origStr = src[pos] + escapedStr;
	if (!silent) {
		const token = state.push("text_special", "", 0);
		if (ch < 256 && ESCAPED[ch]) token.content = escapedStr;
		else token.content = origStr;
		token.markup = origStr;
		token.info = "escape";
	}
	state.pos = nextPos + 1;
	return true;
}
var escape_default = escape;
function fragments_join(state) {
	let curr, last;
	let level = 0;
	const tokens = state.tokens;
	const max = state.tokens.length;
	for (curr = last = 0; curr < max; curr++) {
		const token = tokens[curr];
		if (!token) continue;
		if (token.nesting && token.nesting < 0) level--;
		token.level = level;
		if (token.nesting && token.nesting > 0) level++;
		if (token.type === "text" && curr + 1 < max && tokens[curr + 1]?.type === "text") tokens[curr + 1].content = token.content + tokens[curr + 1].content;
		else {
			if (curr !== last) tokens[last] = token;
			last++;
		}
	}
	if (curr !== last) tokens.length = last;
}
var fragments_join_default = fragments_join;
/**
* Process html tags
*/
const HTML_TAG_RE = /^<\/?[a-z][a-z0-9-]*(?:\s+[a-z_:][\w:.-]*(?:\s*=\s*(?:[^"'=<>`\s]+|'[^']*'|"[^"]*"))?)*\s*\/?>/i;
function isLinkOpen(str) {
	return /^<a[>\s]/i.test(str);
}
function isLinkClose(str) {
	return /^<\/a\s*>/i.test(str);
}
function isLetter(ch) {
	const lc = ch | 32;
	return lc >= 97 && lc <= 122;
}
function html_inline(state, silent) {
	if (!state.md.options.html) return false;
	const max = state.posMax;
	const pos = state.pos;
	if (state.src.charCodeAt(pos) !== 60 || pos + 2 >= max) return false;
	const ch = state.src.charCodeAt(pos + 1);
	if (ch !== 33 && ch !== 63 && ch !== 47 && !isLetter(ch)) return false;
	const match = state.src.slice(pos).match(HTML_TAG_RE);
	if (!match) return false;
	if (!silent) {
		const token = state.push("html_inline", "", 0);
		token.content = match[0];
		if (isLinkOpen(token.content)) state.linkLevel++;
		if (isLinkClose(token.content)) state.linkLevel--;
	}
	state.pos += match[0].length;
	return true;
}
var html_inline_default = html_inline;
function image(state, silent) {
	let code$1, content, label, pos, ref, res, title, start;
	let href = "";
	const oldPos = state.pos;
	const max = state.posMax;
	if (state.src.charCodeAt(state.pos) !== 33) return false;
	if (state.src.charCodeAt(state.pos + 1) !== 91) return false;
	const labelStart = state.pos + 2;
	const labelEnd = parse_link_label_default(state, state.pos + 1, false);
	if (labelEnd < 0) return false;
	pos = labelEnd + 1;
	if (pos < max && state.src.charCodeAt(pos) === 40) {
		pos++;
		for (; pos < max; pos++) {
			code$1 = state.src.charCodeAt(pos);
			if (code$1 !== 32 && code$1 !== 10) break;
		}
		if (pos >= max) return false;
		start = pos;
		res = parse_link_destination_default(state.src, pos, state.posMax);
		if (res.ok) {
			href = state.md.normalizeLink(res.str);
			if (state.md.validateLink(href)) pos = res.pos;
			else href = "";
			for (; pos < max; pos++) {
				code$1 = state.src.charCodeAt(pos);
				if (code$1 !== 32 && code$1 !== 10) break;
			}
			res = parse_link_title_default(state.src, pos, state.posMax);
			if (pos < max && res.ok) {
				title = res.str;
				pos = res.pos;
				for (; pos < max; pos++) {
					code$1 = state.src.charCodeAt(pos);
					if (code$1 !== 32 && code$1 !== 10) break;
				}
			} else title = "";
		}
		if (pos >= max || state.src.charCodeAt(pos) !== 41) {
			state.pos = oldPos;
			return false;
		}
		pos++;
	} else {
		if (typeof state.env.references === "undefined") return false;
		if (pos < max && state.src.charCodeAt(pos) === 91) {
			start = pos + 1;
			pos = parse_link_label_default(state, pos);
			if (pos >= 0) label = state.src.slice(start, pos++);
			else pos = labelEnd + 1;
		} else pos = labelEnd + 1;
		if (!label) label = state.src.slice(labelStart, labelEnd);
		ref = state.env.references[label && label.toLowerCase()];
		if (!ref) {
			state.pos = oldPos;
			return false;
		}
		href = ref.href;
		title = ref.title;
	}
	if (!silent) {
		content = state.src.slice(labelStart, labelEnd);
		const tokens = [];
		state.md.inline.parse(content, state.md, state.env, tokens);
		const token = state.push("image", "img", 0);
		token.attrs = [["src", href], ["alt", ""]];
		token.children = tokens;
		token.content = content;
		if (title) token.attrs.push(["title", title]);
	}
	state.pos = pos;
	state.posMax = max;
	return true;
}
var image_default = image;
function link(state, silent) {
	let code$1, label, res, ref;
	let href = "";
	let title = "";
	let start = state.pos;
	let parseReference = true;
	if (state.src.charCodeAt(state.pos) !== 91) return false;
	const oldPos = state.pos;
	const max = state.posMax;
	const labelStart = state.pos + 1;
	const labelEnd = parse_link_label_default(state, state.pos, true);
	if (labelEnd < 0) return false;
	let pos = labelEnd + 1;
	if (pos < max && state.src.charCodeAt(pos) === 40) {
		parseReference = false;
		pos++;
		for (; pos < max; pos++) {
			code$1 = state.src.charCodeAt(pos);
			if (code$1 !== 32 && code$1 !== 10) break;
		}
		if (pos >= max) return false;
		start = pos;
		res = parse_link_destination_default(state.src, pos, state.posMax);
		if (res.ok) {
			href = state.md.normalizeLink(res.str);
			if (state.md.validateLink(href)) pos = res.pos;
			else href = "";
			for (; pos < max; pos++) {
				code$1 = state.src.charCodeAt(pos);
				if (code$1 !== 32 && code$1 !== 10) break;
			}
			res = parse_link_title_default(state.src, pos, state.posMax);
			if (pos < max && res.ok) {
				title = res.str;
				pos = res.pos;
				for (; pos < max; pos++) {
					code$1 = state.src.charCodeAt(pos);
					if (code$1 !== 32 && code$1 !== 10) break;
				}
			}
		}
		if (pos >= max || state.src.charCodeAt(pos) !== 41) parseReference = true;
		pos++;
	}
	if (parseReference) {
		if (typeof state.env.references === "undefined") return false;
		if (pos < max && state.src.charCodeAt(pos) === 91) {
			start = pos + 1;
			pos = parse_link_label_default(state, pos);
			if (pos >= 0) label = state.src.slice(start, pos++);
			else pos = labelEnd + 1;
		} else pos = labelEnd + 1;
		if (!label) label = state.src.slice(labelStart, labelEnd);
		ref = state.env.references[label && label.toLowerCase()];
		if (!ref) {
			state.pos = oldPos;
			return false;
		}
		href = ref.href;
		title = ref.title;
	}
	if (!silent) {
		state.pos = labelStart;
		state.posMax = labelEnd;
		const token_o = state.push("link_open", "a", 1);
		const attrs = [["href", href]];
		token_o.attrs = attrs;
		if (title) attrs.push(["title", title]);
		state.linkLevel++;
		state.md.inline.tokenize(state);
		state.linkLevel--;
		state.push("link_close", "a", -1);
	}
	state.pos = pos;
	state.posMax = max;
	return true;
}
var link_default = link;
const SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function linkify$1(state, silent) {
	if (!state.md.options.linkify) return false;
	if (state.linkLevel > 0) return false;
	const pos = state.pos;
	const max = state.posMax;
	if (pos + 3 > max) return false;
	if (state.src.charCodeAt(pos) !== 58) return false;
	if (state.src.charCodeAt(pos + 1) !== 47) return false;
	if (state.src.charCodeAt(pos + 2) !== 47) return false;
	const match = state.pending.match(SCHEME_RE);
	if (!match) return false;
	const proto = match[1];
	const link$1 = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
	if (!link$1) return false;
	let url = link$1.url;
	if (url.length <= proto.length) return false;
	url = url.replace(/\*+$/, "");
	const fullUrl = state.md.normalizeLink(url);
	if (!state.md.validateLink(fullUrl)) return false;
	if (!silent) {
		state.pending = state.pending.slice(0, -proto.length);
		const token_o = state.push("link_open", "a", 1);
		token_o.attrs = [["href", fullUrl]];
		token_o.markup = "linkify";
		token_o.info = "auto";
		const token_t = state.push("text", "", 0);
		token_t.content = state.md.normalizeLinkText(url);
		const token_c = state.push("link_close", "a", -1);
		token_c.markup = "linkify";
		token_c.info = "auto";
	}
	state.pos += url.length - proto.length;
	return true;
}
/**
* Inline rule: newline
* Process newlines
*/
function newline(state, silent) {
	const { pos, src, posMax } = state;
	if (src.charCodeAt(pos) !== 10) return false;
	const pmax = state.pending.length - 1;
	const max = posMax;
	if (!silent) if (pmax >= 0 && state.pending.charCodeAt(pmax) === 32) if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 32) {
		let ws = pmax - 1;
		while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 32) ws--;
		state.pending = state.pending.slice(0, ws);
		state.push("hardbreak", "br", 0);
	} else {
		state.pending = state.pending.slice(0, -1);
		state.push("softbreak", "br", 0);
	}
	else state.push("softbreak", "br", 0);
	state.pos++;
	while (state.pos < max && src.charCodeAt(state.pos) === 32) state.pos++;
	return true;
}
var newline_default = newline;
function strikethrough_tokenize(state, silent) {
	const start = state.pos;
	const marker = state.src.charCodeAt(start);
	if (silent) return false;
	if (marker !== 126) return false;
	const scanned = state.scanDelims(state.pos, true);
	if (!scanned) return false;
	let len = scanned.length;
	const ch = String.fromCharCode(marker);
	if (len < 2) return false;
	let token;
	if (len % 2) {
		token = state.push("text", "", 0);
		token.content = ch;
		len--;
	}
	for (let i = 0; i < len; i += 2) {
		token = state.push("text", "", 0);
		token.content = ch + ch;
		state.delimiters.push({
			marker,
			length: 0,
			token: state.tokens.length - 1,
			end: -1,
			open: scanned.can_open,
			close: scanned.can_close
		});
	}
	state.pos += scanned.length;
	return true;
}
function postProcess(state, delimiters) {
	let token;
	const loneMarkers = [];
	const max = delimiters.length;
	for (let i = 0; i < max; i++) {
		const startDelim = delimiters[i];
		if (startDelim.marker !== 126) continue;
		if (startDelim.end === -1) continue;
		const endDelim = delimiters[startDelim.end];
		token = state.tokens[startDelim.token];
		token.type = "s_open";
		token.tag = "s";
		token.nesting = 1;
		token.markup = "~~";
		token.content = "";
		token = state.tokens[endDelim.token];
		token.type = "s_close";
		token.tag = "s";
		token.nesting = -1;
		token.markup = "~~";
		token.content = "";
		if (state.tokens[endDelim.token - 1].type === "text" && state.tokens[endDelim.token - 1].content === "~") loneMarkers.push(endDelim.token - 1);
	}
	while (loneMarkers.length) {
		const i = loneMarkers.pop();
		let j = i + 1;
		while (j < state.tokens.length && state.tokens[j].type === "s_close") j++;
		j--;
		if (i !== j) {
			token = state.tokens[j];
			state.tokens[j] = state.tokens[i];
			state.tokens[i] = token;
		}
	}
}
function strikethrough_postProcess(state) {
	const delimiters = state.delimiters;
	postProcess(state, delimiters);
	const tokens_meta = state.tokens_meta;
	if (tokens_meta) {
		for (let curr = 0; curr < tokens_meta.length; curr++) if (tokens_meta[curr] && tokens_meta[curr].delimiters) postProcess(state, tokens_meta[curr].delimiters);
	}
}
const strikethrough = {
	tokenize: strikethrough_tokenize,
	postProcess: strikethrough_postProcess
};
/**
* Inline rule: text
* Skip text characters for text token, place those to pending buffer
* and increment current pos
*/
function isTerminatorChar(ch) {
	switch (ch) {
		case 10:
		case 33:
		case 35:
		case 36:
		case 37:
		case 38:
		case 42:
		case 43:
		case 45:
		case 58:
		case 60:
		case 61:
		case 62:
		case 64:
		case 91:
		case 92:
		case 93:
		case 94:
		case 95:
		case 96:
		case 123:
		case 125:
		case 126: return true;
		default: return false;
	}
}
function text(state, silent) {
	let pos = state.pos;
	while (pos < state.posMax && !isTerminatorChar(state.src.charCodeAt(pos))) pos++;
	if (pos === state.pos) return false;
	if (!silent) state.pending += state.src.slice(state.pos, pos);
	state.pos = pos;
	return true;
}
var text_default = text;
var InlineRuler = class {
	rules = [];
	cache = null;
	invalidateCache() {
		this.cache = null;
	}
	/**
	* Push new rule to the end of chain
	*/
	push(name, fn, options) {
		const idx = this.rules.findIndex((r) => r.name === name);
		if (idx >= 0) this.rules.splice(idx, 1);
		this.rules.push({
			name,
			fn,
			alt: options?.alt || [],
			enabled: true
		});
		this.invalidateCache();
	}
	at(name) {
		return this.rules.find((rule) => rule.name === name);
	}
	before(beforeName, name, fn, options) {
		const i = this.rules.findIndex((r) => r.name === beforeName);
		if (i < 0) throw new Error(`Parser rule not found: ${beforeName}`);
		const exists = this.rules.findIndex((r) => r.name === name);
		if (exists >= 0) this.rules.splice(exists, 1);
		this.rules.splice(i, 0, {
			name,
			fn,
			alt: options?.alt || [],
			enabled: true
		});
		this.invalidateCache();
	}
	after(afterName, name, fn, options) {
		const i = this.rules.findIndex((r) => r.name === afterName);
		if (i < 0) throw new Error(`Parser rule not found: ${afterName}`);
		const exists = this.rules.findIndex((r) => r.name === name);
		if (exists >= 0) this.rules.splice(exists, 1);
		this.rules.splice(i + 1, 0, {
			name,
			fn,
			alt: options?.alt || [],
			enabled: true
		});
		this.invalidateCache();
	}
	enable(names, ignoreInvalid) {
		const list$1 = Array.isArray(names) ? names : [names];
		const changed = [];
		for (const n of list$1) {
			const idx = this.rules.findIndex((r) => r.name === n);
			if (idx < 0) {
				if (!ignoreInvalid) throw new Error(`Rules manager: invalid rule name ${n}`);
				continue;
			}
			if (!this.rules[idx].enabled) {
				this.rules[idx].enabled = true;
				changed.push(n);
			}
		}
		if (changed.length) this.invalidateCache();
		return changed;
	}
	disable(names, ignoreInvalid) {
		const list$1 = Array.isArray(names) ? names : [names];
		const changed = [];
		for (const n of list$1) {
			const idx = this.rules.findIndex((r) => r.name === n);
			if (idx < 0) {
				if (!ignoreInvalid) throw new Error(`Rules manager: invalid rule name ${n}`);
				continue;
			}
			if (this.rules[idx].enabled) {
				this.rules[idx].enabled = false;
				changed.push(n);
			}
		}
		if (changed.length) this.invalidateCache();
		return changed;
	}
	enableOnly(names) {
		const allow = new Set(names);
		let changed = false;
		for (const r of this.rules) {
			const next = allow.has(r.name);
			if (r.enabled !== next) {
				r.enabled = next;
				changed = true;
			}
		}
		if (changed) this.invalidateCache();
	}
	/**
	* Get rules for specified chain name (or empty string for default)
	*/
	getRules(chainName) {
		const chain = chainName || "";
		if (!this.cache) this.compileCache();
		return this.cache.get(chain) ?? [];
	}
	compileCache() {
		const chains = new Set([""]);
		for (const rule of this.rules) {
			if (!rule.enabled) continue;
			if (rule.alt) for (const alt of rule.alt) chains.add(alt);
		}
		const cache = /* @__PURE__ */ new Map();
		for (const chain of chains) {
			const bucket = [];
			for (const rule of this.rules) {
				if (!rule.enabled) continue;
				if (chain !== "" && !rule.alt?.includes(chain)) continue;
				bucket.push(rule.fn);
			}
			cache.set(chain, bucket);
		}
		this.cache = cache;
	}
};
/**
* StateInline - state object for inline parser
*/
var StateInline = class {
	src;
	md;
	env;
	outTokens;
	tokens;
	tokens_meta;
	pos;
	posMax;
	level;
	pending;
	pendingLevel;
	cache;
	delimiters;
	_prev_delimiters;
	backticks;
	backticksScanned;
	linkLevel;
	Token;
	constructor(src, md, env, outTokens) {
		this.src = src;
		this.md = md;
		this.env = env;
		this.outTokens = outTokens;
		this.tokens = outTokens;
		this.tokens_meta = new Array(outTokens.length);
		this.pos = 0;
		this.posMax = src.length;
		this.level = 0;
		this.pending = "";
		this.pendingLevel = 0;
		this.cache = {};
		this.delimiters = [];
		this._prev_delimiters = [];
		this.backticks = {};
		this.backticksScanned = false;
		this.linkLevel = 0;
		this.Token = Token;
	}
	/**
	* Push pending text as a text token
	*/
	pushPending() {
		const token = new Token("text", "", 0);
		token.content = this.pending;
		token.level = this.pendingLevel;
		this.tokens.push(token);
		this.tokens_meta.push(null);
		this.pending = "";
		return token;
	}
	/**
	* Push a new token to the output
	*/
	push(type, tag, nesting) {
		if (this.pending) this.pushPending();
		const token = new Token(type, tag, nesting);
		token.level = this.level;
		let token_meta = null;
		if (nesting < 0) {
			this.level--;
			this.delimiters = this._prev_delimiters.pop() || [];
		}
		token.level = this.level;
		if (nesting > 0) {
			this.level++;
			this._prev_delimiters.push(this.delimiters);
			this.delimiters = [];
			token_meta = { delimiters: this.delimiters };
		}
		this.pendingLevel = this.level;
		this.tokens.push(token);
		this.tokens_meta.push(token_meta);
		return token;
	}
	/**
	* Scan delimiter run (for emphasis)
	*/
	scanDelims(start, canSplitWord) {
		const { src, posMax } = this;
		const marker = src.charCodeAt(start);
		let pos = start;
		while (pos < posMax && src.charCodeAt(pos) === marker) pos++;
		const count = pos - start;
		if (count < 1) return null;
		const lastChar = start > 0 ? src.charCodeAt(start - 1) : 32;
		const nextChar = pos < posMax ? src.charCodeAt(pos) : 32;
		const isLastPunctChar = isMdAsciiPunct(lastChar) || isPunctChar(String.fromCharCode(lastChar));
		const isNextPunctChar = isMdAsciiPunct(nextChar) || isPunctChar(String.fromCharCode(nextChar));
		const isLastWhiteSpace = isWhiteSpace(lastChar);
		const isNextWhiteSpace = isWhiteSpace(nextChar);
		const left_flanking = !isNextWhiteSpace && (!isNextPunctChar || isLastWhiteSpace || isLastPunctChar);
		const right_flanking = !isLastWhiteSpace && (!isLastPunctChar || isNextWhiteSpace || isNextPunctChar);
		return {
			can_open: left_flanking && (canSplitWord || !right_flanking || isLastPunctChar),
			can_close: right_flanking && (canSplitWord || !left_flanking || isNextPunctChar),
			length: count
		};
	}
};
/**
* ParserInline - inline parser with Ruler-based rule management
*/
var ParserInline = class {
	ruler;
	ruler2;
	constructor() {
		this.ruler = new InlineRuler();
		this.ruler2 = new InlineRuler();
		this.ruler.push("text", text_default);
		this.ruler.push("linkify", linkify$1);
		this.ruler.push("newline", newline_default);
		this.ruler.push("escape", escape_default);
		this.ruler.push("backticks", backticks_default);
		this.ruler.push("strikethrough", strikethrough.tokenize);
		this.ruler.push("emphasis", emphasis.tokenize);
		this.ruler.push("link", link_default);
		this.ruler.push("image", image_default);
		this.ruler.push("autolink", autolink_default);
		this.ruler.push("html_inline", html_inline_default);
		this.ruler.push("entity", entity_default);
		this.ruler2.push("balance_pairs", balance_pairs_default);
		this.ruler2.push("strikethrough", strikethrough.postProcess);
		this.ruler2.push("emphasis", emphasis.postProcess);
		this.ruler2.push("fragments_join", fragments_join_default);
	}
	/**
	* Skip single token by running all rules in validation mode
	*/
	skipToken(state) {
		const pos = state.pos;
		const rules = this.ruler.getRules("");
		const len = rules.length;
		const posMax = state.posMax;
		const maxNesting = state.md?.options?.maxNesting || 100;
		if (typeof state.cache[pos] !== "undefined") {
			state.pos = state.cache[pos];
			return;
		}
		let ok = false;
		if (state.level < maxNesting) for (let i = 0; i < len; i++) {
			state.level++;
			ok = rules[i](state, true);
			state.level--;
			if (ok) {
				if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
				break;
			}
		}
		else state.pos = posMax;
		if (!ok) state.pos++;
		state.cache[pos] = state.pos;
	}
	/**
	* Generate tokens for input string
	*/
	tokenize(state) {
		const rules = this.ruler.getRules("");
		const len = rules.length;
		const end = state.posMax;
		const maxNesting = state.md?.options?.maxNesting || 100;
		while (state.pos < end) {
			const prevPos = state.pos;
			let ok = false;
			if (state.level < maxNesting) for (let i = 0; i < len; i++) {
				ok = rules[i](state, false);
				if (ok) {
					if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
					break;
				}
			}
			if (ok) {
				if (state.pos >= end) break;
				continue;
			}
			state.pending += state.src[state.pos++];
		}
		if (state.pending) state.pushPending();
	}
	/**
	* ParserInline.parse(str, md, env, outTokens)
	*
	* Process input string and push inline tokens into `outTokens`.
	* Matches the signature from original markdown-it/lib/parser_inline.mjs
	*/
	parse(str, md, env, outTokens) {
		const state = new StateInline(str, md, env, outTokens);
		this.tokenize(state);
		const rules2 = this.ruler2.getRules("");
		const len = rules2.length;
		for (let i = 0; i < len; i++) rules2[i](state, false);
	}
};
var State = class {
	src;
	env;
	tokens;
	inlineMode;
	md;
	Token;
	constructor(src, md, env = {}) {
		this.src = src || "";
		this.env = env;
		this.tokens = [];
		this.inlineMode = false;
		this.md = md;
		this.Token = Token;
	}
};
const CORE_RULES = [
	["normalize", normalize],
	["block", block],
	["inline", inline],
	["linkify", linkify],
	["replacements", replacements],
	["smartquotes", smartquotes],
	["text_join", text_join]
];
const DEFAULT_OPTIONS_TEMPLATE = {
	html: false,
	xhtmlOut: false,
	breaks: false,
	langPrefix: "language-",
	linkify: false,
	typographer: false,
	quotes: "“”‘’",
	maxNesting: 100
};
const DEFAULT_HELPERS = {
	parseLinkLabel,
	parseLinkDestination,
	parseLinkTitle
};
function cloneDefaultOptions() {
	return { ...DEFAULT_OPTIONS_TEMPLATE };
}
function cloneDefaultHelpers() {
	return { ...DEFAULT_HELPERS };
}
var ParserCore = class {
	fallbackParser;
	lastState = null;
	block;
	inline;
	ruler;
	linkifyInstance = null;
	cachedCoreRules = null;
	constructor() {
		this.block = new ParserBlock();
		this.inline = new ParserInline();
		this.ruler = new CoreRuler();
		for (let i = 0; i < CORE_RULES.length; i++) {
			const [name, rule] = CORE_RULES[i];
			this.ruler.push(name, rule);
		}
		this.fallbackParser = {
			block: this.block,
			inline: this.inline,
			core: this,
			options: cloneDefaultOptions(),
			helpers: cloneDefaultHelpers(),
			normalizeLink,
			normalizeLinkText,
			validateLink,
			linkify: null
		};
	}
	resolveParser(md) {
		if (md) return md;
		if (!this.linkifyInstance) this.linkifyInstance = new linkify_it_default();
		if (this.fallbackParser.block !== this.block) this.fallbackParser.block = this.block;
		if (this.fallbackParser.inline !== this.inline) this.fallbackParser.inline = this.inline;
		this.fallbackParser.core = this;
		this.fallbackParser.linkify = this.linkifyInstance;
		return this.fallbackParser;
	}
	createState(src, env = {}, md) {
		return new State(src, this.resolveParser(md), env);
	}
	process(state) {
		if (!this.cachedCoreRules) this.cachedCoreRules = this.ruler.getRules("");
		const rules = this.cachedCoreRules;
		for (let i = 0; i < rules.length; i++) rules[i](state);
	}
	parse(src, env = {}, md) {
		if (typeof src !== "string") throw new TypeError("Input data should be a String");
		const state = this.createState(src, env, md);
		this.process(state);
		this.lastState = state;
		return state;
	}
	getTokens() {
		return this.lastState ? this.lastState.tokens : [];
	}
};
var commonmark_default = { options: {
	html: false,
	xhtmlOut: false,
	breaks: false,
	langPrefix: "language-",
	linkify: false,
	typographer: false
} };
var default_default = {
	options: {
		html: false,
		xhtmlOut: false,
		breaks: false,
		langPrefix: "language-",
		linkify: false,
		typographer: false,
		quotes: "“”‘’",
		highlight: null,
		maxNesting: 100
	},
	components: {
		core: {},
		block: {},
		inline: {}
	}
};
var zero_default = {
	options: {
		html: false,
		xhtmlOut: false,
		breaks: false,
		langPrefix: "language-",
		linkify: false,
		typographer: false,
		quotes: "“”‘’",
		maxNesting: 20
	},
	components: {
		core: { rules: [
			"normalize",
			"block",
			"inline",
			"text_join"
		] },
		block: { rules: ["paragraph"] },
		inline: { rules: ["text"] },
		inline2: { rules: ["balance_pairs", "fragments_join"] }
	}
};
/**
* Common utility functions for escaping HTML and unescaping entities
*/
const HTML_ESCAPE_TEST_RE = /[&<>"]/;
const HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
const HTML_REPLACEMENTS = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;"
};
function replaceUnsafeChar(ch) {
	return HTML_REPLACEMENTS[ch] || ch;
}
/**
* Escape HTML characters to prevent XSS
*/
function escapeHtml(str) {
	if (HTML_ESCAPE_TEST_RE.test(str)) return str.replace(HTML_ESCAPE_REPLACE_RE, replaceUnsafeChar);
	return str;
}
const UNESCAPE_ALL_RE = new RegExp(`${/\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g.source}|${/&([a-z#][a-z0-9]{1,31});/gi.source}`, "gi");
const DIGITAL_ENTITY_TEST_RE = /^#(?:x[a-f0-9]{1,8}|\d{1,8})$/i;
/**
* Unescape all backslash escapes and HTML entities
*/
function unescapeAll(str) {
	if (!str.includes("\\") && !str.includes("&")) return str;
	return str.replace(UNESCAPE_ALL_RE, (match, escaped, entity$1) => {
		if (escaped) return escaped;
		if (DIGITAL_ENTITY_TEST_RE.test(entity$1)) {
			const code$1 = entity$1[1].toLowerCase() === "x" ? Number.parseInt(entity$1.slice(2), 16) : Number.parseInt(entity$1.slice(1), 10);
			if (code$1 >= 55296 && code$1 <= 57343) return "�";
			if (code$1 >= 128 && code$1 <= 159) return "�";
			return String.fromCodePoint(code$1);
		}
		return match;
	});
}
function isPromiseLike(value) {
	return !!value && (typeof value === "object" || typeof value === "function") && typeof value.then === "function";
}
function ensureSyncResult(value, ruleName) {
	if (isPromiseLike(value)) throw new TypeError(`Renderer rule "${ruleName}" returned a Promise. Use renderAsync() instead.`);
	return value;
}
const resolveResult = (value) => isPromiseLike(value) ? value : Promise.resolve(value);
function renderFence(token, highlighted, info, langName, options, self) {
	if (highlighted.startsWith("<pre")) return `${highlighted}\n`;
	if (info) {
		const classIndex = typeof token.attrIndex === "function" ? token.attrIndex("class") : -1;
		const tmpAttrs = token.attrs ? token.attrs.map((attr) => attr.slice()) : [];
		const langClass = `${options.langPrefix || "language-"}${langName}`;
		if (classIndex < 0) tmpAttrs.push(["class", langClass]);
		else tmpAttrs[classIndex][1] += ` ${langClass}`;
		const tmpToken = {
			...token,
			attrs: tmpAttrs
		};
		return `<pre><code${self.renderAttrs(tmpToken)}>${highlighted}</code></pre>\n`;
	}
	return `<pre><code${self.renderAttrs(token)}>${highlighted}</code></pre>\n`;
}
const DEFAULT_RENDERER_OPTIONS = {
	langPrefix: "language-",
	xhtmlOut: false,
	breaks: false
};
const hasOwn = Object.prototype.hasOwnProperty;
const defaultRules = {
	code_inline(tokens, idx, _options, _env, self) {
		const token = tokens[idx];
		return `<code${self.renderAttrs(token)}>${escapeHtml(token.content)}</code>`;
	},
	code_block(tokens, idx, _options, _env, self) {
		const token = tokens[idx];
		return `<pre${self.renderAttrs(token)}><code>${escapeHtml(token.content)}</code></pre>\n`;
	},
	fence(tokens, idx, options, _env, self) {
		const token = tokens[idx];
		const info = token.info ? unescapeAll(token.info).trim() : "";
		let langName = "";
		let langAttrs = "";
		if (info) {
			const parts = info.split(/(\s+)/g);
			langName = parts[0];
			langAttrs = parts.slice(2).join("");
		}
		const highlight = options.highlight;
		const fallback = () => escapeHtml(token.content);
		if (!highlight) return renderFence(token, fallback(), info, langName, options, self);
		const highlighted = highlight(token.content, langName, langAttrs);
		if (isPromiseLike(highlighted)) return highlighted.then((res) => renderFence(token, res || fallback(), info, langName, options, self));
		return renderFence(token, highlighted || fallback(), info, langName, options, self);
	},
	image(tokens, idx, options, env, self) {
		const token = tokens[idx];
		const altText = self.renderInlineAsText(token.children || [], options, env);
		if (typeof token.attrIndex === "function") {
			const altIndex = token.attrIndex("alt");
			if (altIndex >= 0 && token.attrs) token.attrs[altIndex][1] = altText;
			else if (token.attrs) token.attrs.push(["alt", altText]);
			else token.attrs = [["alt", altText]];
		}
		return self.renderToken(tokens, idx, options);
	},
	hardbreak(_tokens, _idx, options) {
		return options.xhtmlOut ? "<br />\n" : "<br>\n";
	},
	softbreak(_tokens, _idx, options) {
		return options.breaks ? options.xhtmlOut ? "<br />\n" : "<br>\n" : "\n";
	},
	text(tokens, idx) {
		return escapeHtml(tokens[idx].content);
	},
	text_special(tokens, idx) {
		return escapeHtml(tokens[idx].content);
	},
	html_block(tokens, idx) {
		return tokens[idx].content;
	},
	html_inline(tokens, idx) {
		return tokens[idx].content;
	}
};
var Renderer = class {
	rules;
	baseOptions;
	normalizedBase;
	constructor(options = {}) {
		this.baseOptions = { ...options };
		this.normalizedBase = this.buildNormalizedBase();
		this.rules = { ...defaultRules };
	}
	set(options) {
		this.baseOptions = {
			...this.baseOptions,
			...options
		};
		this.normalizedBase = this.buildNormalizedBase();
		return this;
	}
	render(tokens, options, env) {
		if (!Array.isArray(tokens)) throw new TypeError("render expects token array as first argument");
		const merged = this.mergeOptions(options);
		const envRef = env ?? {};
		let output = "";
		for (let i = 0; i < tokens.length; i++) {
			const token = tokens[i];
			if (token.type === "inline") {
				output += this.renderInlineTokens(token.children || [], merged, envRef);
				continue;
			}
			const rule = this.rules[token.type];
			if (rule) output += ensureSyncResult(rule(tokens, i, merged, envRef, this), token.type);
			else output += this.renderToken(tokens, i, merged);
		}
		return output;
	}
	async renderAsync(tokens, options, env) {
		if (!Array.isArray(tokens)) throw new TypeError("render expects token array as first argument");
		const merged = this.mergeOptions(options);
		const envRef = env ?? {};
		let output = "";
		for (let i = 0; i < tokens.length; i++) {
			const token = tokens[i];
			if (token.type === "inline") {
				output += await this.renderInlineTokensAsync(token.children || [], merged, envRef);
				continue;
			}
			const rule = this.rules[token.type];
			if (rule) output += await resolveResult(rule(tokens, i, merged, envRef, this));
			else output += this.renderToken(tokens, i, merged);
		}
		return output;
	}
	renderInline(tokens, options, env) {
		const merged = this.mergeOptions(options);
		const envRef = env ?? {};
		return this.renderInlineTokens(tokens, merged, envRef);
	}
	async renderInlineAsync(tokens, options, env) {
		const merged = this.mergeOptions(options);
		const envRef = env ?? {};
		return this.renderInlineTokensAsync(tokens, merged, envRef);
	}
	renderInlineAsText(tokens, options, env) {
		const merged = this.mergeOptions(options);
		const envRef = env ?? {};
		return this.renderInlineAsTextInternal(tokens, merged, envRef);
	}
	renderAttrs(token) {
		if (!token.attrs || token.attrs.length === 0) return "";
		let result = "";
		for (let i = 0; i < token.attrs.length; i++) {
			const attr = token.attrs[i];
			result += ` ${escapeHtml(attr[0])}="${escapeHtml(attr[1])}"`;
		}
		return result;
	}
	renderToken(tokens, idx, options) {
		const token = tokens[idx];
		if (token.hidden) return "";
		let result = "";
		if (token.block && token.nesting !== -1 && idx > 0 && tokens[idx - 1].hidden) result += "\n";
		result += token.nesting === -1 ? `</${token.tag}` : `<${token.tag}`;
		result += this.renderAttrs(token);
		if (token.nesting === 0 && options.xhtmlOut) result += " /";
		let needLineFeed = false;
		if (token.block) {
			needLineFeed = true;
			if (token.nesting === 1 && idx + 1 < tokens.length) {
				const nextToken = tokens[idx + 1];
				if (nextToken.type === "inline" || nextToken.hidden) needLineFeed = false;
				else if (nextToken.nesting === -1 && nextToken.tag === token.tag) needLineFeed = false;
			}
		}
		result += needLineFeed ? ">\n" : ">";
		return result;
	}
	mergeOptions(overrides) {
		const base$1 = this.normalizedBase;
		if (!overrides) return base$1;
		let merged = null;
		const ensureMerged = () => {
			if (!merged) merged = { ...base$1 };
			return merged;
		};
		if (hasOwn.call(overrides, "highlight") && overrides.highlight !== base$1.highlight) ensureMerged().highlight = overrides.highlight;
		if (hasOwn.call(overrides, "langPrefix")) {
			const value = overrides.langPrefix;
			if (value !== base$1.langPrefix) ensureMerged().langPrefix = value;
		}
		if (hasOwn.call(overrides, "xhtmlOut")) {
			const value = overrides.xhtmlOut;
			if (value !== base$1.xhtmlOut) ensureMerged().xhtmlOut = value;
		}
		if (hasOwn.call(overrides, "breaks")) {
			const value = overrides.breaks;
			if (value !== base$1.breaks) ensureMerged().breaks = value;
		}
		return merged || base$1;
	}
	buildNormalizedBase() {
		return Object.freeze({
			...DEFAULT_RENDERER_OPTIONS,
			...this.baseOptions
		});
	}
	renderInlineTokens(tokens, options, env) {
		if (!tokens || tokens.length === 0) return "";
		let output = "";
		for (let i = 0; i < tokens.length; i++) {
			const token = tokens[i];
			const rule = this.rules[token.type];
			if (rule) output += ensureSyncResult(rule(tokens, i, options, env, this), token.type);
			else output += this.renderToken(tokens, i, options);
		}
		return output;
	}
	async renderInlineTokensAsync(tokens, options, env) {
		if (!tokens || tokens.length === 0) return "";
		let output = "";
		for (let i = 0; i < tokens.length; i++) {
			const token = tokens[i];
			const rule = this.rules[token.type];
			if (rule) output += await resolveResult(rule(tokens, i, options, env, this));
			else output += this.renderToken(tokens, i, options);
		}
		return output;
	}
	renderInlineAsTextInternal(tokens, options, env) {
		if (!tokens || tokens.length === 0) return "";
		let output = "";
		for (let i = 0; i < tokens.length; i++) {
			const token = tokens[i];
			switch (token.type) {
				case "text":
				case "text_special":
					output += token.content;
					break;
				case "image":
					output += this.renderInlineAsTextInternal(token.children || [], options, env);
					break;
				case "html_inline":
				case "html_block":
					output += token.content;
					break;
				case "softbreak":
				case "hardbreak":
					output += "\n";
					break;
				default: break;
			}
		}
		return output;
	}
};
var renderer_default = Renderer;
const DEFAULTS = {
	maxChunkChars: 1e4,
	maxChunkLines: 200,
	fenceAware: true,
	maxChunks: void 0
};
/**
* Chunk a markdown document on reasonably safe boundaries (blank-line separated)
* and parse each chunk separately, then merge token streams with line map offsets.
*
* This is experimental and aims to speed up very large documents by reducing the
* cost of parsing one huge string at once, at the price of some orchestration.
*/
function chunkedParse(md, src, env = {}, opts) {
	const options = {
		...DEFAULTS,
		...opts || {}
	};
	let chunks = splitIntoChunks(src, options);
	if (options.maxChunks && chunks.length > options.maxChunks) {
		const keep = options.maxChunks - 1;
		const head = chunks.slice(0, keep);
		const tailMerged = chunks.slice(keep).join("\n");
		chunks = [...head, tailMerged];
	}
	let lineOffset = 0;
	const out = [];
	try {
		env.__mdtsChunkInfo = {
			count: chunks.length,
			maxChunkChars: options.maxChunkChars,
			maxChunkLines: options.maxChunkLines
		};
	} catch {}
	for (const ch of chunks) {
		const tokens = md.core.parse(ch, env, md).tokens;
		if (lineOffset !== 0 && tokens.length) shiftTokenLines(tokens, lineOffset);
		out.push(...tokens);
		lineOffset += countLines(ch);
	}
	return out;
}
/**
* Split text into chunks by blank lines without breaking fenced code blocks.
* Keeps chunk sizes under maxChunkChars/maxChunkLines where possible.
*/
function splitIntoChunks(src, opts) {
	const lines = src.split("\n");
	const chunks = [];
	let buf = [];
	let charCount = 0;
	let lineCount = 0;
	let sinceBlankLines = 0;
	let sinceBlankChars = 0;
	let inFence = null;
	function flush() {
		if (buf.length > 0) {
			chunks.push(buf.join("\n"));
			buf = [];
			charCount = 0;
			lineCount = 0;
		}
	}
	for (let i = 0; i < lines.length; i++) {
		const line = lines[i];
		const trimmed = line.trim();
		if (opts.fenceAware) {
			let p = 0;
			while (p < line.length) {
				const c = line.charCodeAt(p);
				if (c === 32 || c === 9) p++;
				else break;
			}
			const ch = line[p];
			if (ch === "`" || ch === "~") {
				let q = p;
				while (q < line.length && line[q] === ch) q++;
				const runLen = q - p;
				if (runLen >= 3) {
					if (!inFence) inFence = {
						marker: ch,
						length: runLen
					};
					else if (inFence.marker === ch && runLen >= inFence.length) inFence = null;
				}
			}
		}
		buf.push(line);
		const lineWithNlLen = line.length + 1;
		charCount += lineWithNlLen;
		lineCount += 1;
		if (trimmed.length === 0) {
			sinceBlankLines = 0;
			sinceBlankChars = 0;
		} else {
			sinceBlankLines += 1;
			sinceBlankChars += lineWithNlLen;
		}
		const atBlankBoundary = trimmed.length === 0;
		if ((charCount >= opts.maxChunkChars || lineCount >= opts.maxChunkLines) && !inFence) if (atBlankBoundary) flush();
		else {
			const maxSinceBlankLines = Math.max(10, Math.floor(opts.maxChunkLines * .5));
			const maxSinceBlankChars = Math.max(opts.maxChunkChars, 8e3);
			if (sinceBlankLines >= maxSinceBlankLines || sinceBlankChars >= maxSinceBlankChars) flush();
		}
	}
	flush();
	return chunks;
}
function shiftTokenLines(tokens, offset) {
	if (offset === 0) return;
	const stack = [...tokens];
	while (stack.length) {
		const t = stack.pop();
		if (t.map) {
			t.map[0] += offset;
			t.map[1] += offset;
		}
		if (t.children) for (let i = t.children.length - 1; i >= 0; i--) stack.push(t.children[i]);
	}
}
const EMPTY_TOKENS = [];
function makeEmptyStats() {
	return {
		total: 0,
		cacheHits: 0,
		appendHits: 0,
		fullParses: 0,
		resets: 0,
		chunkedParses: 0,
		lastMode: "idle"
	};
}
var StreamParser = class {
	core;
	cache = null;
	stats = makeEmptyStats();
	MIN_SIZE_FOR_OPTIMIZATION = 1e3;
	DEFAULT_SKIP_CACHE_CHARS = 6e5;
	DEFAULT_SKIP_CACHE_LINES = 1e4;
	MAX_CHUNKS_FOR_FALLBACK = 24;
	MAX_CHUNKED_DOC_CHARS = 12e4;
	constructor(core) {
		this.core = core;
	}
	reset() {
		this.cache = null;
		this.stats.resets += 1;
		this.stats.lastMode = "reset";
	}
	resetStats() {
		const { resets } = this.stats;
		this.stats = makeEmptyStats();
		this.stats.resets = resets;
	}
	parse(src, env, md) {
		const envProvided = env;
		const cached = this.cache;
		if (!cached || envProvided && envProvided !== cached.env) {
			const workingEnv = envProvided ?? {};
			const chunkedEnabled$1 = !!md.options?.streamChunkedFallback;
			const chunkAdaptive$1 = md.options?.streamChunkAdaptive !== false;
			const targetChunks$1 = md.options?.streamChunkTargetChunks ?? 8;
			const chunkSizeCharsCfg$1 = md.options?.streamChunkSizeChars;
			const chunkSizeLinesCfg$1 = md.options?.streamChunkSizeLines;
			const auto$1 = md.options?.autoTuneChunks !== false;
			const chunkFenceAware$1 = md.options?.streamChunkFenceAware ?? true;
			const skipCacheChars = md.options?.streamSkipCacheAboveChars ?? this.DEFAULT_SKIP_CACHE_CHARS;
			const skipCacheLines = md.options?.streamSkipCacheAboveLines ?? this.DEFAULT_SKIP_CACHE_LINES;
			let srcLineCount;
			let isVeryLargeOneShot = src.length >= skipCacheChars;
			if (!isVeryLargeOneShot && skipCacheLines !== void 0) {
				srcLineCount = countLines(src);
				isVeryLargeOneShot = srcLineCount >= skipCacheLines;
			}
			if (isVeryLargeOneShot) {
				const tokens$1 = this.core.parse(src, workingEnv, md).tokens;
				this.stats.total += 1;
				this.stats.fullParses += 1;
				this.stats.lastMode = "full";
				return tokens$1;
			} else if (chunkedEnabled$1 && src.length < this.MAX_CHUNKED_DOC_CHARS) {
				const clamp$1 = (v, lo, hi) => v < lo ? lo : v > hi ? hi : v;
				if (srcLineCount === void 0) srcLineCount = countLines(src);
				let useChars = chunkAdaptive$1 ? clamp$1(Math.ceil(src.length / targetChunks$1), 8e3, 32e3) : chunkSizeCharsCfg$1 ?? 1e4;
				let useLines = chunkAdaptive$1 ? clamp$1(Math.ceil(srcLineCount / targetChunks$1), 150, 350) : chunkSizeLinesCfg$1 ?? 200;
				if (auto$1 && !chunkSizeCharsCfg$1 && !chunkSizeLinesCfg$1) if (src.length <= 5e3) {
					useChars = 16e3;
					useLines = 250;
				} else if (src.length <= 2e4) {
					useChars = 16e3;
					useLines = 200;
				} else if (src.length <= 5e4) {
					useChars = 16e3;
					useLines = 250;
				} else if (src.length <= 1e5) {
					useChars = 1e4;
					useLines = 200;
				} else {
					useChars = 2e4;
					useLines = 200;
				}
				const hasTrailingNewline = src.length > 0 && src.charCodeAt(src.length - 1) === 10;
				const estimatedChunks = Math.ceil(src.length / useChars);
				if ((src.length >= useChars * 2 || srcLineCount >= useLines * 2) && hasTrailingNewline && estimatedChunks <= this.MAX_CHUNKS_FOR_FALLBACK) {
					const tokens$1 = chunkedParse(md, src, workingEnv, {
						maxChunkChars: useChars,
						maxChunkLines: useLines,
						fenceAware: chunkFenceAware$1
					});
					this.cache = {
						src,
						tokens: tokens$1,
						env: workingEnv,
						lineCount: srcLineCount
					};
					this.stats.total += 1;
					this.stats.chunkedParses = (this.stats.chunkedParses || 0) + 1;
					this.stats.lastMode = "chunked";
					return tokens$1;
				}
			}
			const tokens = this.core.parse(src, workingEnv, md).tokens;
			this.cache = {
				src,
				tokens,
				env: workingEnv,
				lineCount: srcLineCount
			};
			this.stats.total += 1;
			this.stats.fullParses += 1;
			this.stats.lastMode = "full";
			return tokens;
		}
		if (src === cached.src) {
			this.stats.total += 1;
			this.stats.cacheHits += 1;
			this.stats.lastMode = "cache";
			return cached.tokens;
		}
		const threshold = md.options?.streamOptimizationMinSize ?? this.MIN_SIZE_FOR_OPTIMIZATION;
		if (cached.src.length < threshold && src.length < threshold * 1.5 && !src.startsWith(cached.src)) {
			const fallbackEnv$1 = envProvided ?? cached.env;
			const nextTokens$1 = this.core.parse(src, fallbackEnv$1, md).tokens;
			this.cache = {
				src,
				tokens: nextTokens$1,
				env: fallbackEnv$1,
				lineCount: countLines(src)
			};
			this.stats.total += 1;
			this.stats.fullParses += 1;
			this.stats.lastMode = "full";
			return nextTokens$1;
		}
		const appended = this.getAppendedSegment(cached.src, src);
		if (appended) {
			const cachedLineCount = cached.lineCount ?? countLines(cached.src);
			let ctxLines = 3;
			if (appended.length > 5e3) ctxLines = 8;
			else if (appended.length > 1e3) ctxLines = 6;
			else if (appended.length > 200) ctxLines = 4;
			ctxLines = Math.min(ctxLines, cachedLineCount);
			let appendedState = null;
			const ctxStrategy = md.options?.streamContextParseStrategy ?? "chars";
			const CONTEXT_PARSE_MIN_CHARS = md.options?.streamContextParseMinChars ?? 200;
			const CONTEXT_PARSE_MIN_LINES = md.options?.streamContextParseMinLines ?? 2;
			function appendedHasBlockConstructs(s) {
				return /(?:^|\n)\s{0,3}(?:#{1,6}\s|>\s|[-*+]\s|\d+\.\s|```|~~~| {4,})/.test(s);
			}
			let shouldAttemptContext = false;
			switch (ctxStrategy) {
				case "lines":
					shouldAttemptContext = countLines(appended) >= CONTEXT_PARSE_MIN_LINES;
					break;
				case "constructs": {
					const appendedLines = countLines(appended);
					shouldAttemptContext = appendedHasBlockConstructs(appended) || appendedLines >= CONTEXT_PARSE_MIN_LINES || appended.length >= CONTEXT_PARSE_MIN_CHARS;
					break;
				}
				case "chars":
				default: shouldAttemptContext = appended.length >= CONTEXT_PARSE_MIN_CHARS;
			}
			if (ctxLines > 0 && shouldAttemptContext) {
				const cachedLines = cached.src.split("\n");
				const ctxStart = Math.max(0, cachedLines.length - ctxLines);
				const ctxSrc = cachedLines.slice(ctxStart).join("\n") + appended;
				try {
					const ctxTokens = this.core.parse(ctxSrc, cached.env, md).tokens;
					const idx = ctxTokens.findIndex((t) => t.map && typeof t.map[1] === "number" && t.map[1] >= ctxLines);
					if (idx !== -1) {
						const appendedTokens = ctxTokens.slice(idx);
						const shiftBy = cachedLineCount - ctxLines;
						if (shiftBy !== 0) this.shiftTokenLines(appendedTokens, shiftBy);
						appendedState = { tokens: appendedTokens };
					}
				} catch {
					appendedState = null;
				}
			} else appendedState = null;
			if (!appendedState) {
				const simpleState = this.core.parse(appended, cached.env, md);
				const lineOffset = cachedLineCount;
				if (lineOffset > 0) this.shiftTokenLines(simpleState.tokens, lineOffset);
				appendedState = simpleState;
			}
			if (cached.tokens.length > 0 && appendedState.tokens.length > 0) {
				const lastCached = cached.tokens[cached.tokens.length - 1];
				const firstApp = appendedState.tokens[0];
				try {
					if (lastCached.type === "inline" && firstApp.type === "inline") {
						if (firstApp.children && firstApp.children.length > 0) {
							if (!lastCached.children) lastCached.children = [];
							lastCached.children.push(...firstApp.children);
						}
						lastCached.content = (lastCached.content || "") + (firstApp.content || "");
						appendedState.tokens.shift();
					}
				} catch {}
			}
			if (appendedState.tokens.length > 0) {
				const cachedTail = cached.tokens;
				const a = appendedState.tokens;
				const maxCheck = Math.min(cachedTail.length, a.length);
				function tokenEquals(x, y) {
					if (!x || !y) return false;
					if (x.type !== y.type) return false;
					if (x.type === "inline") return (x.content || "") === (y.content || "");
					return true;
				}
				let dup = 0;
				for (let n = maxCheck; n > 0; n--) {
					let ok = true;
					for (let i = 0; i < n; i++) {
						const tailToken = cachedTail[cachedTail.length - n + i];
						const prefToken = a[i];
						if (!tokenEquals(tailToken, prefToken)) {
							ok = false;
							break;
						}
					}
					if (ok) {
						dup = n;
						break;
					}
				}
				if (dup > 0) a.splice(0, dup);
				if (a.length > 0) cached.tokens.push(...a);
			}
			cached.src = src;
			cached.lineCount = cachedLineCount + countLines(appended);
			this.stats.total += 1;
			this.stats.appendHits += 1;
			this.stats.lastMode = "append";
			return cached.tokens;
		}
		const fallbackEnv = envProvided ?? cached.env;
		const chunkedEnabled = !!md.options?.streamChunkedFallback;
		const chunkAdaptive = md.options?.streamChunkAdaptive !== false;
		const targetChunks = md.options?.streamChunkTargetChunks ?? 8;
		const chunkSizeCharsCfg = md.options?.streamChunkSizeChars;
		const chunkSizeLinesCfg = md.options?.streamChunkSizeLines;
		const auto = md.options?.autoTuneChunks !== false;
		const chunkFenceAware = md.options?.streamChunkFenceAware ?? true;
		let srcLineCount2 = cached.lineCount;
		if (chunkedEnabled && src.length < this.MAX_CHUNKED_DOC_CHARS) {
			if (srcLineCount2 === void 0) srcLineCount2 = countLines(src);
			const clamp$1 = (v, lo, hi) => v < lo ? lo : v > hi ? hi : v;
			let useChars = chunkAdaptive ? clamp$1(Math.ceil(src.length / targetChunks), 8e3, 32e3) : chunkSizeCharsCfg ?? 1e4;
			let useLines = chunkAdaptive ? clamp$1(Math.ceil(srcLineCount2 / targetChunks), 150, 350) : chunkSizeLinesCfg ?? 200;
			if (auto && !chunkSizeCharsCfg && !chunkSizeLinesCfg) if (src.length <= 5e3) {
				useChars = 16e3;
				useLines = 250;
			} else if (src.length <= 2e4) {
				useChars = 16e3;
				useLines = 200;
			} else if (src.length <= 5e4) {
				useChars = 16e3;
				useLines = 250;
			} else if (src.length <= 1e5) {
				useChars = 1e4;
				useLines = 200;
			} else {
				useChars = 2e4;
				useLines = 200;
			}
			const hasTrailingNewline2 = src.length > 0 && src.charCodeAt(src.length - 1) === 10;
			const estimatedChunks = Math.ceil(src.length / useChars);
			if ((src.length >= useChars * 2 || srcLineCount2 >= useLines * 2) && hasTrailingNewline2 && estimatedChunks <= this.MAX_CHUNKS_FOR_FALLBACK) {
				const tokens = chunkedParse(md, src, fallbackEnv, {
					maxChunkChars: useChars,
					maxChunkLines: useLines,
					fenceAware: chunkFenceAware
				});
				this.cache = {
					src,
					tokens,
					env: fallbackEnv,
					lineCount: srcLineCount2
				};
				this.stats.total += 1;
				this.stats.chunkedParses = (this.stats.chunkedParses || 0) + 1;
				this.stats.lastMode = "chunked";
				return tokens;
			}
		}
		const nextTokens = this.core.parse(src, fallbackEnv, md).tokens;
		this.cache = {
			src,
			tokens: nextTokens,
			env: fallbackEnv,
			lineCount: srcLineCount2
		};
		this.stats.total += 1;
		this.stats.fullParses += 1;
		this.stats.lastMode = "full";
		return nextTokens;
	}
	getAppendedSegment(prev, next) {
		if (!next.startsWith(prev)) return null;
		if (!prev.endsWith("\n")) return null;
		const segment = next.slice(prev.length);
		if (!segment) return null;
		if (!segment.includes("\n")) return null;
		if (!segment.endsWith("\n")) return null;
		let newlineCount = 0;
		for (let i = 0; i < segment.length; i++) if (segment.charCodeAt(i) === 10) newlineCount++;
		if (newlineCount < 2) return null;
		const firstLineBreak = segment.indexOf("\n");
		const trimmedFirstLine = (firstLineBreak === -1 ? segment : segment.slice(0, firstLineBreak)).trim();
		if (trimmedFirstLine.length === 0) return null;
		if (/^[-=]+$/.test(trimmedFirstLine)) {
			const prevWithoutTrailingNewline = prev.slice(0, -1);
			const lastBreak = prevWithoutTrailingNewline.lastIndexOf("\n");
			if (prevWithoutTrailingNewline.slice(lastBreak + 1).trim().length > 0) return null;
		}
		if (this.endsInsideOpenFence(prev)) return null;
		return segment;
	}
	endsInsideOpenFence(text$1) {
		const WINDOW = 4e3;
		const start = text$1.length > WINDOW ? text$1.length - WINDOW : 0;
		const lines = text$1.slice(start).split("\n");
		let inFence = null;
		for (let i = 0; i < lines.length; i++) {
			const line = lines[i];
			let p = 0;
			while (p < line.length) {
				const c = line.charCodeAt(p);
				if (c === 32 || c === 9) p++;
				else break;
			}
			const ch = line[p];
			if (ch === "`" || ch === "~") {
				let q = p;
				while (q < line.length && line[q] === ch) q++;
				const runLen = q - p;
				if (runLen >= 3) {
					if (!inFence) inFence = {
						marker: ch,
						length: runLen
					};
					else if (inFence.marker === ch && runLen >= inFence.length) inFence = null;
				}
			}
		}
		return inFence !== null;
	}
	peek() {
		return this.cache?.tokens ?? EMPTY_TOKENS;
	}
	getStats() {
		return { ...this.stats };
	}
	shiftTokenLines(tokens, offset) {
		if (offset === 0) return;
		const stack = [...tokens];
		while (stack.length > 0) {
			const token = stack.pop();
			if (token.map) {
				token.map[0] += offset;
				token.map[1] += offset;
			}
			if (token.children) for (let i = token.children.length - 1; i >= 0; i--) stack.push(token.children[i]);
		}
	}
};
const config = {
	default: default_default,
	zero: zero_default,
	commonmark: commonmark_default
};
function markdownIt(presetName, options) {
	let opts = {
		html: false,
		xhtmlOut: false,
		breaks: false,
		langPrefix: "language-",
		linkify: false,
		typographer: false,
		quotes: "“”‘’",
		highlight: null,
		maxNesting: 100,
		stream: false,
		streamOptimizationMinSize: 1e3,
		streamChunkedFallback: false,
		streamChunkSizeChars: 1e4,
		streamChunkSizeLines: 200,
		streamChunkFenceAware: true,
		streamChunkAdaptive: true,
		streamChunkTargetChunks: 8,
		streamSkipCacheAboveChars: 6e5,
		streamSkipCacheAboveLines: 1e4,
		fullChunkedFallback: false,
		fullChunkThresholdChars: 2e4,
		fullChunkThresholdLines: 400,
		fullChunkSizeChars: 1e4,
		fullChunkSizeLines: 200,
		fullChunkFenceAware: true,
		fullChunkAdaptive: true,
		fullChunkTargetChunks: 8,
		fullChunkMaxChunks: void 0,
		autoTuneChunks: true
	};
	let presetToUse = "default";
	let userOptions;
	if (!options && typeof presetName !== "string") {
		userOptions = presetName;
		presetToUse = "default";
	} else if (typeof presetName === "string") {
		presetToUse = presetName;
		userOptions = options;
	}
	const preset = config[presetToUse];
	if (!preset) throw new Error(`Wrong \`markdown-it\` preset "${presetToUse}", check name`);
	if (preset?.options) opts = {
		...opts,
		...preset.options
	};
	if (userOptions) opts = {
		...opts,
		...userOptions
	};
	if (typeof opts.quotes === "string") {
		const quotesStr = opts.quotes;
		if (quotesStr.length >= 4) opts.quotes = [
			quotesStr[0],
			quotesStr[1],
			quotesStr[2],
			quotesStr[3]
		];
		else opts.quotes = [
			"“",
			"”",
			"‘",
			"’"
		];
	}
	const core = new ParserCore();
	let renderer = null;
	const getRenderer = () => {
		if (!renderer) renderer = new renderer_default(opts);
		return renderer;
	};
	let streamParser = null;
	const getStreamParser = () => {
		if (!streamParser) streamParser = new StreamParser(core);
		return streamParser;
	};
	let linkifyInstance = null;
	const getLinkify = () => {
		if (!linkifyInstance) linkifyInstance = new linkify_it_default();
		return linkifyInstance;
	};
	const md = {
		core,
		block: core.block,
		inline: core.inline,
		get linkify() {
			const inst = getLinkify();
			Object.defineProperty(this, "linkify", {
				value: inst,
				writable: true,
				configurable: true
			});
			return inst;
		},
		get renderer() {
			const r = getRenderer();
			Object.defineProperty(this, "renderer", {
				value: r,
				writable: true,
				configurable: true
			});
			return r;
		},
		options: opts,
		set(newOpts) {
			this.options = {
				...this.options,
				...newOpts
			};
			if (renderer) renderer.set(newOpts);
			if (typeof newOpts.stream === "boolean") {
				this.stream.enabled = newOpts.stream;
				if (streamParser) {
					streamParser.reset();
					streamParser.resetStats();
				}
			}
			return this;
		},
		configure(presets) {
			const p = typeof presets === "string" ? config[presets] : presets;
			if (!p) throw new Error("Wrong `markdown-it` preset, can't be empty");
			if (p.options) this.set(p.options);
			if (p.components) {
				const c = p.components;
				if (c.core?.rules) this.core.ruler.enableOnly(c.core.rules);
				if (c.block?.rules) this.block.ruler.enableOnly(c.block.rules);
				if (c.inline?.rules) this.inline.ruler.enableOnly(c.inline.rules);
				if (c.inline2?.rules) this.inline.ruler2.enableOnly(c.inline2.rules);
			}
			return this;
		},
		enable(list$1, ignoreInvalid) {
			const names = Array.isArray(list$1) ? list$1 : [list$1];
			const managers = [
				this.core?.ruler,
				this.block?.ruler,
				this.inline?.ruler,
				this.inline?.ruler2
			];
			let changed = 0;
			for (const m of managers) {
				if (!m) continue;
				const enabled = m.enable(names, true);
				changed += enabled.length;
			}
			if (!ignoreInvalid && changed < names.length) throw new Error("Rules manager: invalid rule name in list");
			return this;
		},
		disable(list$1, ignoreInvalid) {
			const names = Array.isArray(list$1) ? list$1 : [list$1];
			const managers = [
				this.core?.ruler,
				this.block?.ruler,
				this.inline?.ruler,
				this.inline?.ruler2
			];
			let changed = 0;
			for (const m of managers) {
				if (!m) continue;
				const disabled = m.disable(names, true);
				changed += disabled.length;
			}
			if (!ignoreInvalid && changed < names.length) throw new Error("Rules manager: invalid rule name in list");
			return this;
		},
		use(plugin, ...params) {
			const fn = typeof plugin === "function" ? plugin : plugin && typeof plugin.default === "function" ? plugin.default : void 0;
			if (!fn) throw new TypeError("MarkdownIt.use: plugin must be a function");
			const args = [this, ...params];
			const thisArg = typeof plugin === "function" ? plugin : plugin;
			fn.apply(thisArg, args);
			return this;
		},
		render(src, env = {}) {
			const tokens = this.parse(src, env);
			return getRenderer().render(tokens, this.options, env);
		},
		async renderAsync(src, env = {}) {
			const tokens = this.parse(src, env);
			return getRenderer().renderAsync(tokens, this.options, env);
		},
		renderInline(src, env = {}) {
			const tokens = this.parseInline(src, env);
			return getRenderer().render(tokens, this.options, env);
		},
		validateLink,
		normalizeLink,
		normalizeLinkText,
		utils: utils_exports,
		helpers: { ...helpers_exports },
		parse(src, env = {}) {
			if (typeof src !== "string") throw new TypeError("Input data should be a String");
			if (!this.stream.enabled && !this.options.fullChunkedFallback) return core.parse(src, env, this).tokens;
			if (!this.stream.enabled) {
				const chars = src.length;
				if (this.options.fullChunkedFallback) {
					const lines = countLines(src);
					const auto = this.options.autoTuneChunks !== false;
					const userForcedChunk = this.options.fullChunkSizeChars || this.options.fullChunkSizeLines;
					if (auto && !userForcedChunk) {
						const fenceAware = this.options.fullChunkFenceAware ?? true;
						if (chars <= 5e3) return chunkedParse(this, src, env, {
							maxChunkChars: 32e3,
							maxChunkLines: 150,
							fenceAware,
							maxChunks: 8
						});
						else if (chars <= 2e4) return chunkedParse(this, src, env, {
							maxChunkChars: 24e3,
							maxChunkLines: 200,
							fenceAware,
							maxChunks: 12
						});
						else if (chars <= 1e5) {} else if (chars <= 2e5) return chunkedParse(this, src, env, {
							maxChunkChars: 2e4,
							maxChunkLines: 150,
							fenceAware,
							maxChunks: 12
						});
					}
					if (chars >= (this.options.fullChunkThresholdChars ?? 2e4) || lines >= (this.options.fullChunkThresholdLines ?? 400)) {
						const clamp$1 = (v, lo, hi) => v < lo ? lo : v > hi ? hi : v;
						const adaptive = this.options.fullChunkAdaptive !== false;
						const target = this.options.fullChunkTargetChunks ?? 8;
						const dynMaxChunkChars = clamp$1(Math.ceil(chars / target), 8e3, 32e3);
						const dynMaxChunkLines = clamp$1(Math.ceil(lines / target), 150, 350);
						const maxChunkChars = adaptive ? dynMaxChunkChars : this.options.fullChunkSizeChars ?? 1e4;
						const maxChunkLines = adaptive ? dynMaxChunkLines : this.options.fullChunkSizeLines ?? 200;
						const maxChunks = adaptive ? Math.max(6, Math.min(12, target)) : this.options.fullChunkMaxChunks;
						return chunkedParse(this, src, env, {
							maxChunkChars,
							maxChunkLines,
							fenceAware: this.options.fullChunkFenceAware ?? true,
							maxChunks
						});
					}
				}
			}
			return core.parse(src, env, this).tokens;
		},
		parseInline(src, env = {}) {
			if (typeof src !== "string") throw new TypeError("Input data should be a String");
			const state = core.createState(src, env, this);
			state.inlineMode = true;
			core.process(state);
			return state.tokens;
		}
	};
	md.stream = {
		enabled: Boolean(opts.stream),
		parse(src, env) {
			if (!md.stream.enabled) return core.parse(src, env ?? {}, md).tokens;
			return getStreamParser().parse(src, env, md);
		},
		reset() {
			getStreamParser().reset();
		},
		peek() {
			return streamParser ? streamParser.peek() : [];
		},
		stats() {
			return streamParser ? streamParser.getStats() : {
				total: 0,
				cacheHits: 0,
				appendHits: 0,
				fullParses: 0,
				resets: 0,
				chunkedParses: 0,
				lastMode: "idle"
			};
		},
		resetStats() {
			if (streamParser) streamParser.resetStats();
		}
	};
	if (presetToUse === "zero" && preset?.components) {
		const c = preset.components;
		if (c.core?.rules) md.core.ruler.enableOnly(c.core.rules);
		if (c.block?.rules) md.block.ruler.enableOnly(c.block.rules);
		if (c.inline?.rules) md.inline.ruler.enableOnly(c.inline.rules);
		if (c.inline2?.rules) md.inline.ruler2.enableOnly(c.inline2.rules);
	}
	return md;
}
var src_default = markdownIt;

//#endregion
//#region src/config.ts
let defaultMathOptions;
function setDefaultMathOptions(opts) {
	defaultMathOptions = opts;
}
function getDefaultMathOptions() {
	return defaultMathOptions;
}

//#endregion
//#region ../../node_modules/.pnpm/markdown-it-container@4.0.0/node_modules/markdown-it-container/index.mjs
function container_plugin(md, name, options) {
	function validateDefault(params) {
		return params.trim().split(" ", 2)[0] === name;
	}
	function renderDefault(tokens, idx, _options, env, slf) {
		if (tokens[idx].nesting === 1) tokens[idx].attrJoin("class", name);
		return slf.renderToken(tokens, idx, _options, env, slf);
	}
	options = options || {};
	const min_markers = 3;
	const marker_str = options.marker || ":";
	const marker_char = marker_str.charCodeAt(0);
	const marker_len = marker_str.length;
	const validate = options.validate || validateDefault;
	const render = options.render || renderDefault;
	function container(state, startLine, endLine, silent) {
		let pos;
		let auto_closed = false;
		let start = state.bMarks[startLine] + state.tShift[startLine];
		let max = state.eMarks[startLine];
		if (marker_char !== state.src.charCodeAt(start)) return false;
		for (pos = start + 1; pos <= max; pos++) if (marker_str[(pos - start) % marker_len] !== state.src[pos]) break;
		const marker_count = Math.floor((pos - start) / marker_len);
		if (marker_count < min_markers) return false;
		pos -= (pos - start) % marker_len;
		const markup = state.src.slice(start, pos);
		const params = state.src.slice(pos, max);
		if (!validate(params, markup)) return false;
		if (silent) return true;
		let nextLine = startLine;
		for (;;) {
			nextLine++;
			if (nextLine >= endLine) break;
			start = state.bMarks[nextLine] + state.tShift[nextLine];
			max = state.eMarks[nextLine];
			if (start < max && state.sCount[nextLine] < state.blkIndent) break;
			if (marker_char !== state.src.charCodeAt(start)) continue;
			if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
			for (pos = start + 1; pos <= max; pos++) if (marker_str[(pos - start) % marker_len] !== state.src[pos]) break;
			if (Math.floor((pos - start) / marker_len) < marker_count) continue;
			pos -= (pos - start) % marker_len;
			pos = state.skipSpaces(pos);
			if (pos < max) continue;
			auto_closed = true;
			break;
		}
		const old_parent = state.parentType;
		const old_line_max = state.lineMax;
		state.parentType = "container";
		state.lineMax = nextLine;
		const token_o = state.push("container_" + name + "_open", "div", 1);
		token_o.markup = markup;
		token_o.block = true;
		token_o.info = params;
		token_o.map = [startLine, nextLine];
		state.md.block.tokenize(state, startLine + 1, nextLine);
		const token_c = state.push("container_" + name + "_close", "div", -1);
		token_c.markup = state.src.slice(start, pos);
		token_c.block = true;
		state.parentType = old_parent;
		state.lineMax = old_line_max;
		state.line = nextLine + (auto_closed ? 1 : 0);
		return true;
	}
	md.block.ruler.before("fence", "container_" + name, container, { alt: [
		"paragraph",
		"reference",
		"blockquote",
		"list"
	] });
	md.renderer.rules["container_" + name + "_open"] = render;
	md.renderer.rules["container_" + name + "_close"] = render;
}

//#endregion
//#region src/plugins/containers.ts
function applyContainers(md) {
	[
		"admonition",
		"info",
		"warning",
		"error",
		"tip",
		"danger",
		"note",
		"caution"
	].forEach((name) => {
		md.use(container_plugin, name, { render(tokens, idx) {
			if (tokens[idx].nesting === 1) return `<div class="vmr-container vmr-container-${name}">`;
			else return "</div>\n";
		} });
	});
	md.block.ruler.before("fence", "vmr_container_fallback", (state, startLine, endLine, silent) => {
		const s = state;
		const startPos = s.bMarks[startLine] + s.tShift[startLine];
		const lineMax = s.eMarks[startLine];
		const markerMatch = s.src.slice(startPos, lineMax).match(/^:::\s*(\w+)/);
		if (!markerMatch) return false;
		if (silent) return true;
		const name = markerMatch[1];
		let nextLine = startLine + 1;
		let found = false;
		while (nextLine <= endLine) {
			const sPos = s.bMarks[nextLine] + s.tShift[nextLine];
			const ePos = s.eMarks[nextLine];
			if (s.src.slice(sPos, ePos).trim() === ":::") {
				found = true;
				break;
			}
			nextLine++;
		}
		if (!found) return false;
		s.push("vmr_container_open", "div", 1).attrSet("class", `vmr-container vmr-container-${name}`);
		const contentLines = [];
		for (let i = startLine + 1; i < nextLine; i++) {
			const sPos = s.bMarks[i] + s.tShift[i];
			const ePos = s.eMarks[i];
			contentLines.push(s.src.slice(sPos, ePos));
		}
		s.push("paragraph_open", "p", 1);
		const inlineToken = s.push("inline", "", 0);
		inlineToken.content = contentLines.join("\n");
		inlineToken.map = [startLine + 1, nextLine];
		inlineToken.children = [];
		s.md.inline.parse(inlineToken.content, s.md, s.env, inlineToken.children);
		s.push("paragraph_close", "p", -1);
		s.push("vmr_container_close", "div", -1);
		s.line = nextLine + 1;
		return true;
	});
}

//#endregion
//#region src/plugins/fixHtmlInline.ts
const VOID_TAGS$2 = new Set([
	"area",
	"base",
	"br",
	"col",
	"embed",
	"hr",
	"img",
	"input",
	"link",
	"meta",
	"param",
	"source",
	"track",
	"wbr"
]);
const BASE_COMMON_HTML_TAGS = new Set([
	...Array.from(VOID_TAGS$2),
	"a",
	"abbr",
	"b",
	"bdi",
	"bdo",
	"button",
	"cite",
	"code",
	"data",
	"del",
	"dfn",
	"em",
	"font",
	"i",
	"img",
	"input",
	"ins",
	"kbd",
	"label",
	"mark",
	"q",
	"s",
	"samp",
	"small",
	"span",
	"strong",
	"sub",
	"sup",
	"time",
	"u",
	"var",
	"article",
	"aside",
	"blockquote",
	"div",
	"details",
	"figcaption",
	"figure",
	"footer",
	"header",
	"h1",
	"h2",
	"h3",
	"h4",
	"h5",
	"h6",
	"li",
	"main",
	"nav",
	"ol",
	"p",
	"pre",
	"section",
	"summary",
	"table",
	"tbody",
	"td",
	"th",
	"thead",
	"tr",
	"ul",
	"svg",
	"g",
	"path"
]);
const OPEN_TAG_RE = /<([A-Z][\w-]*)(?=[\s/>]|$)/gi;
const CLOSE_TAG_RE = /<\/\s*([A-Z][\w-]*)(?=[\s/>]|$)/gi;
const TAG_NAME_AT_START_RE = /^<\s*(?:\/\s*)?([A-Z][\w-]*)/i;
function findTagCloseIndexOutsideQuotes$1(html) {
	let inSingle = false;
	let inDouble = false;
	for (let i = 0; i < html.length; i++) {
		const ch = html[i];
		if (ch === "\"" && !inSingle) {
			inDouble = !inDouble;
			continue;
		}
		if (ch === "'" && !inDouble) {
			inSingle = !inSingle;
			continue;
		}
		if (ch === ">" && !inSingle && !inDouble) return i;
	}
	return -1;
}
function tokenToRaw$1(token) {
	const shape = token;
	return String(shape.raw ?? shape.content ?? shape.markup ?? "");
}
function buildCommonHtmlTagSet(extraTags) {
	const set = new Set(BASE_COMMON_HTML_TAGS);
	if (extraTags && Array.isArray(extraTags)) for (const t of extraTags) {
		const raw = String(t ?? "").trim();
		if (!raw) continue;
		const m = raw.match(/^[<\s/]*([A-Z][\w-]*)/i);
		if (!m) continue;
		set.add(m[1].toLowerCase());
	}
	return set;
}
function isCommonHtmlTagOrPrefix(tag, tagSet) {
	if (tagSet.has(tag)) return true;
	for (const common of tagSet) if (common.startsWith(tag)) return true;
	return false;
}
function findFirstIncompleteTag(content, tagSet) {
	let first = null;
	for (const m of content.matchAll(OPEN_TAG_RE)) {
		const idx = m.index ?? -1;
		if (idx < 0) continue;
		const tag = (m[1] ?? "").toLowerCase();
		if (!isCommonHtmlTagOrPrefix(tag, tagSet)) continue;
		if (findTagCloseIndexOutsideQuotes$1(content.slice(idx)) !== -1) continue;
		if (!first || idx < first.index) first = {
			index: idx,
			tag,
			closing: false
		};
	}
	for (const m of content.matchAll(CLOSE_TAG_RE)) {
		const idx = m.index ?? -1;
		if (idx < 0) continue;
		const tag = (m[1] ?? "").toLowerCase();
		if (!isCommonHtmlTagOrPrefix(tag, tagSet)) continue;
		if (findTagCloseIndexOutsideQuotes$1(content.slice(idx)) !== -1) continue;
		if (!first || idx < first.index) first = {
			index: idx,
			tag,
			closing: true
		};
	}
	const bareClose = /<\/\s*$/.exec(content);
	if (bareClose && typeof bareClose.index === "number") {
		const idx = bareClose.index;
		if (!content.slice(idx).includes(">") && (!first || idx < first.index)) first = {
			index: idx,
			tag: "",
			closing: true
		};
	}
	const bareOpen = /<\s*$/.exec(content);
	if (bareOpen && typeof bareOpen.index === "number") {
		const idx = bareOpen.index;
		const rest = content.slice(idx);
		if (!rest.startsWith("</") && !rest.includes(">") && (!first || idx < first.index)) first = {
			index: idx,
			tag: "",
			closing: false
		};
	}
	return first;
}
function splitTextToken(token, content) {
	const t = token;
	return Object.assign(Object.create(Object.getPrototypeOf(t)), t, {
		type: "text",
		content,
		raw: content
	});
}
function fixStreamingHtmlInlineChildren(children, tagSet) {
	if (!children.length) return { children };
	const out = [];
	let pending = null;
	let pendingAtEnd = null;
	function pushTextPart(text$1, baseToken) {
		if (!text$1) return;
		if (baseToken) out.push(splitTextToken(baseToken, text$1));
		else out.push({
			type: "text",
			content: text$1,
			raw: text$1
		});
	}
	function splitCompleteHtmlFromText(chunk, baseToken) {
		let cursor = 0;
		while (cursor < chunk.length) {
			const lt = chunk.indexOf("<", cursor);
			if (lt === -1) {
				pushTextPart(chunk.slice(cursor), baseToken);
				break;
			}
			pushTextPart(chunk.slice(cursor, lt), baseToken);
			const sub = chunk.slice(lt);
			const tagMatch = sub.match(TAG_NAME_AT_START_RE);
			if (!tagMatch) {
				pushTextPart("<", baseToken);
				cursor = lt + 1;
				continue;
			}
			const closeIdx = findTagCloseIndexOutsideQuotes$1(sub);
			if (closeIdx === -1) {
				pushTextPart("<", baseToken);
				cursor = lt + 1;
				continue;
			}
			const tagText = sub.slice(0, closeIdx + 1);
			const tagName = (tagMatch[1] ?? "").toLowerCase();
			if (tagSet.has(tagName)) out.push({
				type: "html_inline",
				tag: "",
				content: tagText,
				raw: tagText
			});
			else pushTextPart(tagText, baseToken);
			cursor = lt + tagText.length;
		}
	}
	function processTextChunk(chunk, baseToken) {
		if (!chunk) return;
		const match = findFirstIncompleteTag(chunk, tagSet);
		if (!match) {
			splitCompleteHtmlFromText(chunk, baseToken);
			return;
		}
		const before = chunk.slice(0, match.index);
		if (before) splitCompleteHtmlFromText(before, baseToken);
		pending = {
			tag: match.tag,
			buffer: chunk.slice(match.index),
			closing: match.closing
		};
		pendingAtEnd = pending.buffer;
	}
	for (const child of children) {
		if (pending) {
			pending.buffer += tokenToRaw$1(child);
			pendingAtEnd = pending.buffer;
			const closeIdx = findTagCloseIndexOutsideQuotes$1(pending.buffer);
			if (closeIdx === -1) continue;
			const tagChunk = pending.buffer.slice(0, closeIdx + 1);
			const afterChunk = pending.buffer.slice(closeIdx + 1);
			out.push({
				type: "html_inline",
				tag: "",
				content: tagChunk,
				raw: tagChunk
			});
			pending = null;
			pendingAtEnd = null;
			if (afterChunk) processTextChunk(afterChunk);
			continue;
		}
		if (child.type === "html_inline") {
			const content = tokenToRaw$1(child);
			const tagName = (content.match(TAG_NAME_AT_START_RE)?.[1] ?? "").toLowerCase();
			if (tagName && tagSet.has(tagName) && findTagCloseIndexOutsideQuotes$1(content) === -1) {
				pending = {
					tag: tagName,
					buffer: content,
					closing: /^<\s*\//.test(content)
				};
				pendingAtEnd = pending.buffer;
				continue;
			}
		}
		if (child.type === "text") {
			const content = String(child.content ?? "");
			if (!content.includes("<")) {
				out.push(child);
				continue;
			}
			processTextChunk(content, child);
			continue;
		}
		out.push(child);
	}
	return {
		children: out,
		pendingBuffer: pendingAtEnd ?? void 0
	};
}
function applyFixHtmlInlineTokens(md, options = {}) {
	const commonHtmlTags = buildCommonHtmlTagSet(options.customHtmlTags);
	const autoCloseInlineTagSet = new Set([
		"a",
		"span",
		"strong",
		"em",
		"b",
		"i",
		"u"
	]);
	const customTagSet = /* @__PURE__ */ new Set();
	if (options.customHtmlTags?.length) for (const t of options.customHtmlTags) {
		const raw = String(t ?? "").trim();
		if (!raw) continue;
		const m = raw.match(/^[<\s/]*([A-Z][\w-]*)/i);
		if (!m) continue;
		const name = m[1].toLowerCase();
		customTagSet.add(name);
		autoCloseInlineTagSet.add(name);
	}
	md.core.ruler.after("inline", "fix_html_inline_streaming", (state) => {
		const toks = state.tokens ?? [];
		for (const t of toks) {
			const tok = t;
			if (tok.type !== "inline" || !Array.isArray(tok.children)) continue;
			const originalContent = String(tok.content ?? "");
			const sourceChildren = tok.children.length ? tok.children : originalContent.includes("<") ? [{
				type: "text",
				content: originalContent,
				raw: originalContent
			}] : null;
			if (!sourceChildren) continue;
			try {
				const fixed = fixStreamingHtmlInlineChildren(sourceChildren, commonHtmlTags);
				tok.children = fixed.children;
				if (fixed.pendingBuffer) {
					const idx = originalContent.lastIndexOf(fixed.pendingBuffer);
					if (idx !== -1) {
						const trimmed = originalContent.slice(0, idx);
						tok.content = trimmed;
						if (typeof tok.raw === "string") tok.raw = trimmed;
					}
				}
			} catch (e) {
				console.error("[applyFixHtmlInlineTokens] failed to fix streaming html inline", e);
			}
		}
	});
	md.core.ruler.push("fix_html_inline_tokens", (state) => {
		const toks = state.tokens ?? [];
		const tagStack = [];
		for (let i = 0; i < toks.length; i++) {
			const t = toks[i];
			if (tagStack.length > 0) {
				const [openTag, openIndex] = tagStack[tagStack.length - 1];
				if (i !== openIndex) {
					if (t.type === "paragraph_open" || t.type === "paragraph_close") {
						toks.splice(i, 1);
						i--;
						continue;
					}
					const chunk = String(t.content ?? t.raw ?? "");
					const closeRe = new RegExp(`<\\s*\\/\\s*${openTag}\\s*>`, "i");
					const closeMatch = chunk ? closeRe.exec(chunk) : null;
					const isClosingTag$1 = !!closeMatch;
					if (chunk) {
						const openToken = toks[openIndex];
						if (closeMatch && typeof closeMatch.index === "number") {
							const end = closeMatch.index + String(closeMatch[0] ?? "").length;
							const before = chunk.slice(0, end);
							const after = chunk.slice(end);
							openToken.content = `${String(openToken.content || "")}\n${before}`;
							openToken.loading = false;
							const afterTrimmed = after.replace(/^\s+/, "");
							toks.splice(i, 1);
							tagStack.pop();
							if (afterTrimmed) toks.splice(i, 0, afterTrimmed.startsWith("<") ? {
								type: "html_block",
								content: afterTrimmed
							} : {
								type: "inline",
								content: afterTrimmed,
								children: [{
									type: "text",
									content: afterTrimmed,
									raw: afterTrimmed
								}]
							});
							i--;
							continue;
						}
						openToken.content = `${String(openToken.content || "")}\n${chunk}`;
						if (openToken.loading !== false) openToken.loading = !isClosingTag$1;
					}
					toks.splice(i, 1);
					i--;
					if (isClosingTag$1) tagStack.pop();
					continue;
				}
			}
			if (t.type === "html_block") {
				const rawContent = String(t.content || "");
				const tag = (rawContent.match(/<\s*(?:\/\s*)?([^\s>/]+)/)?.[1] ?? "").toLowerCase();
				if (!/^\s*<\s*\//.test(rawContent)) {
					if (tag) {
						if (!new RegExp(`<\\s*\\/\\s*${tag}\\s*>`, "i").test(rawContent)) tagStack.push([tag, i]);
					}
				} else if (tagStack.length > 0 && tag && tagStack[tagStack.length - 1][0] === tag) {
					const [, openIndex] = tagStack[tagStack.length - 1];
					const openToken = toks[openIndex];
					openToken.content = `${String(openToken.content || "")}\n${rawContent}`;
					openToken.loading = false;
					tagStack.pop();
					toks.splice(i, 1);
					i--;
				}
				continue;
			} else if (tagStack.length > 0) {
				if (t.type === "paragraph_open" || t.type === "paragraph_close") {
					toks.splice(i, 1);
					i--;
					continue;
				}
				const content = t.content || "";
				const isClosingTag$1 = new RegExp(`<\\s*\\/\\s*${tagStack[tagStack.length - 1][0]}\\s*>`, "i").test(content);
				if (content) {
					const [, openIndex] = tagStack[tagStack.length - 1];
					const openToken = toks[openIndex];
					openToken.content = `${openToken.content || ""}\n${content}`;
					if (openToken.loading !== false) openToken.loading = !isClosingTag$1;
				}
				if (isClosingTag$1) tagStack.pop();
				toks.splice(i, 1);
				i--;
			} else continue;
		}
		if (customTagSet.size > 0) {
			const openReCache = /* @__PURE__ */ new Map();
			const closeReCache = /* @__PURE__ */ new Map();
			const getOpenRe = (tag) => {
				let r = openReCache.get(tag);
				if (!r) {
					r = new RegExp(`<\\s*${tag}\\b`, "i");
					openReCache.set(tag, r);
				}
				return r;
			};
			const getCloseRe = (tag) => {
				let r = closeReCache.get(tag);
				if (!r) {
					r = new RegExp(`<\\s*\\/\\s*${tag}\\s*>`, "i");
					closeReCache.set(tag, r);
				}
				return r;
			};
			const stack = [];
			for (let i = 0; i < toks.length; i++) {
				const tok = toks[i];
				const content = String(tok.content ?? "");
				if (stack.length > 0) {
					const top = stack[stack.length - 1];
					const openTok = toks[top.index];
					if (tok.type === "html_block" && getCloseRe(top.tag).test(content)) {
						openTok.content = `${String(openTok.content ?? "")}\n${content}`;
						if (Array.isArray(openTok.children)) openTok.children.push({
							type: "html_inline",
							content: `</${top.tag}>`,
							raw: `</${top.tag}>`
						});
						toks.splice(i, 1);
						i--;
						stack.pop();
						continue;
					}
					if (tok.type !== "inline") continue;
					const children = Array.isArray(tok.children) ? tok.children : [];
					const closeChildIndex = children.findIndex((c) => {
						if (!c || c.type !== "html_inline") return false;
						const cContent = String(c.content ?? "");
						return /^\s*<\s*\//.test(cContent) && cContent.toLowerCase().includes(top.tag);
					});
					if (closeChildIndex !== -1) {
						const beforeChildren = children.slice(0, closeChildIndex + 1);
						const afterChildren = children.slice(closeChildIndex + 1);
						const beforeText = beforeChildren.map((c) => String(c?.content ?? c?.raw ?? "")).join("");
						openTok.content = `${String(openTok.content ?? "")}\n${beforeText}`;
						if (Array.isArray(openTok.children)) openTok.children.push(...beforeChildren);
						if (afterChildren.length) {
							const afterText = afterChildren.map((c) => String(c.content ?? c.raw ?? "")).join("");
							if (afterText.trim()) {
								const trimmed = afterText.replace(/^\s+/, "");
								if (trimmed.startsWith("<")) toks.splice(i, 1, {
									type: "html_block",
									content: trimmed
								});
								else toks.splice(i, 1, {
									type: "paragraph_open",
									tag: "p",
									nesting: 1
								}, {
									type: "inline",
									tag: "",
									nesting: 0,
									content: afterText,
									children: [{
										type: "text",
										content: afterText,
										raw: afterText
									}]
								}, {
									type: "paragraph_close",
									tag: "p",
									nesting: -1
								});
							} else {
								toks.splice(i, 1);
								i--;
							}
						} else {
							toks.splice(i, 1);
							i--;
						}
						stack.pop();
						continue;
					}
					openTok.content = `${String(openTok.content ?? "")}\n${content}`;
					if (Array.isArray(openTok.children)) openTok.children.push(...children);
					toks.splice(i, 1);
					i--;
					continue;
				}
				if (tok.type !== "inline") continue;
				for (const tag of customTagSet) if (getOpenRe(tag).test(content) && !getCloseRe(tag).test(content)) {
					stack.push({
						tag,
						index: i
					});
					break;
				}
			}
		}
		{
			let depth = 0;
			for (let i = 0; i < toks.length; i++) {
				const t = toks[i];
				if (t.type === "paragraph_open") {
					depth++;
					continue;
				}
				if (t.type === "paragraph_close") if (depth > 0) depth--;
				else {
					toks.splice(i, 1);
					i--;
				}
			}
		}
		for (let i = 0; i < toks.length; i++) {
			const t = toks[i];
			if (t.type === "html_block") {
				const tag = (t.content?.match(/<([^\s>/]+)/)?.[1] ?? "").toLowerCase();
				if (customTagSet.has(tag)) {
					const raw$1 = String(t.content ?? "");
					const closeRe = new RegExp(`<\\/\\s*${tag}\\s*>`, "i");
					t.loading = closeRe.test(raw$1) ? false : t.loading !== void 0 ? t.loading : true;
					const closeMatch = closeRe.exec(raw$1);
					const endTagIndex = closeMatch ? closeMatch.index : -1;
					const closeLen = closeMatch ? closeMatch[0].length : 0;
					if (endTagIndex !== -1) {
						const rawForNode = raw$1.slice(0, endTagIndex + closeLen);
						t.content = rawForNode;
						t.raw = rawForNode;
						const afterTrimmed = (raw$1.slice(endTagIndex + closeLen) || "").replace(/^\s+/, "");
						if (afterTrimmed) toks.splice(i + 1, 0, afterTrimmed.startsWith("<") ? {
							type: "html_block",
							content: afterTrimmed
						} : {
							type: "text",
							content: afterTrimmed,
							raw: afterTrimmed
						});
					}
					continue;
				}
				if (tag.startsWith("!") || tag.startsWith("?")) {
					t.loading = false;
					continue;
				}
				if ([
					"br",
					"hr",
					"img",
					"input",
					"link",
					"meta",
					"div",
					"p",
					"ul",
					"li"
				].includes(tag)) continue;
				t.type = "inline";
				const loading = new RegExp(`<\\/\\s*${tag}\\s*>`, "i").test(String(t.content ?? "")) ? false : t.loading !== void 0 ? t.loading : true;
				const attrs = [];
				const attrRegex = /\s([\w:-]+)(?:\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s"'>]+)))?/g;
				let match;
				while ((match = attrRegex.exec(t.content || "")) !== null) {
					const attrName = match[1];
					const attrValue = match[2] || match[3] || match[4] || "";
					attrs.push([attrName, attrValue]);
				}
				if (customTagSet.has(tag)) {
					const raw$1 = String(t.content ?? "");
					const closeMatch = new RegExp(`<\\/\\s*${tag}\\s*>`, "i").exec(raw$1);
					const endTagIndex = closeMatch ? closeMatch.index : -1;
					const closeLen = closeMatch ? closeMatch[0].length : 0;
					const rawForNode = endTagIndex !== -1 ? raw$1.slice(0, endTagIndex + closeLen) : raw$1;
					let inner = "";
					const openEnd = findTagCloseIndexOutsideQuotes$1(raw$1);
					if (openEnd !== -1) {
						if (endTagIndex !== -1 && openEnd < endTagIndex) inner = raw$1.slice(openEnd + 1, endTagIndex);
						else if (endTagIndex === -1) inner = raw$1.slice(openEnd + 1).replace(/<.*$/, "");
					}
					t.children = [{
						type: tag,
						content: inner,
						raw: rawForNode,
						attrs,
						tag,
						loading
					}];
					if (endTagIndex !== -1) {
						t.content = rawForNode;
						t.raw = rawForNode;
						const afterTrimmed = (raw$1.slice(endTagIndex + closeLen) || "").replace(/^\s+/, "");
						if (afterTrimmed) toks.splice(i + 1, 0, afterTrimmed.startsWith("<") ? {
							type: "html_block",
							content: afterTrimmed
						} : {
							type: "text",
							content: afterTrimmed,
							raw: afterTrimmed
						});
					}
				} else t.children = [{
					type: "html_block",
					content: t.content,
					tag,
					loading
				}];
				continue;
			}
			if (!t || t.type !== "inline") continue;
			if (t.children.length === 2 && t.children[0].type === "html_inline") {
				const tag = (t.children[0].content?.match(/<([^\s>/]+)/)?.[1] ?? "").toLowerCase();
				if (autoCloseInlineTagSet.has(tag)) {
					t.children[0].loading = true;
					t.children[0].tag = tag;
					t.children.push({
						type: "html_inline",
						tag,
						loading: true,
						content: `</${tag}>`
					});
				} else t.children = [{
					type: "html_block",
					loading: true,
					tag,
					content: t.children[0].content + t.children[1].content
				}];
				continue;
			} else if (t.children.length === 3 && t.children[0].type === "html_inline" && t.children[2].type === "html_inline") {
				const tag = (t.children[0].content?.match(/<([^\s>/]+)/)?.[1] ?? "").toLowerCase();
				if (autoCloseInlineTagSet.has(tag)) continue;
				t.children = [{
					type: "html_block",
					loading: false,
					tag,
					content: t.children.map((ct) => ct.content).join("")
				}];
				continue;
			}
			if (!t.content?.startsWith("<") || t.children?.length !== 1) continue;
			const raw = String(t.content);
			const tagName = raw.match(/<([^\s>/]+)/)?.[1]?.toLowerCase() ?? "";
			if (!tagName) continue;
			const isVoid = /\/\s*>\s*$/.test(raw) || VOID_TAGS$2.has(tagName);
			const htmlToken = t;
			if (isVoid) {
				htmlToken.children = [{
					type: "html_inline",
					content: raw
				}];
				continue;
			}
			htmlToken.children.length = 0;
		}
	});
}

//#endregion
//#region src/plugins/fixLinkTokens.ts
function textToken(content) {
	return {
		type: "text",
		content,
		raw: content
	};
}
function pushEmOpen(arr, type) {
	if (type === 1) arr.push({
		type: "em_open",
		tag: "em",
		nesting: 1
	});
	else if (type === 2) arr.push({
		type: "strong_open",
		tag: "strong",
		nesting: 1
	});
	else if (type === 3) {
		arr.push({
			type: "strong_open",
			tag: "strong",
			nesting: 1
		});
		arr.push({
			type: "em_open",
			tag: "em",
			nesting: 1
		});
	}
}
function pushEmClose(arr, type) {
	if (type === 1) arr.push({
		type: "em_close",
		tag: "em",
		nesting: -1
	});
	else if (type === 2) arr.push({
		type: "strong_close",
		tag: "strong",
		nesting: -1
	});
	else if (type === 3) {
		arr.push({
			type: "em_close",
			tag: "em",
			nesting: -1
		});
		arr.push({
			type: "strong_close",
			tag: "strong",
			nesting: -1
		});
	}
}
function createLinkToken(text$1, href, loading) {
	let title = "";
	if (href.includes("\"")) {
		const temps = href.split("\"");
		href = temps[0].trim();
		title = temps[1].trim();
	}
	return {
		type: "link",
		loading,
		href,
		title,
		text: text$1,
		children: [{
			type: "text",
			content: text$1,
			raw: text$1
		}],
		raw: String(`[${text$1}](${href})`)
	};
}
function applyFixLinkTokens(md) {
	md.core.ruler.after("inline", "fix_link_tokens", (state) => {
		const toks = state.tokens ?? [];
		for (let i = 0; i < toks.length; i++) {
			const t = toks[i];
			if (t && t.type === "inline" && Array.isArray(t.children)) try {
				t.children = fixLinkToken(t.children);
			} catch (e) {
				console.error("[applyFixLinkTokens] failed to fix inline children", e);
			}
		}
	});
}
function fixLinkToken(tokens) {
	if (tokens.length < 4) return tokens;
	for (let i = 0; i <= tokens.length - 1; i++) {
		if (i < 0) i = 0;
		const curToken = tokens[i];
		if (!curToken) break;
		if (curToken?.type === "em_open" && tokens[i - 1]?.type === "text" && tokens[i - 1].content?.endsWith("*")) {
			const beforeText = tokens[i - 1].content?.replace(/(\*+)$/, "") || "";
			tokens[i - 1].content = beforeText;
			curToken.type = "strong_open";
			curToken.tag = "strong";
			curToken.markup = "**";
			for (let j = i + 1; j < tokens.length; j++) if (tokens[j]?.type === "em_close") {
				tokens[j].type = "strong_close";
				tokens[j].tag = "strong";
				tokens[j].markup = "**";
				break;
			}
		} else if (curToken?.type === "text" && curToken.content?.endsWith("(") && tokens[i + 1]?.type === "link_open") {
			const match = curToken.content.match(/\[([^\]]+)\]/);
			if (match) {
				let beforeText = curToken.content.slice(0, match.index);
				const emphasisMatch = beforeText.match(/(\*+)$/);
				const replacerTokens = [];
				if (emphasisMatch) {
					beforeText = beforeText.slice(0, emphasisMatch.index);
					if (beforeText) replacerTokens.push(textToken(beforeText));
					const text$1 = match[1];
					const type = emphasisMatch[1].length;
					pushEmOpen(replacerTokens, type);
					let href = tokens[i + 2]?.content || "";
					if (tokens[i + 4]?.type === "text" && !tokens[i + 4].content?.startsWith(")")) {
						href += tokens[i + 4]?.content || "";
						tokens[i + 4].content = "";
					}
					replacerTokens.push(createLinkToken(text$1, href, !tokens[i + 4]?.content?.startsWith(")")));
					pushEmClose(replacerTokens, type);
					if (tokens[i + 4]?.type === "text") {
						const afterText = tokens[i + 4].content?.replace(/^\)\**/, "");
						if (afterText) replacerTokens.push(textToken(afterText));
						tokens.splice(i, 5, ...replacerTokens);
					} else tokens.splice(i, 4, ...replacerTokens);
				} else {
					if (beforeText) replacerTokens.push(textToken(beforeText));
					let text$1 = match[1];
					const emphasisMatch$1 = text$1.match(/^\*+/);
					if (emphasisMatch$1) {
						const type = emphasisMatch$1[0].length;
						text$1 = text$1.replace(/^\*+/, "").replace(/\*+$/, "");
						let href$1 = tokens[i + 2]?.content || "";
						if (tokens[i + 4]?.type === "text" && !tokens[i + 4].content?.startsWith(")")) {
							href$1 += tokens[i + 4]?.content || "";
							tokens[i + 4].content = "";
						}
						pushEmOpen(replacerTokens, type);
						replacerTokens.push(createLinkToken(text$1, href$1, !tokens[i + 4]?.content?.startsWith(")")));
						pushEmClose(replacerTokens, type);
						if (tokens[i + 4]?.type === "text") {
							const afterText = tokens[i + 4].content?.replace(/^\)/, "");
							if (afterText) replacerTokens.push(textToken(afterText));
							tokens.splice(i, 5, ...replacerTokens);
						} else tokens.splice(i, 4, ...replacerTokens);
						if (i === 0) i = replacerTokens.length - 1;
						else i -= replacerTokens.length - 1;
						continue;
					}
					let href = tokens[i + 2]?.content || "";
					if (tokens[i + 4]?.type === "text" && !tokens[i + 4].content?.startsWith(")")) {
						href += tokens[i + 4]?.content || "";
						tokens[i + 4].content = "";
					}
					replacerTokens.push(createLinkToken(text$1, href, !tokens[i + 4]?.content?.startsWith(")")));
					if (tokens[i + 4]?.type === "text") {
						const afterText = tokens[i + 4].content?.replace(/^\)/, "");
						if (afterText) replacerTokens.push(textToken(afterText));
						tokens.splice(i, 5, ...replacerTokens);
					} else tokens.splice(i, 4, ...replacerTokens);
				}
				i -= replacerTokens.length - 1;
				continue;
			}
		} else if (curToken.type === "link_open" && curToken.markup === "linkify" && tokens[i - 1]?.type === "text" && tokens[i - 1].content?.endsWith("(")) {
			if (tokens[i - 2]?.type === "link_close") {
				const replacerTokens = [];
				const text$1 = tokens[i - 3].content || "";
				let href = curToken.attrs?.find((attr) => attr[0] === "href")?.[1] || "";
				if (tokens[i + 3]?.type === "text") {
					const m = (tokens[i + 3]?.content ?? "").indexOf(")");
					const loading = m === -1;
					if (m === -1) {
						href += tokens[i + 3]?.content?.slice(0, m) || "";
						tokens[i + 3].content = "";
					}
					replacerTokens.push(createLinkToken(text$1, href, loading));
					const afterText = tokens[i + 3].content?.replace(/^\)\**/, "");
					if (afterText) replacerTokens.push(textToken(afterText));
					tokens.splice(i - 4, 8, ...replacerTokens);
				} else {
					replacerTokens.push({
						type: "link",
						loading: true,
						href,
						title: "",
						text: text$1,
						children: [{
							type: "text",
							content: href,
							raw: href
						}],
						raw: String(`[${text$1}](${href})`)
					});
					tokens.splice(i - 4, 7, ...replacerTokens);
				}
				continue;
			} else if (tokens[i - 1].content === "](" && tokens[i - 3]?.type === "text" && tokens[i - 3].content?.endsWith(")")) if (tokens[i - 2]?.type === "strong_open") {
				const [beforeText, linText] = tokens[i - 3].content?.split("[**") || [];
				tokens[i + 1].content = linText || "";
				tokens[i - 3].content = beforeText || "";
				tokens[i - 1].content = "";
			} else if (tokens[i - 2]?.type === "em_open") {
				const [beforeText, linText] = tokens[i - 3].content?.split("[*") || [];
				tokens[i + 1].content = linText || "";
				tokens[i - 3].content = beforeText || "";
				tokens[i - 1].content = "";
			} else {
				const [beforeText, linText] = tokens[i - 3].content?.split("[") || [];
				tokens[i + 1].content = linText || "";
				tokens[i - 3].content = beforeText || "";
				tokens[i - 1].content = "";
			}
		}
		if (curToken.type === "link_close" && curToken.nesting === -1 && tokens[i + 1]?.type === "text" && tokens[i - 1]?.type === "text") {
			const text$1 = tokens[i - 1].content || "";
			const attrs = tokens[i - 2].attrs || [];
			const href = attrs.find((a) => a[0] === "href")?.[1] || "";
			const title = attrs.find((a) => a[0] === "title")?.[1] || "";
			let count = 3;
			let deleteCount = 2;
			const emphasisMatch = (tokens[i - 3]?.content || "").match(/^(\*+)$/);
			const replacerTokens = [];
			if (emphasisMatch) {
				deleteCount += 1;
				const type = emphasisMatch[1].length;
				pushEmOpen(replacerTokens, type);
			}
			if (curToken.markup !== "linkify" && tokens[i + 1].type === "text" && tokens[i + 1]?.content?.startsWith("](")) {
				count += 1;
				for (let j = i + 1; j < tokens.length; j++) {
					const type = emphasisMatch ? emphasisMatch[1].length : tokens[i - 3].markup.length;
					const t = tokens[j];
					if (type === 1 && t.type === "em_close") break;
					else if (type === 2 && t.type === "strong_close") break;
					else if (type === 3) {
						if (t.type === "em_close" || t.type === "strong_close") break;
					}
					count += 1;
				}
			}
			replacerTokens.push({
				type: "link",
				loading: false,
				href,
				title,
				text: text$1,
				children: [{
					type: "text",
					content: text$1,
					raw: text$1
				}],
				raw: String(`[${text$1}](${href})`)
			});
			if (emphasisMatch) {
				const type = emphasisMatch[1].length;
				pushEmClose(replacerTokens, type);
			}
			tokens.splice(i - deleteCount, count, ...replacerTokens);
			i -= replacerTokens.length - 1;
			continue;
		} else if (curToken.content?.startsWith("](") && tokens[i - 1].markup?.includes("*") && tokens[i - 4]?.type === "text" && tokens[i - 4].content?.endsWith("[")) {
			const type = tokens[i - 1].markup.length;
			const replacerTokens = [];
			const beforeText = tokens[i - 4].content.slice(0, tokens[i - 4].content.length - type);
			if (beforeText) replacerTokens.push(textToken(beforeText));
			pushEmOpen(replacerTokens, type);
			const text$1 = tokens[i - 2].content || "";
			let href = curToken.content.slice(2);
			let loading = true;
			if (tokens[i + 1]?.type === "text") {
				const m = (tokens[i + 1]?.content ?? "").indexOf(")");
				loading = m === -1;
				if (m === -1) {
					href += tokens[i + 1]?.content?.slice(0, m) || "";
					tokens[i + 1].content = "";
				}
			}
			replacerTokens.push(createLinkToken(text$1, href, loading));
			pushEmClose(replacerTokens, type);
			if (tokens[i + 1]?.type === "text") {
				const afterText = tokens[i + 1].content?.replace(/^\)\**/, "");
				if (afterText) replacerTokens.push(textToken(afterText));
				tokens.splice(i - 4, 8, ...replacerTokens);
			} else if (tokens[i + 1]?.type === "link_open") tokens.splice(i - 4, 10, ...replacerTokens);
			else tokens.splice(i - 4, 7, ...replacerTokens);
			i -= replacerTokens.length - 1;
			continue;
		} else if (curToken.content?.startsWith("](") && tokens[i - 1].type === "strong_close" && tokens[i - 4]?.type === "text" && tokens[i - 4]?.content?.includes("**[")) {
			const replacerTokens = [];
			const beforeText = tokens[i - 4].content.split("**[")[0];
			if (beforeText) replacerTokens.push(textToken(beforeText));
			pushEmOpen(replacerTokens, 2);
			const text$1 = tokens[i - 2].content || "";
			let href = curToken.content.slice(2);
			let loading = true;
			if (tokens[i + 1]?.type === "text") {
				const m = (tokens[i + 1]?.content ?? "").indexOf(")");
				loading = m === -1;
				if (m === -1) {
					href += tokens[i + 1]?.content?.slice(0, m) || "";
					tokens[i + 1].content = "";
				}
			}
			replacerTokens.push(createLinkToken(text$1, href, loading));
			pushEmClose(replacerTokens, 2);
			if (tokens[i + 1]?.type === "text") {
				const afterText = tokens[i + 1].content?.replace(/^\)\**/, "");
				if (afterText) replacerTokens.push(textToken(afterText));
				tokens.splice(i - 4, 8, ...replacerTokens);
			} else if (tokens[i + 1]?.type === "link_open") tokens.splice(i - 4, 10, ...replacerTokens);
			else tokens.splice(i - 4, 7, ...replacerTokens);
			i -= replacerTokens.length - 1;
			continue;
		} else if (curToken.type === "strong_close" && tokens[i + 1]?.type === "text" && tokens[i + 1].content?.includes("](") && tokens[i - 1].type === "text" && /\[.*$/.test(tokens[i - 1].content || "")) {
			const replacerTokens = [];
			const [beforeText, afterText] = tokens[i - 1].content?.split("[") || ["", ""];
			if (beforeText) replacerTokens.push(textToken(beforeText));
			pushEmOpen(replacerTokens, 2);
			let [text$1, href] = tokens[i + 1].content.split("](");
			text$1 = afterText + text$1;
			let deleteCount = 4;
			if (tokens[i + 2]?.type === "link_open") {
				const _href = tokens[i + 2].attrs?.find((a) => a[0] === "href")?.[1];
				if (tokens[i + 5]?.type === "text" && tokens[i + 5].content === ".") {
					href = (_href || href) + tokens[i + 5].content;
					tokens[i + 5].content = "";
				} else href = _href || href;
				deleteCount += 3;
			}
			let loading = true;
			if (curToken.nesting === -1) text$1 = text$1.replace(/\*+$/, "");
			if (tokens[i + 2]?.type === "text") {
				const m = (tokens[i + 2]?.content ?? "").indexOf(")");
				loading = m === -1;
				if (m === -1) {
					href += tokens[i + 2]?.content?.slice(0, m) || "";
					tokens[i + 2].content = "";
				}
			}
			replacerTokens.push(createLinkToken(text$1, href, loading));
			pushEmClose(replacerTokens, 2);
			tokens.splice(i - 2, deleteCount, ...replacerTokens);
		}
		if (curToken.type === "text" && /\*+\[[^\]]*$/.test(curToken.content || "") && tokens[i + 1]?.type === "strong_open" && tokens[i + 2]?.type === "text" && tokens[i + 2].content === "](" && tokens[i + 3]?.type === "link_open" && tokens[i + 5]?.type === "link_close" && tokens[i + 6]?.type === "text" && tokens[i + 6].content === ")" && tokens[i + 7]?.type === "strong_close") {
			const startMatch = (curToken.content || "").match(/^(\*+)\[(.*)$/);
			if (startMatch) {
				const finalLabel = (startMatch[2] || "") + startMatch[1];
				let href = tokens[i + 3]?.attrs?.find((a) => a[0] === "href")?.[1] || "";
				if (!href && tokens[i + 4]?.type === "text") href = tokens[i + 4].content || "";
				const out = [];
				pushEmOpen(out, 2);
				out.push(createLinkToken(finalLabel, href, false));
				pushEmClose(out, 2);
				tokens.splice(i, 9, ...out);
				i -= out.length - 1;
				continue;
			}
		}
	}
	return tokens;
}

//#endregion
//#region src/plugins/fixListItem.ts
function applyFixListItem(md) {
	md.core.ruler.after("inline", "fix_list_item_tokens", (state) => {
		const toks = state.tokens ?? [];
		for (let i = 0; i < toks.length; i++) {
			const t = toks[i];
			if (t && t.type === "inline" && Array.isArray(t.children)) try {
				t.children = fixListItem(t.children);
			} catch (e) {
				console.error("[applyFixListItem] failed to fix inline children", e);
			}
		}
	});
}
function fixListItem(tokens) {
	const last = tokens[tokens.length - 1];
	const lastContent = String(last?.content ?? "");
	if (last?.type === "text" && /^\s*\d+\.\s*$/.test(lastContent) && tokens[tokens.length - 2]?.tag === "br") tokens.splice(tokens.length - 1, 1);
	return tokens;
}

//#endregion
//#region src/plugins/fixStrongTokens.ts
function applyFixStrongTokens(md) {
	md.core.ruler.after("inline", "fix_strong_tokens", (state) => {
		const toks = state.tokens ?? [];
		for (let i = 0; i < toks.length; i++) {
			const t = toks[i];
			if (t && t.type === "inline" && Array.isArray(t.children)) try {
				t.children = fixStrongTokens(t.children);
			} catch (e) {
				console.error("[applyFixStrongTokens] failed to fix inline children", e);
			}
		}
	});
}
function fixStrongTokens(tokens) {
	let strongIndex = 0;
	const cleansStrong = /* @__PURE__ */ new Set();
	const cleansEm = /* @__PURE__ */ new Set();
	let emIndex = 0;
	for (let i$1 = 0; i$1 < tokens.length; i$1++) {
		const t = tokens[i$1];
		const type = t.type;
		if (type === "strong_open") {
			strongIndex++;
			const markup = String(t.markup ?? "");
			let j = i$1 - 1;
			while (j >= 0 && tokens[j].type === "text" && tokens[j].content === "") j--;
			const preToken = tokens[j];
			let k = i$1 + 1;
			while (k < tokens.length && tokens[k].type === "text" && tokens[k].content === "") k++;
			const postToken = tokens[k];
			if (markup === "__" && (preToken?.content?.endsWith("_") || postToken?.content?.startsWith("_") || postToken?.markup?.includes("_"))) {
				t.type = "text";
				t.tag = "";
				t.content = markup;
				t.raw = markup;
				t.markup = "";
				t.attrs = null;
				t.map = null;
				t.info = "";
				t.meta = null;
				cleansStrong.add(strongIndex);
			}
		} else if (type === "strong_close") {
			if (cleansStrong.has(strongIndex) && t.markup === "__") {
				t.type = "text";
				t.content = t.markup;
				t.raw = String(t.markup ?? "");
				t.tag = "";
				t.markup = "";
				t.attrs = null;
				t.map = null;
				t.info = "";
				t.meta = null;
			}
			strongIndex--;
			if (strongIndex < 0) strongIndex = 0;
		} else if (type === "em_open") {
			emIndex++;
			const markup = String(t.markup ?? "");
			let j = i$1 - 1;
			while (j >= 0 && tokens[j].type === "text" && tokens[j].content === "") j--;
			const preToken = tokens[j];
			let k = i$1 + 1;
			while (k < tokens.length && tokens[k].type === "text" && tokens[k].content === "") k++;
			const postToken = tokens[k];
			if (markup === "_" && (preToken?.content?.endsWith("_") || postToken?.content?.startsWith("_") || postToken?.markup?.includes("_"))) {
				t.type = "text";
				t.tag = "";
				t.content = markup;
				t.raw = markup;
				t.markup = "";
				t.attrs = null;
				t.map = null;
				t.info = "";
				t.meta = null;
				cleansEm.add(emIndex);
			}
		} else if (type === "em_close") {
			if (cleansEm.has(emIndex) && t.markup === "_") {
				t.type = "text";
				t.content = t.markup;
				t.raw = String(t.markup ?? "");
				t.tag = "";
				t.markup = "";
				t.attrs = null;
				t.map = null;
				t.info = "";
				t.meta = null;
			}
			emIndex--;
			if (emIndex < 0) emIndex = 0;
		}
	}
	if (tokens.length < 5) return tokens;
	const i = tokens.length - 4;
	const token = tokens[i];
	const fixedTokens = [...tokens];
	const nextToken = tokens[i + 1];
	const tokenContent = String(token.content ?? "");
	if (token.type === "link_open" && tokens[i - 1]?.type === "em_open" && tokens[i - 2]?.type === "text" && tokens[i - 2].content?.endsWith("*")) {
		const textContent = String(tokens[i - 2].content ?? "").slice(0, -1);
		const replaceTokens = [
			{
				type: "strong_open",
				tag: "strong",
				attrs: null,
				map: null,
				children: null,
				content: "",
				markup: "**",
				info: "",
				meta: null,
				raw: ""
			},
			tokens[i],
			tokens[i + 1],
			tokens[i + 2],
			{
				type: "strong_close",
				tag: "strong",
				attrs: null,
				map: null,
				children: null,
				content: "",
				markup: "**",
				info: "",
				meta: null,
				raw: ""
			}
		];
		if (textContent) replaceTokens.unshift({
			type: "text",
			content: textContent,
			raw: textContent
		});
		fixedTokens.splice(i - 2, 6, ...replaceTokens);
	} else if (token.type === "text" && tokenContent.endsWith("*") && nextToken.type === "em_open") {
		const _nextToken = tokens[i + 2];
		const count = _nextToken?.type === "text" ? 4 : 3;
		const insert = [
			{
				type: "strong_open",
				tag: "strong",
				attrs: null,
				map: null,
				children: null,
				content: "",
				markup: "**",
				info: "",
				meta: null,
				raw: ""
			},
			{
				type: "text",
				content: _nextToken?.type === "text" ? String(_nextToken.content ?? "") : "",
				raw: _nextToken?.type === "text" ? String(_nextToken.content ?? "") : ""
			},
			{
				type: "strong_close",
				tag: "strong",
				attrs: null,
				map: null,
				children: null,
				content: "",
				markup: "**",
				info: "",
				meta: null,
				raw: ""
			}
		];
		const beforeText = tokenContent.slice(0, -1);
		if (beforeText) insert.unshift({
			type: "text",
			content: beforeText,
			raw: beforeText
		});
		fixedTokens.splice(i, count, ...insert);
		return fixedTokens;
	}
	return fixedTokens;
}

//#endregion
//#region src/plugins/fixTableTokens.ts
function applyFixTableTokens(md) {
	md.core.ruler.after("block", "fix_table_tokens", (state) => {
		const s = state;
		try {
			const fixed = fixTableTokens(s.tokens ?? []);
			if (Array.isArray(fixed)) s.tokens = fixed;
		} catch (e) {
			console.error("[applyFixTableTokens] failed to fix table tokens", e);
		}
	});
}
function createStart() {
	return [
		{
			type: "table_open",
			tag: "table",
			attrs: null,
			map: null,
			children: null,
			content: "",
			markup: "",
			info: "",
			level: 0,
			loading: true,
			meta: null
		},
		{
			type: "thead_open",
			tag: "thead",
			attrs: null,
			block: true,
			level: 1,
			children: null
		},
		{
			type: "tr_open",
			tag: "tr",
			attrs: null,
			block: true,
			level: 2,
			children: null
		}
	];
}
function createEnd() {
	return [
		{
			type: "tr_close",
			tag: "tr",
			attrs: null,
			block: true,
			level: 2,
			children: null
		},
		{
			type: "thead_close",
			tag: "thead",
			attrs: null,
			block: true,
			level: 1,
			children: null
		},
		{
			type: "table_close",
			tag: "table",
			attrs: null,
			map: null,
			children: null,
			content: "",
			markup: "",
			info: "",
			level: 0,
			meta: null
		}
	];
}
function createTh(text$1) {
	return [
		{
			type: "th_open",
			tag: "th",
			attrs: null,
			block: true,
			level: 3,
			children: null
		},
		{
			type: "inline",
			tag: "",
			children: [{
				tag: "",
				type: "text",
				block: false,
				content: text$1,
				children: null
			}],
			content: text$1,
			level: 4,
			attrs: null,
			block: true
		},
		{
			type: "th_close",
			tag: "th",
			attrs: null,
			block: true,
			level: 3,
			children: null
		}
	];
}
function fixTableTokens(tokens) {
	const fixedTokens = [...tokens];
	if (tokens.length < 3) return fixedTokens;
	const i = tokens.length - 2;
	const token = tokens[i];
	if (token.type === "inline") {
		const tcontent = String(token.content ?? "");
		const childContent = String(token.children?.[0]?.content ?? "");
		if (!tcontent.includes("\n") && /^\|(?:[^|\n]+\|?)+/.test(tcontent)) {
			const body = childContent.slice(1).split("|").map((i$1) => i$1.trim()).filter(Boolean).flatMap((i$1) => createTh(i$1));
			const insert = [
				...createStart(),
				...body,
				...createEnd()
			];
			fixedTokens.splice(i - 1, 3, ...insert);
		} else if (/^\|(?:[^|\n]+\|)+\n\|:?-/.test(tcontent)) {
			const body = childContent.slice(1, -1).split("|").map((i$1) => i$1.trim()).flatMap((i$1) => createTh(i$1));
			const insert = [
				...createStart(),
				...body,
				...createEnd()
			];
			fixedTokens.splice(i - 1, 3, ...insert);
		} else if (/^\|(?:[^|\n:]+\|)+\n\|:?$/.test(tcontent)) {
			token.content = tcontent.slice(0, -2);
			token.children.splice(2, 1);
		}
	}
	return fixedTokens;
}

//#endregion
//#region src/findMatchingClose.ts
function findMatchingClose(src, startIdx, open, close) {
	const len = src.length;
	if (open === "$$" && close === "$$") {
		let i$1 = startIdx;
		while (i$1 < len - 1) {
			if (src[i$1] === "$" && src[i$1 + 1] === "$") {
				let k = i$1 - 1;
				let backslashes = 0;
				while (k >= 0 && src[k] === "\\") {
					backslashes++;
					k--;
				}
				if (backslashes % 2 === 0) return i$1;
			}
			i$1++;
		}
		return -1;
	}
	const openChar = open[open.length - 1];
	const closeSeq = close;
	let depth = 0;
	let i = startIdx;
	while (i < len) {
		if (src.slice(i, i + closeSeq.length) === closeSeq) {
			let k = i - 1;
			let backslashes = 0;
			while (k >= 0 && src[k] === "\\") {
				backslashes++;
				k--;
			}
			if (backslashes % 2 === 0) {
				if (depth === 0) return i;
				depth--;
				i += closeSeq.length;
				continue;
			}
		}
		const ch = src[i];
		if (ch === "\\") {
			i += 2;
			continue;
		}
		if (ch === openChar) depth++;
		else if (ch === closeSeq[closeSeq.length - 1]) {
			if (depth > 0) depth--;
		}
		i++;
	}
	return -1;
}
var findMatchingClose_default = findMatchingClose;

//#endregion
//#region src/plugins/isMathLike.ts
const TEX_BRACE_COMMANDS = [
	"boldsymbol",
	"mathbb",
	"mathcal",
	"mathfrak",
	"mathrm",
	"mathit",
	"mathsf",
	"vec",
	"hat",
	"bar",
	"tilde",
	"overline",
	"underline",
	"mathscr",
	"mathnormal",
	"operatorname",
	"mathbf*"
];
const ESCAPED_TEX_BRACE_COMMANDS = TEX_BRACE_COMMANDS.map((c) => c.replace(/[.*+?^${}()|[\\]"\]/g, "\\$&")).join("|");
const TEX_CMD_RE = /\\[a-z]+/i;
const PREFIX_CLASS = "(?:\\\\|\\u0008)";
const TEX_CMD_WITH_BRACES_RE = new RegExp(`${PREFIX_CLASS}(?:${ESCAPED_TEX_BRACE_COMMANDS})\\s*\\{[^}]+\\}`, "i");
const TEX_BRACE_CMD_START_RE = new RegExp(`(?:${PREFIX_CLASS})?(?:${ESCAPED_TEX_BRACE_COMMANDS})\s*\{`, "i");
const TEX_SPECIFIC_RE = /\\(?:text|frac|left|right|times)/;
const OPS_RE = /* @__PURE__ */ new RegExp("(?:^|[^+])\\+(?!\\+)|[=\\-*/^<>]|\\\\times|\\\\pm|\\\\cdot|\\\\le|\\\\ge|\\\\neq");
const HYPHENATED_MULTIWORD_RE = /\b[A-Z]{2,}-[A-Z]{2,}\b/i;
const FUNC_CALL_RE = /[A-Z]+\s*\([^)]+\)/i;
const WORDS_RE = /\b(?:sin|cos|tan|log|ln|exp|sqrt|frac|sum|lim|int|prod)\b/;
const DATE_TIME_RE = /\b\d{4}\/\d{1,2}\/\d{1,2}(?:[ T]\d{1,2}:\d{2}(?::\d{2})?)?\b/;
function isMathLike(s) {
	if (!s) return false;
	const norm = s.replace(/[\u0008\v\f]/g, (ch) => {
		switch (ch) {
			case "\b": return "\\b";
			case "\v": return "\\v";
			case "\f": return "\\f";
			default: return ch;
		}
	});
	const stripped = norm.trim();
	if (DATE_TIME_RE.test(stripped)) return false;
	if (stripped.includes("**")) return false;
	if (stripped.length > 2e3) return true;
	const texCmd = TEX_CMD_RE.test(norm);
	const texCmdWithBraces = TEX_CMD_WITH_BRACES_RE.test(norm);
	const texBraceStart = TEX_BRACE_CMD_START_RE.test(norm);
	const texSpecific = TEX_SPECIFIC_RE.test(norm);
	const superSub = /(?:^|[^\w\\])(?:[A-Z]|\\[A-Z]+)_(?:\{[^}]+\}|[A-Z0-9\\])/i.test(norm) || /(?:^|[^\w\\])(?:[A-Z]|\\[A-Z]+)\^(?:\{[^}]+\}|[A-Z0-9\\])/i.test(norm);
	const ops = OPS_RE.test(norm) && !HYPHENATED_MULTIWORD_RE.test(norm);
	const funcCall = FUNC_CALL_RE.test(norm);
	const words = WORDS_RE.test(norm);
	const pureWord = /^\([a-z]\)$/i.test(stripped) || /^(?:[a-z]|pi)$/i.test(stripped);
	const chemicalLike = /^(?:[A-Z][a-z]?(?:_\{?\d+\}?|\^\{?\d+\}?)?)+$/.test(stripped);
	return texCmd || texCmdWithBraces || texBraceStart || texSpecific || superSub || ops || funcCall || words || pureWord || chemicalLike;
}

//#endregion
//#region src/plugins/math.ts
const KATEX_COMMANDS = [
	"ldots",
	"cdots",
	"quad",
	"in",
	"displaystyle",
	"int_",
	"lim",
	"lim_",
	"ce",
	"pu",
	"end",
	"infty",
	"perp",
	"mid",
	"operatorname",
	"to",
	"rightarrow",
	"leftarrow",
	"math",
	"mathrm",
	"mathit",
	"mathbb",
	"mathcal",
	"mathfrak",
	"implies",
	"alpha",
	"beta",
	"gamma",
	"delta",
	"epsilon",
	"lambda",
	"sum",
	"sum_",
	"prod",
	"sqrt",
	"fbox",
	"boxed",
	"color",
	"rule",
	"edef",
	"fcolorbox",
	"hline",
	"hdashline",
	"cdot",
	"times",
	"pm",
	"le",
	"ge",
	"neq",
	"sin",
	"cos",
	"tan",
	"log",
	"ln",
	"exp",
	"frac",
	"text",
	"left",
	"right"
];
const ANY_COMMANDS = [
	"cdot",
	"mathbf{",
	"partial",
	"mu_{"
];
const ESCAPED_KATEX_COMMANDS = KATEX_COMMANDS.slice().sort((a, b) => b.length - a.length).map((c) => c.replace(/[.*+?^${}()|[\\]\\\]/g, "\\$&")).join("|");
const CONTROL_CHARS_CLASS = "[	\r\b\f\v]";
const ESCAPED_MKATWX_COMMANDS = new RegExp(`([^\\\\])(${ANY_COMMANDS.map((c) => c).join("|")})+`, "g");
const SPAN_CURLY_RE = /span\{([^}]+)\}/;
const OPERATORNAME_SPAN_RE = /\\operatorname\{span\}\{((?:[^{}]|\{[^}]*\})+)\}/;
const SINGLE_BACKSLASH_NEWLINE_RE = /(^|[^\\])\\\r?\n/g;
const ENDING_SINGLE_BACKSLASH_RE = /(^|[^\\])\\$/g;
const DEFAULT_MATH_RE = new RegExp(`(${CONTROL_CHARS_CLASS})|(${ESCAPED_KATEX_COMMANDS})\\b`, "g");
const MATH_RE_CACHE = /* @__PURE__ */ new Map();
const BRACE_CMD_RE_CACHE = /* @__PURE__ */ new Map();
function getMathRegex(commands) {
	if (!commands) return DEFAULT_MATH_RE;
	const arr = [...commands];
	arr.sort((a, b) => b.length - a.length);
	const key = arr.join("");
	const cached = MATH_RE_CACHE.get(key);
	if (cached) return cached;
	const commandPattern = `(?:${arr.map((c) => c.replace(/[.*+?^${}()|[\\]\\"\]/g, "\\$&")).join("|")})`;
	const re = new RegExp(`(${CONTROL_CHARS_CLASS})|(${commandPattern})\\b`, "g");
	MATH_RE_CACHE.set(key, re);
	return re;
}
function getBraceCmdRegex(useDefault, commands) {
	const arr = useDefault ? [] : [...commands ?? []];
	if (!useDefault) arr.sort((a, b) => b.length - a.length);
	const key = useDefault ? "__default__" : arr.join("");
	const cached = BRACE_CMD_RE_CACHE.get(key);
	if (cached) return cached;
	const braceEscaped = useDefault ? [ESCAPED_TEX_BRACE_COMMANDS, ESCAPED_KATEX_COMMANDS].filter(Boolean).join("|") : [arr.map((c) => c.replace(/[.*+?^${}()|[\\]\\\]/g, "\\$&")).join("|"), ESCAPED_TEX_BRACE_COMMANDS].filter(Boolean).join("|");
	const re = new RegExp(`(^|[^\\\\\\w])(${braceEscaped})\\s*\\{`, "g");
	BRACE_CMD_RE_CACHE.set(key, re);
	return re;
}
const CONTROL_MAP = {
	"	": "t",
	"\r": "r",
	"\b": "b",
	"\f": "f",
	"\v": "v"
};
function countUnescapedStrong(s) {
	const re = /(^|[^\\])(__|\*\*)/g;
	let c = 0;
	while (re.exec(s) !== null) c++;
	return c;
}
function normalizeStandaloneBackslashT(s, opts) {
	const commands = opts?.commands ?? KATEX_COMMANDS;
	const escapeExclamation = opts?.escapeExclamation ?? true;
	const useDefault = opts?.commands == null;
	const re = getMathRegex(useDefault ? void 0 : commands);
	let out = s.replace(re, (m, control, cmd, offset, str) => {
		if (control !== void 0 && CONTROL_MAP[control] !== void 0) return `\\${CONTROL_MAP[control]}`;
		if (cmd && commands.includes(cmd)) {
			const prev = str && typeof offset === "number" ? str[offset - 1] : void 0;
			if (prev === "\\" || prev && /\w/.test(prev)) return m;
			return `\\${cmd}`;
		}
		return m;
	});
	if (escapeExclamation) out = out.replace(/(^|[^\\])!/g, "$1\\!");
	let result = out;
	const braceCmdRe = getBraceCmdRegex(useDefault, useDefault ? void 0 : commands);
	result = result.replace(braceCmdRe, (_m, p1, p2) => `${p1}\\${p2}{`);
	result = result.replace(SPAN_CURLY_RE, "span\\{$1\\}").replace(OPERATORNAME_SPAN_RE, "\\operatorname{span}\\{$1\\}");
	result = result.replace(SINGLE_BACKSLASH_NEWLINE_RE, "$1\\\\\n");
	result = result.replace(ENDING_SINGLE_BACKSLASH_RE, "$1\\\\");
	result = result.replace(ESCAPED_MKATWX_COMMANDS, "$1\\$2");
	return result;
}
function isPlainBracketMathLike(content) {
	const stripped = content.trim();
	if (!isMathLike(stripped)) return false;
	if (!(/\\[a-z]+/i.test(stripped) || /\d/.test(stripped) || /[=+*/^<>]|\\times|\\pm|\\cdot|\\le|\\ge|\\neq/.test(stripped) || /[_^]/.test(stripped)) && /\s-\s/.test(stripped)) return false;
	return true;
}
function applyMath(md, mathOpts) {
	const mathInline = (state, silent) => {
		const s = state;
		const strict = !!mathOpts?.strictDelimiters;
		if (/^\*[^*]+/.test(s.src)) return false;
		const delimiters = [["$", "$"], ["\\(", "\\)"]];
		let searchPos = 0;
		let preMathPos = 0;
		for (const [open, close] of delimiters) {
			const src = s.src;
			let foundAny = false;
			const pushText = (text$1) => {
				if (text$1 === "undefined" || text$1 == null) text$1 = "";
				if (text$1 === "\\") {
					s.pos = s.pos + text$1.length;
					searchPos = s.pos;
					return;
				}
				if (text$1 === "\\)" || text$1 === "\\(") {
					const t$1 = s.push("text_special", "", 0);
					t$1.content = text$1 === "\\)" ? ")" : "(";
					t$1.markup = text$1;
					s.pos = s.pos + text$1.length;
					searchPos = s.pos;
					return;
				}
				if (!text$1) return;
				const t = s.push("text", "", 0);
				t.content = text$1;
				s.pos = s.pos + text$1.length;
				searchPos = s.pos;
			};
			while (true) {
				if (searchPos >= src.length) break;
				const index = src.indexOf(open, searchPos);
				if (index === -1) break;
				if (index > 0) {
					let i = index - 1;
					while (i >= 0 && src[i] === " ") i--;
					if (i >= 0 && src[i] === "]") return false;
				}
				const endIdx = findMatchingClose_default(src, index + open.length, open, close);
				if (endIdx === -1) {
					const content$1 = src.slice(index + open.length);
					if (content$1.includes(open)) {
						searchPos = src.indexOf(open, index + open.length);
						continue;
					}
					if (endIdx === -1) {
						if (!strict && isMathLike(content$1) && !content$1.includes("`")) {
							searchPos = index + open.length;
							foundAny = true;
							if (!silent) {
								s.pending = "";
								const isStrongPrefix = countUnescapedStrong(preMathPos ? src.slice(preMathPos, searchPos) : src.slice(0, searchPos)) % 2 === 1;
								if (preMathPos) pushText(src.slice(preMathPos, searchPos));
								else {
									let text$1 = src.slice(0, searchPos);
									if (text$1.endsWith(open)) text$1 = text$1.slice(0, text$1.length - open.length);
									pushText(text$1);
								}
								if (isStrongPrefix) {
									const strongToken = s.push("strong_open", "", 0);
									strongToken.markup = src.slice(0, index + 2);
									const token = s.push("math_inline", "math", 0);
									token.content = normalizeStandaloneBackslashT(content$1, mathOpts);
									token.markup = open === "$$" ? "$$" : open === "\\(" ? "\\(\\)" : open === "$" ? "$" : "()";
									token.raw = `${open}${content$1}${close}`;
									token.loading = true;
									strongToken.content = content$1;
									s.push("strong_close", "", 0);
								} else {
									const token = s.push("math_inline", "math", 0);
									token.content = normalizeStandaloneBackslashT(content$1, mathOpts);
									token.markup = open === "$$" ? "$$" : open === "\\(" ? "\\(\\)" : open === "$" ? "$" : "()";
									token.raw = `${open}${content$1}${close}`;
									token.loading = true;
								}
								s.pos = src.length;
							}
							searchPos = src.length;
							preMathPos = searchPos;
						}
						break;
					}
				}
				const content = src.slice(index + open.length, endIdx);
				const hasBacktick = content.includes("`");
				if (strict ? hasBacktick : hasBacktick || !(open === "$") && !isMathLike(content)) {
					searchPos = endIdx + close.length;
					const text$1 = src.slice(s.pos, searchPos);
					if (!s.pending) pushText(text$1);
					continue;
				}
				foundAny = true;
				if (!silent) {
					const before = src.slice(s.pos - s.pending.length, index);
					let toPushBefore = src.slice(0, searchPos) ? src.slice(preMathPos, index) : before;
					const isStrongPrefix = countUnescapedStrong(toPushBefore) % 2 === 1;
					if (index !== s.pos && isStrongPrefix) toPushBefore = s.pending + src.slice(s.pos, index);
					if (s.pending !== toPushBefore) {
						s.pending = "";
						if (isStrongPrefix) {
							const _match = toPushBefore.match(/(\*+)/);
							const after = toPushBefore.slice(_match.index + _match[0].length);
							pushText(toPushBefore.slice(0, _match.index));
							const strongToken = s.push("strong_open", "", 0);
							strongToken.markup = _match[0];
							const textToken$1 = s.push("text", "", 0);
							textToken$1.content = after;
							s.push("strong_close", "", 0);
						} else pushText(toPushBefore);
					}
					if (isStrongPrefix) {
						const strongToken = s.push("strong_open", "", 0);
						strongToken.markup = "**";
						const token = s.push("math_inline", "math", 0);
						token.content = normalizeStandaloneBackslashT(content, mathOpts);
						token.markup = open === "$$" ? "$$" : open === "\\(" ? "\\(\\)" : open === "$" ? "$" : "()";
						token.raw = `${open}${content}${close}`;
						token.loading = false;
						const raw = src.slice(endIdx + close.length);
						const isBeforeClose = raw.startsWith("*");
						if (isBeforeClose) s.push("strong_close", "", 0);
						if (raw) {
							s.pos = endIdx + close.length;
							searchPos = s.pos;
							preMathPos = searchPos;
						}
						if (!isBeforeClose) s.push("strong_close", "", 0);
						continue;
					} else {
						const token = s.push("math_inline", "math", 0);
						token.content = normalizeStandaloneBackslashT(content, mathOpts);
						token.markup = open === "$$" ? "$$" : open === "\\(" ? "\\(\\)" : open === "$" ? "$" : "()";
						token.raw = `${open}${content}${close}`;
						token.loading = false;
					}
				}
				searchPos = endIdx + close.length;
				preMathPos = searchPos;
				s.pos = searchPos;
			}
			if (foundAny) {
				if (!silent) {
					if (searchPos < src.length) pushText(src.slice(searchPos));
					s.pos = src.length;
				} else s.pos = searchPos;
				return true;
			}
		}
		return false;
	};
	const mathBlock = (state, startLine, endLine, silent) => {
		const s = state;
		const strict = mathOpts?.strictDelimiters;
		const delimiters = strict ? [["\\[", "\\]"], ["$$", "$$"]] : [
			["\\[", "\\]"],
			["[", "]"],
			["$$", "$$"]
		];
		const startPos = s.bMarks[startLine] + s.tShift[startLine];
		let lineText = s.src.slice(startPos, s.eMarks[startLine]).trim();
		let matched = false;
		let openDelim = "";
		let closeDelim = "";
		let skipFirstLine = false;
		for (const [open, close] of delimiters) if (lineText.startsWith(open)) if (open.includes("[")) if (mathOpts?.strictDelimiters) {
			if (lineText.replace("\\", "") === "[") {
				if (startLine + 1 < endLine) {
					matched = true;
					openDelim = open;
					closeDelim = close;
					break;
				}
				continue;
			}
		} else if (lineText.replace("\\", "") === "[") {
			if (startLine + 1 < endLine) {
				matched = true;
				openDelim = open;
				closeDelim = close;
				break;
			}
			continue;
		} else {
			const lastToken = s.tokens[s.tokens.length - 1];
			if (lastToken && lastToken.type === "list_item_open" && lastToken.mark === "-" && lineText.slice(open.length, lineText.indexOf("]")).trim() === "x") continue;
			if (lineText.replace("\\", "").startsWith("[") && !lineText.includes("](")) {
				const closeIndex = lineText.indexOf("]");
				if (lineText.slice(closeIndex).trim() !== "]") continue;
				const inner = lineText.slice(open.length, closeIndex);
				if (open === "[" ? isPlainBracketMathLike(inner) : isMathLike(inner)) {
					matched = true;
					openDelim = open;
					closeDelim = close;
					break;
				}
				continue;
			}
		}
		else {
			matched = true;
			openDelim = open;
			closeDelim = close;
			break;
		}
		else if (lineText.endsWith(open) && !lineText.slice(0, lineText.length - open.length).trim().includes(open) && startLine + 1 < endLine) {
			s.push("text", "", 0).content = lineText.slice(0, lineText.length - open.length);
			const nextLineStartPos = s.bMarks[startLine + 1] + s.tShift[startLine + 1];
			lineText = s.src.slice(nextLineStartPos, s.eMarks[startLine + 1]).trim();
			if (open === "$$") {
				skipFirstLine = true;
				matched = true;
				openDelim = open;
				closeDelim = close;
				break;
			}
		}
		if (!matched) return false;
		if (silent) return true;
		if (lineText.includes(closeDelim) && lineText.indexOf(closeDelim) > openDelim.length) {
			const startDelimIndex = lineText.indexOf(openDelim);
			const endDelimIndex = lineText.indexOf(closeDelim, startDelimIndex + openDelim.length);
			const content$1 = lineText.slice(startDelimIndex + openDelim.length, endDelimIndex);
			const token$1 = s.push("math_block", "math", 0);
			token$1.content = normalizeStandaloneBackslashT(content$1);
			token$1.markup = openDelim === "$$" ? "$$" : openDelim === "[" ? "[]" : "\\[\\]";
			token$1.map = [startLine, startLine + 1];
			token$1.raw = `${openDelim}${content$1}${closeDelim}`;
			token$1.block = true;
			token$1.loading = false;
			s.line = startLine + 1;
			return true;
		}
		let nextLine = startLine;
		let content = "";
		let found = false;
		const firstLineContent = lineText === openDelim ? "" : lineText.slice(openDelim.length);
		if (firstLineContent.includes(closeDelim)) {
			const endIndex = firstLineContent.indexOf(closeDelim);
			content = firstLineContent.slice(0, endIndex);
			found = true;
			nextLine = startLine;
		} else {
			if (firstLineContent && !skipFirstLine) content = firstLineContent;
			for (nextLine = startLine + 1; nextLine < endLine; nextLine++) {
				const lineStart = s.bMarks[nextLine] + s.tShift[nextLine];
				const lineEnd = s.eMarks[nextLine];
				const currentLine = s.src.slice(lineStart - 1, lineEnd);
				if (currentLine.trim() === closeDelim) {
					found = true;
					break;
				} else if (currentLine.includes(closeDelim)) {
					found = true;
					const endIndex = currentLine.indexOf(closeDelim);
					content += (content ? "\n" : "") + currentLine.slice(0, endIndex);
					break;
				}
				content += (content ? "\n" : "") + currentLine;
			}
		}
		if (strict && !found) return false;
		if (!(openDelim === "[" ? isPlainBracketMathLike(content) : isMathLike(content))) return false;
		const token = s.push("math_block", "math", 0);
		token.content = normalizeStandaloneBackslashT(content);
		token.markup = openDelim === "$$" ? "$$" : openDelim === "[" ? "[]" : "\\[\\]";
		token.raw = `${openDelim}${content}${content.startsWith("\n") ? "\n" : ""}${closeDelim}`;
		token.map = [startLine, nextLine + 1];
		token.block = true;
		token.loading = !found;
		s.line = nextLine + 1;
		return true;
	};
	md.inline.ruler.before("escape", "math", mathInline);
	md.block.ruler.before("paragraph", "math_block", mathBlock, { alt: [
		"paragraph",
		"reference",
		"blockquote",
		"list"
	] });
}

//#endregion
//#region src/renderers/index.ts
function applyRenderRules(md) {
	const defaultImage = md.renderer.rules.image || function(tokens, idx, options, env, self) {
		const tokensAny = tokens;
		const selfShape = self;
		return selfShape.renderToken ? selfShape.renderToken(tokensAny, idx, options) : "";
	};
	md.renderer.rules.image = (tokens, idx, options, env, self) => {
		const tokensAny = tokens;
		tokensAny[idx].attrSet?.("loading", "lazy");
		return defaultImage(tokensAny, idx, options, env, self);
	};
	md.renderer.rules.fence = md.renderer.rules.fence || ((tokens, idx) => {
		const tokenShape = tokens[idx];
		const info = String(tokenShape.info ?? "").trim();
		return `<pre class="${info ? `language-${md.utils.escapeHtml(info.split(/\s+/g)[0])}` : ""}"><code>${md.utils.escapeHtml(String(tokenShape.content ?? ""))}</code></pre>`;
	});
}

//#endregion
//#region src/factory.ts
function factory(opts = {}) {
	const md = new src_default({
		html: true,
		linkify: true,
		typographer: true,
		stream: true,
		...opts.markdownItOptions ?? {}
	});
	if (opts.enableMath ?? true) applyMath(md, {
		...getDefaultMathOptions() ?? {},
		...opts.mathOptions ?? {}
	});
	if (opts.enableContainers ?? true) applyContainers(md);
	applyFixLinkTokens(md);
	applyFixStrongTokens(md);
	applyFixListItem(md);
	applyFixTableTokens(md);
	applyRenderRules(md);
	applyFixHtmlInlineTokens(md, { customHtmlTags: opts.customHtmlTags });
	return md;
}

//#endregion
//#region src/parser/inline-parsers/checkbox-parser.ts
function parseCheckboxToken(token) {
	const tokenMeta = token.meta ?? {};
	return {
		type: "checkbox",
		checked: tokenMeta.checked === true,
		raw: tokenMeta.checked ? "[x]" : "[ ]"
	};
}
function parseCheckboxInputToken(token) {
	const tokenAny = token;
	const rawAttr = tokenAny.attrGet ? tokenAny.attrGet("checked") : void 0;
	const checked = rawAttr === "" || rawAttr === "true";
	return {
		type: "checkbox_input",
		checked,
		raw: checked ? "[x]" : "[ ]"
	};
}

//#endregion
//#region src/parser/inline-parsers/emoji-parser.ts
function parseEmojiToken(token) {
	const name = String(token.content ?? "");
	return {
		type: "emoji",
		name,
		markup: String(token.markup ?? ""),
		raw: `:${name}:`
	};
}

//#endregion
//#region src/parser/inline-parsers/emphasis-parser.ts
function parseEmphasisToken(tokens, startIndex, options) {
	const children = [];
	let emText = "";
	let i = startIndex + 1;
	const innerTokens = [];
	while (i < tokens.length && tokens[i].type !== "em_close") {
		emText += String(tokens[i].content ?? tokens[i]?.text ?? "");
		innerTokens.push(tokens[i]);
		i++;
	}
	children.push(...parseInlineTokens(innerTokens, void 0, void 0, {
		requireClosingStrong: options?.requireClosingStrong,
		customHtmlTags: options?.customHtmlTags
	}));
	return {
		node: {
			type: "emphasis",
			children,
			raw: `*${emText}*`
		},
		nextIndex: i < tokens.length ? i + 1 : tokens.length
	};
}

//#endregion
//#region src/parser/inline-parsers/fence-parser.ts
const TRAILING_FENCE_LINE_RE = /\r?\n[ \t]*`+\s*$/;
const DIFF_HEADER_PREFIXES = [
	"diff ",
	"index ",
	"--- ",
	"+++ ",
	"@@ "
];
const NEWLINE_RE = /\r?\n/;
function splitUnifiedDiff(content) {
	const orig = [];
	const updated = [];
	for (const rawLine of content.split(NEWLINE_RE)) {
		const line = rawLine;
		if (DIFF_HEADER_PREFIXES.some((p) => line.startsWith(p))) continue;
		if (line.length >= 2 && line[0] === "-" && line[1] === " ") orig.push(` ${line.slice(1)}`);
		else if (line.length >= 2 && line[0] === "+" && line[1] === " ") updated.push(` ${line.slice(1)}`);
		else {
			orig.push(line);
			updated.push(line);
		}
	}
	return {
		original: orig.join("\n"),
		updated: updated.join("\n")
	};
}
function parseFenceToken(token) {
	const hasMap = Array.isArray(token.map) && token.map.length === 2;
	const tokenMeta = token.meta ?? {};
	const closed = typeof tokenMeta.closed === "boolean" ? tokenMeta.closed : void 0;
	const info = String(token.info ?? "");
	const diff = info.startsWith("diff");
	const language = diff ? (() => {
		const s = info;
		const sp = s.indexOf(" ");
		return sp === -1 ? "" : String(s.slice(sp + 1) ?? "");
	})() : info;
	let content = String(token.content ?? "");
	if (TRAILING_FENCE_LINE_RE.test(content)) content = content.replace(TRAILING_FENCE_LINE_RE, "");
	if (diff) {
		const { original, updated } = splitUnifiedDiff(content);
		return {
			type: "code_block",
			language,
			code: String(updated ?? ""),
			raw: String(content ?? ""),
			diff,
			loading: closed === true ? false : closed === false ? true : !hasMap,
			originalCode: original,
			updatedCode: updated
		};
	}
	return {
		type: "code_block",
		language,
		code: String(content ?? ""),
		raw: String(content ?? ""),
		diff,
		loading: closed === true ? false : closed === false ? true : !hasMap
	};
}

//#endregion
//#region src/parser/inline-parsers/footnote-ref-parser.ts
function parseFootnoteRefToken(token) {
	const tokenMeta = token.meta ?? {};
	return {
		type: "footnote_reference",
		id: String(tokenMeta.label ?? ""),
		raw: `[^${String(tokenMeta.label ?? "")}]`
	};
}

//#endregion
//#region src/parser/inline-parsers/hardbreak-parser.ts
function parseHardbreakToken() {
	return {
		type: "hardbreak",
		raw: "\\\n"
	};
}

//#endregion
//#region src/parser/inline-parsers/highlight-parser.ts
function parseHighlightToken(tokens, startIndex, options) {
	const children = [];
	let markText = "";
	let i = startIndex + 1;
	const innerTokens = [];
	while (i < tokens.length && tokens[i].type !== "mark_close") {
		markText += String(tokens[i].content ?? "");
		innerTokens.push(tokens[i]);
		i++;
	}
	children.push(...parseInlineTokens(innerTokens, void 0, void 0, {
		requireClosingStrong: options?.requireClosingStrong,
		customHtmlTags: options?.customHtmlTags
	}));
	return {
		node: {
			type: "highlight",
			children,
			raw: `==${markText}==`
		},
		nextIndex: i < tokens.length ? i + 1 : tokens.length
	};
}

//#endregion
//#region src/parser/inline-parsers/html-inline-code-parser.ts
const VOID_TAGS$1 = new Set([
	"area",
	"base",
	"br",
	"col",
	"embed",
	"hr",
	"img",
	"input",
	"link",
	"meta",
	"param",
	"source",
	"track",
	"wbr"
]);
function getTagName(html) {
	const match = html.match(/^<\s*(?:\/\s*)?([\w-]+)/);
	return match ? match[1].toLowerCase() : "";
}
function isClosingTag(html) {
	return /^<\s*\//.test(html);
}
function isSelfClosing(tag, html) {
	return /\/\s*>\s*$/.test(html) || VOID_TAGS$1.has(tag);
}
function normalizeCustomTag(t) {
	const raw = String(t ?? "").trim();
	if (!raw) return "";
	const m = raw.match(/^[<\s/]*([A-Z][\w-]*)/i);
	return m ? m[1].toLowerCase() : "";
}
function tokenToRaw(token) {
	const shape = token;
	const raw = shape.raw ?? shape.content ?? shape.markup ?? "";
	return String(raw ?? "");
}
function stringifyTokens(tokens) {
	return tokens.map(tokenToRaw).join("");
}
function findMatchingClosing(tokens, startIndex, tag) {
	let depth = 0;
	for (let idx = startIndex; idx < tokens.length; idx++) {
		const t = tokens[idx];
		if (t.type !== "html_inline") continue;
		const content = String(t.content ?? "");
		const tTag = getTagName(content);
		const closing = isClosingTag(content);
		const selfClosing = isSelfClosing(tTag, content);
		if (!closing && !selfClosing && tTag === tag) {
			depth++;
			continue;
		}
		if (closing && tTag === tag) {
			if (depth === 0) return idx;
			depth--;
		}
	}
	return -1;
}
function collectHtmlFragment(tokens, startIndex, tag) {
	const fragmentTokens = [tokens[startIndex]];
	let innerTokens = [];
	let nextIndex = startIndex + 1;
	let closed = false;
	const closingIndex = tag ? findMatchingClosing(tokens, startIndex + 1, tag) : -1;
	if (closingIndex !== -1) {
		innerTokens = tokens.slice(startIndex + 1, closingIndex);
		fragmentTokens.push(...innerTokens, tokens[closingIndex]);
		nextIndex = closingIndex + 1;
		closed = true;
	} else {
		innerTokens = tokens.slice(startIndex + 1);
		if (innerTokens.length) fragmentTokens.push(...innerTokens);
		nextIndex = tokens.length;
	}
	return {
		closed,
		html: stringifyTokens(fragmentTokens),
		innerTokens,
		nextIndex
	};
}
function parseHtmlInlineCodeToken(token, tokens, i, parseInlineTokens$1, raw, pPreToken, options) {
	const code$1 = String(token.content ?? "");
	const tag = getTagName(code$1);
	const customTags = options?.customHtmlTags;
	const customTagSet = customTags && customTags.length ? new Set(customTags.map(normalizeCustomTag).filter(Boolean)) : null;
	if (!tag) return [{
		type: "inline_code",
		code: code$1,
		raw: code$1
	}, i + 1];
	if (tag === "br") return [{
		type: "hardbreak",
		raw: code$1
	}, i + 1];
	const closing = isClosingTag(code$1);
	const selfClosing = isSelfClosing(tag, code$1);
	if (closing) return [{
		type: "html_inline",
		tag,
		content: code$1,
		children: [],
		raw: code$1,
		loading: false
	}, i + 1];
	if (tag === "a") {
		const fragment$1 = collectHtmlFragment(tokens, i, tag);
		const innerTokens = fragment$1.innerTokens;
		const hrefMatch = code$1.match(/href\s*=\s*"([^"]+)"|href\s*=\s*'([^']+)'|href\s*=\s*([^\s>]+)/i);
		const href = hrefMatch ? hrefMatch[1] || hrefMatch[2] || hrefMatch[3] : "";
		const children$1 = innerTokens.length ? parseInlineTokens$1(innerTokens, raw, pPreToken, options) : [];
		const textContent = innerTokens.length ? stringifyTokens(innerTokens) : href || "";
		if (!children$1.length && textContent) children$1.push({
			type: "text",
			content: textContent,
			raw: textContent
		});
		return [{
			type: "link",
			href: String(href ?? ""),
			title: null,
			text: textContent,
			children: children$1,
			loading: !fragment$1.closed,
			raw: fragment$1.html || code$1
		}, fragment$1.nextIndex];
	}
	if (selfClosing) return [{
		type: customTagSet?.has(tag) ? tag : "html_inline",
		tag,
		content: code$1,
		children: [],
		raw: code$1,
		loading: false
	}, i + 1];
	const fragment = collectHtmlFragment(tokens, i, tag);
	if (tag === "p" || tag === "div") return [{
		type: "paragraph",
		children: fragment.innerTokens.length ? parseInlineTokens$1(fragment.innerTokens, raw, pPreToken, options) : [],
		raw: fragment.html
	}, fragment.nextIndex];
	const children = fragment.innerTokens.length ? parseInlineTokens$1(fragment.innerTokens, raw, pPreToken, options) : [];
	let content = fragment.html || code$1;
	let loading = !fragment.closed;
	let autoClosed = false;
	if (!fragment.closed) {
		const closeTag = `</${tag}>`;
		if (!content.toLowerCase().includes(closeTag.toLowerCase())) content += closeTag;
		autoClosed = true;
		loading = true;
	}
	const attrs = [];
	const attrRegex = /\s([\w:-]+)(?:\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s"'>]+)))?/g;
	let match;
	while ((match = attrRegex.exec(code$1)) !== null) {
		const attrName = match[1];
		const attrValue = match[2] || match[3] || match[4] || "";
		attrs.push([attrName, attrValue]);
	}
	if (customTagSet?.has(tag)) return [{
		type: tag,
		tag,
		attrs,
		content: fragment.innerTokens.length ? stringifyTokens(fragment.innerTokens) : "",
		children: fragment.innerTokens.length ? parseInlineTokens$1(fragment.innerTokens, raw, pPreToken, options) : [],
		raw: content,
		loading: token.loading || loading,
		autoClosed
	}, fragment.nextIndex];
	return [{
		type: "html_inline",
		tag,
		attrs,
		content,
		children,
		raw: content,
		loading,
		autoClosed
	}, fragment.nextIndex];
}

//#endregion
//#region src/parser/inline-parsers/image-parser.ts
function parseImageToken(token, loading = false) {
	let attrs = token.attrs ?? [];
	let childWithAttrs = null;
	if ((!attrs || attrs.length === 0) && Array.isArray(token.children)) for (const child of token.children) {
		const childAttrs = child?.attrs;
		if (Array.isArray(childAttrs) && childAttrs.length > 0) {
			attrs = childAttrs;
			childWithAttrs = child;
			break;
		}
	}
	const src = String(attrs.find((attr) => attr[0] === "src")?.[1] ?? "");
	const altAttr = attrs.find((attr) => attr[0] === "alt")?.[1];
	let alt = "";
	if (altAttr != null && String(altAttr).length > 0) alt = String(altAttr);
	else if (childWithAttrs?.content != null && String(childWithAttrs.content).length > 0) alt = String(childWithAttrs.content);
	else if (Array.isArray(childWithAttrs?.children) && childWithAttrs.children[0]?.content) alt = String(childWithAttrs.children[0].content);
	else if (Array.isArray(token.children) && token.children[0]?.content) alt = String(token.children[0].content);
	else if (token.content != null && String(token.content).length > 0) alt = String(token.content);
	const _title = attrs.find((attr) => attr[0] === "title")?.[1] ?? null;
	const title = _title === null ? null : String(_title);
	const raw = String(token.content ?? "");
	return {
		type: "image",
		src,
		alt,
		title,
		raw,
		loading
	};
}

//#endregion
//#region src/parser/inline-parsers/inline-code-parser.ts
function parseInlineCodeToken(token) {
	const code$1 = String(token.content ?? "");
	return {
		type: "inline_code",
		code: code$1,
		raw: code$1
	};
}

//#endregion
//#region src/parser/inline-parsers/insert-parser.ts
function parseInsertToken(tokens, startIndex, options) {
	const children = [];
	let insText = "";
	let i = startIndex + 1;
	const innerTokens = [];
	while (i < tokens.length && tokens[i].type !== "ins_close") {
		insText += String(tokens[i].content ?? "");
		innerTokens.push(tokens[i]);
		i++;
	}
	children.push(...parseInlineTokens(innerTokens, void 0, void 0, {
		requireClosingStrong: options?.requireClosingStrong,
		customHtmlTags: options?.customHtmlTags
	}));
	return {
		node: {
			type: "insert",
			children,
			raw: `++${String(insText)}++`
		},
		nextIndex: i < tokens.length ? i + 1 : tokens.length
	};
}

//#endregion
//#region src/parser/inline-parsers/link-parser.ts
function parseLinkToken(tokens, startIndex, options) {
	const attrs = tokens[startIndex].attrs ?? [];
	const href = String(attrs.find((attr) => attr[0] === "href")?.[1] ?? "");
	const _title = attrs.find((attr) => attr[0] === "title")?.[1] ?? null;
	const title = _title === null ? null : String(_title);
	let i = startIndex + 1;
	const linkTokens = [];
	let loading = true;
	while (i < tokens.length && tokens[i].type !== "link_close") {
		linkTokens.push(tokens[i]);
		i++;
	}
	if (tokens[i]?.type === "link_close") loading = false;
	const children = parseInlineTokens(linkTokens, void 0, void 0, {
		requireClosingStrong: options?.requireClosingStrong,
		customHtmlTags: options?.customHtmlTags
	});
	const linkText = children.map((node) => {
		const nodeAny = node;
		if ("content" in node) return String(nodeAny.content ?? "");
		return String(nodeAny.raw ?? "");
	}).join("");
	return {
		node: {
			type: "link",
			href,
			title,
			text: linkText,
			children,
			raw: String(`[${linkText}](${href}${title ? ` "${title}"` : ""})`),
			loading
		},
		nextIndex: i < tokens.length ? i + 1 : tokens.length
	};
}

//#endregion
//#region src/parser/inline-parsers/math-inline-parser.ts
function parseMathInlineToken(token) {
	const content = token.content ?? "";
	const raw = token.raw === "$$" ? `$${content}$` : token.raw || "";
	return {
		type: "math_inline",
		content,
		loading: !!token.loading,
		raw
	};
}

//#endregion
//#region src/parser/inline-parsers/reference-parser.ts
function parseReferenceToken(token) {
	return {
		type: "reference",
		id: String(token.content ?? ""),
		raw: String(token.markup ?? `[${token.content ?? ""}]`)
	};
}

//#endregion
//#region src/parser/inline-parsers/strikethrough-parser.ts
function parseStrikethroughToken(tokens, startIndex, options) {
	const children = [];
	let sText = "";
	let i = startIndex + 1;
	const innerTokens = [];
	while (i < tokens.length && tokens[i].type !== "s_close") {
		sText += String(tokens[i].content ?? "");
		innerTokens.push(tokens[i]);
		i++;
	}
	children.push(...parseInlineTokens(innerTokens, void 0, void 0, {
		requireClosingStrong: options?.requireClosingStrong,
		customHtmlTags: options?.customHtmlTags
	}));
	return {
		node: {
			type: "strikethrough",
			children,
			raw: `~~${sText}~~`
		},
		nextIndex: i < tokens.length ? i + 1 : tokens.length
	};
}

//#endregion
//#region src/parser/inline-parsers/strong-parser.ts
function parseStrongToken(tokens, startIndex, raw, options) {
	const children = [];
	let strongText = "";
	let i = startIndex + 1;
	const innerTokens = [];
	let openCount = 1;
	while (i < tokens.length) {
		if (tokens[i].type === "strong_close") {
			if (openCount === 1) break;
			openCount--;
		}
		if (tokens[i].type === "strong_open") openCount++;
		strongText += String(tokens[i].content ?? "");
		innerTokens.push(tokens[i]);
		i++;
	}
	children.push(...parseInlineTokens(innerTokens, raw, void 0, {
		requireClosingStrong: options?.requireClosingStrong,
		customHtmlTags: options?.customHtmlTags
	}));
	return {
		node: {
			type: "strong",
			children,
			raw: `**${String(strongText)}**`
		},
		nextIndex: i < tokens.length ? i + 1 : tokens.length
	};
}

//#endregion
//#region src/parser/inline-parsers/subscript-parser.ts
function parseSubscriptToken(tokens, startIndex, options) {
	const children = [];
	let subText = "";
	let i = startIndex + 1;
	const innerTokens = [];
	while (i < tokens.length && tokens[i].type !== "sub_close") {
		subText += String(tokens[i].content ?? "");
		innerTokens.push(tokens[i]);
		i++;
	}
	children.push(...parseInlineTokens(innerTokens, void 0, void 0, {
		requireClosingStrong: options?.requireClosingStrong,
		customHtmlTags: options?.customHtmlTags
	}));
	const startContent = String(tokens[startIndex].content ?? "");
	const display = subText || startContent;
	return {
		node: {
			type: "subscript",
			children: children.length > 0 ? children : [{
				type: "text",
				content: display,
				raw: display
			}],
			raw: `~${display}~`
		},
		nextIndex: i < tokens.length ? i + 1 : tokens.length
	};
}

//#endregion
//#region src/parser/inline-parsers/superscript-parser.ts
function parseSuperscriptToken(tokens, startIndex, options) {
	const children = [];
	let supText = "";
	let i = startIndex + 1;
	const innerTokens = [];
	while (i < tokens.length && tokens[i].type !== "sup_close") {
		supText += String(tokens[i].content ?? "");
		innerTokens.push(tokens[i]);
		i++;
	}
	children.push(...parseInlineTokens(innerTokens, void 0, void 0, {
		requireClosingStrong: options?.requireClosingStrong,
		customHtmlTags: options?.customHtmlTags
	}));
	return {
		node: {
			type: "superscript",
			children: children.length > 0 ? children : [{
				type: "text",
				content: supText || String(tokens[startIndex].content ?? ""),
				raw: supText || String(tokens[startIndex].content ?? "")
			}],
			raw: `^${supText || String(tokens[startIndex].content ?? "")}^`
		},
		nextIndex: i < tokens.length ? i + 1 : tokens.length
	};
}

//#endregion
//#region src/parser/inline-parsers/text-parser.ts
function parseTextToken(token) {
	const content = String(token.content ?? "");
	return {
		type: "text",
		content,
		raw: content
	};
}

//#endregion
//#region src/parser/inline-parsers/index.ts
const STRONG_PAIR_RE = /\*\*([\s\S]*?)\*\*/;
function escapeRegExp(str) {
	return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
const AUTOLINK_PROTOCOL_RE = /^(?:https?:\/\/|mailto:|ftp:\/\/)/i;
const AUTOLINK_GENERIC_RE = /:\/\//;
function isLikelyUrl(href) {
	if (!href) return false;
	return AUTOLINK_PROTOCOL_RE.test(href) || AUTOLINK_GENERIC_RE.test(href);
}
function parseInlineTokens(tokens, raw, pPreToken, options) {
	if (!tokens || tokens.length === 0) return [];
	const result = [];
	let currentTextNode = null;
	let i = 0;
	const requireClosingStrong = options?.requireClosingStrong;
	function resetCurrentTextNode() {
		currentTextNode = null;
	}
	function handleEmphasisAndStrikethrough(content, token) {
		if (/[^~]*~{2,}[^~]+/.test(content)) {
			let idx = content.indexOf("~~");
			if (idx === -1) idx = 0;
			const _text = content.slice(0, idx);
			if (_text) if (currentTextNode) {
				currentTextNode.content += _text;
				currentTextNode.raw += _text;
			} else {
				currentTextNode = {
					type: "text",
					content: String(_text ?? ""),
					raw: String(token.content ?? "")
				};
				result.push(currentTextNode);
			}
			const { node } = parseStrikethroughToken([
				{
					type: "s_open",
					tag: "s",
					content: "",
					markup: "*",
					info: "",
					meta: null
				},
				{
					type: "text",
					tag: "",
					content: content.slice(idx).replace(/~/g, ""),
					markup: "",
					info: "",
					meta: null
				},
				{
					type: "s_close",
					tag: "s",
					content: "",
					markup: "*",
					info: "",
					meta: null
				}
			], 0);
			resetCurrentTextNode();
			pushNode(node);
			i++;
			return true;
		}
		if (/\*\*/.test(content)) {
			const openIdx = content.indexOf("**");
			const beforeText = openIdx > -1 ? content.slice(0, openIdx) : "";
			if (beforeText) pushText(beforeText, beforeText);
			if (openIdx === -1) {
				i++;
				return true;
			}
			const exec = STRONG_PAIR_RE.exec(content);
			let inner = "";
			let after = "";
			if (exec && typeof exec.index === "number") {
				inner = exec[1];
				after = content.slice(exec.index + exec[0].length);
			} else {
				if (requireClosingStrong) {
					pushText(content, content);
					i++;
					return true;
				}
				inner = content.slice(openIdx + 2);
				after = "";
			}
			const { node } = parseStrongToken([
				{
					type: "strong_open",
					tag: "strong",
					content: "",
					markup: "**",
					info: "",
					meta: null
				},
				{
					type: "text",
					tag: "",
					content: inner,
					markup: "",
					info: "",
					meta: null
				},
				{
					type: "strong_close",
					tag: "strong",
					content: "",
					markup: "**",
					info: "",
					meta: null
				}
			], 0, raw, options);
			resetCurrentTextNode();
			pushNode(node);
			if (after) {
				handleToken({
					type: "text",
					content: after,
					raw: after
				});
				i--;
			}
			i++;
			return true;
		}
		if (/[^*]*\*[^*]+/.test(content)) {
			let idx = content.indexOf("*");
			if (idx === -1) idx = 0;
			const _text = content.slice(0, idx);
			if (_text) if (currentTextNode) {
				currentTextNode.content += _text;
				currentTextNode.raw += _text;
			} else {
				currentTextNode = {
					type: "text",
					content: String(_text ?? ""),
					raw: String(token.content ?? "")
				};
				result.push(currentTextNode);
			}
			const closeIndex = content.indexOf("*", idx + 1);
			const { node } = parseEmphasisToken([
				{
					type: "em_open",
					tag: "em",
					content: "",
					markup: "*",
					info: "",
					meta: null
				},
				{
					type: "text",
					tag: "",
					content: content.slice(idx, closeIndex > -1 ? closeIndex + 1 : void 0).replace(/\*/g, ""),
					markup: "",
					info: "",
					meta: null
				},
				{
					type: "em_close",
					tag: "em",
					content: "",
					markup: "*",
					info: "",
					meta: null
				}
			], 0, options);
			if (closeIndex !== -1 && closeIndex < content.length - 1) {
				const afterContent = content.slice(closeIndex + 1);
				if (afterContent) handleToken({
					type: "text",
					content: afterContent,
					raw: afterContent
				});
			}
			resetCurrentTextNode();
			pushNode(node);
			i++;
			return true;
		}
		return false;
	}
	function handleInlineCodeContent(content, _token) {
		if (!content.includes("`")) return false;
		const codeStart = content.indexOf("`");
		let runLen = 1;
		for (let k = codeStart + 1; k < content.length && content[k] === "`"; k++) runLen++;
		const closingSeq = "`".repeat(runLen);
		const searchFrom = codeStart + runLen;
		const codeEnd = content.indexOf(closingSeq, searchFrom);
		if (codeEnd === -1) {
			if (runLen === 1) {
				const beforeText$1 = content.slice(0, codeStart);
				const codeContent$1 = content.slice(codeStart + 1);
				if (beforeText$1) if (!handleEmphasisAndStrikethrough(beforeText$1, _token)) pushText(beforeText$1, beforeText$1);
				else i--;
				pushParsed({
					type: "inline_code",
					code: codeContent$1,
					raw: String(codeContent$1)
				});
				i++;
				return true;
			}
			let merged = content;
			for (let j = i + 1; j < tokens.length; j++) merged += String((tokens[j].content ?? "") + (tokens[j].markup ?? ""));
			i = tokens.length - 1;
			pushText(merged, merged);
			i++;
			return true;
		}
		resetCurrentTextNode();
		const beforeText = content.slice(0, codeStart);
		const codeContent = content.slice(codeStart + runLen, codeEnd);
		const after = content.slice(codeEnd + runLen);
		if (beforeText) if (!handleEmphasisAndStrikethrough(beforeText, _token)) pushText(beforeText, beforeText);
		else i--;
		pushParsed({
			type: "inline_code",
			code: codeContent,
			raw: String(codeContent ?? "")
		});
		if (after) {
			handleToken({
				type: "text",
				content: after,
				raw: after
			});
			i--;
		}
		i++;
		return true;
	}
	function pushParsed(node) {
		resetCurrentTextNode();
		result.push(node);
	}
	function pushToken(token) {
		resetCurrentTextNode();
		result.push(token);
	}
	function pushNode(node) {
		pushParsed(node);
	}
	function pushText(content, raw$1) {
		if (currentTextNode) {
			currentTextNode.content += content;
			currentTextNode.raw += raw$1 ?? content;
		} else {
			currentTextNode = {
				type: "text",
				content: String(content ?? ""),
				raw: String(raw$1 ?? content ?? "")
			};
			result.push(currentTextNode);
		}
	}
	while (i < tokens.length) {
		const token = tokens[i];
		handleToken(token);
	}
	function handleToken(token) {
		switch (token.type) {
			case "text":
				handleTextToken(token);
				break;
			case "softbreak":
				if (currentTextNode) {
					currentTextNode.content += "\n";
					currentTextNode.raw += "\n";
				} else {
					currentTextNode = {
						type: "text",
						content: "\n",
						raw: "\n"
					};
					result.push(currentTextNode);
				}
				i++;
				break;
			case "code_inline":
				pushNode(parseInlineCodeToken(token));
				i++;
				break;
			case "html_inline": {
				const [node, index] = parseHtmlInlineCodeToken(token, tokens, i, parseInlineTokens, raw, pPreToken, options);
				pushNode(node);
				i = index;
				break;
			}
			case "link_open":
				handleLinkOpen(token);
				break;
			case "image":
				resetCurrentTextNode();
				pushNode(parseImageToken(token));
				i++;
				break;
			case "strong_open": {
				resetCurrentTextNode();
				const { node, nextIndex } = parseStrongToken(tokens, i, token.content, options);
				pushNode(node);
				i = nextIndex;
				break;
			}
			case "em_open": {
				resetCurrentTextNode();
				const { node, nextIndex } = parseEmphasisToken(tokens, i, options);
				pushNode(node);
				i = nextIndex;
				break;
			}
			case "s_open": {
				resetCurrentTextNode();
				const { node, nextIndex } = parseStrikethroughToken(tokens, i, options);
				pushNode(node);
				i = nextIndex;
				break;
			}
			case "mark_open": {
				resetCurrentTextNode();
				const { node, nextIndex } = parseHighlightToken(tokens, i, options);
				pushNode(node);
				i = nextIndex;
				break;
			}
			case "ins_open": {
				resetCurrentTextNode();
				const { node, nextIndex } = parseInsertToken(tokens, i, options);
				pushNode(node);
				i = nextIndex;
				break;
			}
			case "sub_open": {
				resetCurrentTextNode();
				const { node, nextIndex } = parseSubscriptToken(tokens, i, options);
				pushNode(node);
				i = nextIndex;
				break;
			}
			case "sup_open": {
				resetCurrentTextNode();
				const { node, nextIndex } = parseSuperscriptToken(tokens, i, options);
				pushNode(node);
				i = nextIndex;
				break;
			}
			case "sub":
				resetCurrentTextNode();
				pushNode({
					type: "subscript",
					children: [{
						type: "text",
						content: String(token.content ?? ""),
						raw: String(token.content ?? "")
					}],
					raw: `~${String(token.content ?? "")}~`
				});
				i++;
				break;
			case "sup":
				resetCurrentTextNode();
				pushNode({
					type: "superscript",
					children: [{
						type: "text",
						content: String(token.content ?? ""),
						raw: String(token.content ?? "")
					}],
					raw: `^${String(token.content ?? "")}^`
				});
				i++;
				break;
			case "emoji": {
				resetCurrentTextNode();
				const preToken = tokens[i - 1];
				if (preToken?.type === "text" && /\|:-+/.test(String(preToken.content ?? ""))) pushText("", "");
				else pushNode(parseEmojiToken(token));
				i++;
				break;
			}
			case "checkbox":
				resetCurrentTextNode();
				pushNode(parseCheckboxToken(token));
				i++;
				break;
			case "checkbox_input":
				resetCurrentTextNode();
				pushNode(parseCheckboxInputToken(token));
				i++;
				break;
			case "footnote_ref":
				resetCurrentTextNode();
				pushNode(parseFootnoteRefToken(token));
				i++;
				break;
			case "footnote_anchor": {
				resetCurrentTextNode();
				const meta = token.meta ?? {};
				pushParsed({
					type: "footnote_anchor",
					id: String(meta.label ?? token.content ?? ""),
					raw: String(token.content ?? "")
				});
				i++;
				break;
			}
			case "hardbreak":
				resetCurrentTextNode();
				pushNode(parseHardbreakToken());
				i++;
				break;
			case "fence":
				resetCurrentTextNode();
				pushNode(parseFenceToken(tokens[i]));
				i++;
				break;
			case "math_inline":
				resetCurrentTextNode();
				if (!token.content && token.markup === "$" && tokens[i + 1]?.type === "text" && tokens[i + 2]?.type === "math_inline") {
					pushNode(parseMathInlineToken({
						...token,
						content: tokens[i + 1].content
					}));
					i += 2;
				} else pushNode(parseMathInlineToken(token));
				i++;
				break;
			case "reference":
				handleReference(token);
				break;
			case "text_special":
				pushText(String(token.content ?? ""), String(token.content ?? ""));
				i++;
				break;
			default:
				pushToken(token);
				i++;
				break;
		}
	}
	function handleTextToken(token) {
		let index = result.length - 1;
		let content = String(token.content ?? "").replace(/\\/g, "");
		if (token.content === "<" || content === "1" && tokens[i - 1]?.tag === "br") {
			i++;
			return;
		}
		if (Array.from(content.matchAll(/\$/g)).length === 1 && content.endsWith("$")) content = content.slice(0, -1);
		if (content.endsWith("undefined") && !raw?.endsWith("undefined")) content = content.slice(0, -9);
		for (; index >= 0; index--) {
			const item = result[index];
			if (item.type === "text") {
				currentTextNode = null;
				content = item.content + content;
				continue;
			}
			break;
		}
		if (index < result.length - 1) result.splice(index + 1);
		const nextToken = tokens[i + 1];
		if (pPreToken?.type === "list_item_open" && /^\d$/.test(content)) {
			i++;
			return;
		}
		if (content === "`" || content === "|" || content === "$" || /^\*+$/.test(content)) {
			i++;
			return;
		}
		if (!nextToken && /[^\]]\s*\(\s*$/.test(content)) content = content.replace(/\(\s*$/, "");
		if (handleCheckboxLike(content)) return;
		const preToken = tokens[i - 1];
		if (content === "[" && !nextToken?.markup?.includes("*") || content === "]" && !preToken?.markup?.includes("*")) {
			i++;
			return;
		}
		if (handleInlineCodeContent(content, token)) return;
		if (handleInlineImageContent(content, token)) return;
		if (tokens[i + 1]?.type !== "link_open" && handleInlineLinkContent(content, token)) return;
		if (handleEmphasisAndStrikethrough(content, token)) return;
		if (!content) {
			i++;
			return;
		}
		const textNode = parseTextToken({
			...token,
			content
		});
		if (currentTextNode) {
			currentTextNode.content += textNode.content.replace(/(\*+|\(|\\)$/, "");
			currentTextNode.raw += textNode.raw;
		} else {
			const maybeMath = preToken?.tag === "br" && tokens[i - 2]?.content === "[";
			if (!tokens[i + 1]) textNode.content = textNode.content.replace(/(\*+|\(|\\)$/, "");
			currentTextNode = textNode;
			currentTextNode.center = maybeMath;
			result.push(currentTextNode);
		}
		i++;
	}
	function handleLinkOpen(token) {
		resetCurrentTextNode();
		const href = token.attrs?.find(([name]) => name === "href")?.[1];
		if (raw && tokens[i + 1].type === "text") {
			let text$1 = String(tokens[i + 1]?.content ?? "");
			const escText = escapeRegExp(text$1);
			if (!(/* @__PURE__ */ new RegExp(`\\[${escText}\\s*\\]`)).test(raw)) {
				const hrefAttr$1 = token.attrs?.find(([name]) => name === "href")?.[1] ?? "";
				if (!raw.includes("[") && isLikelyUrl(String(hrefAttr$1))) {
					resetCurrentTextNode();
					pushParsed({
						type: "link",
						href: String(hrefAttr$1),
						title: null,
						text: text$1,
						children: [{
							type: "text",
							content: text$1,
							raw: text$1
						}],
						loading: false
					});
					i += 3;
					return;
				}
				if (tokens[i + 2]?.type === "strong_open") {
					i += 2;
					while (i < tokens.length - 1 && tokens[i] && tokens[i]?.type !== "link_close") {
						text$1 += String(tokens[i]?.markup || tokens[i]?.content || "");
						i++;
					}
					pushParsed({
						type: "link",
						href: String(hrefAttr$1),
						title: null,
						text: text$1,
						children: [{
							type: "text",
							content: text$1,
							raw: text$1
						}],
						loading: false
					});
					i += 1;
				} else {
					i += 2;
					while (i < tokens.length && tokens[i].type !== "link_close") {
						text$1 += String(tokens[i]?.content || "");
						i++;
					}
					const loading = tokens[i].type !== "link_close";
					pushParsed({
						type: "link",
						href: String(hrefAttr$1),
						title: null,
						text: text$1,
						children: [{
							type: "text",
							content: text$1,
							raw: text$1
						}],
						loading
					});
				}
				return;
			}
		}
		if (raw && href) {
			const loadingMath = /* @__PURE__ */ new RegExp(`\\(\\s*${escapeRegExp(href)}\\s*\\)`);
			const pre = result.length > 0 ? result[result.length - 1] : void 0;
			const loading = !loadingMath.test(raw);
			if (loading && pre) {
				let preText = "";
				if (pre) {
					if (pre.type === "link") preText = String(pre.text ?? "");
					else if (pre.type === "text") preText = String(pre.content ?? "");
					else if (pre.content && typeof pre.content === "string") preText = String(pre.content ?? "").slice(1, -1);
				}
				if ((/* @__PURE__ */ new RegExp(`\\[${escapeRegExp(preText)}\\s*\\]\\(`)).test(raw)) {
					const text$1 = String(preText ?? "");
					resetCurrentTextNode();
					const node$1 = {
						type: "link",
						href: "",
						title: null,
						text: text$1,
						children: [{
							type: "text",
							content: text$1,
							raw: text$1
						}],
						loading
					};
					result.splice(result.length - 1, 1, node$1);
					i += 3;
					if (String(tokens[i]?.content ?? "") === ".") i++;
					return;
				}
			}
		}
		const { node, nextIndex } = parseLinkToken(tokens, i, { requireClosingStrong });
		i = nextIndex;
		const hrefAttr = token.attrs?.find(([name]) => name === "href")?.[1];
		const hrefStr = String(hrefAttr ?? "");
		if (raw && hrefStr) {
			const openIdx = raw.indexOf("](");
			if (openIdx === -1) {} else {
				const closeIdx = raw.indexOf(")", openIdx + 2);
				if (closeIdx === -1) node.loading = true;
				else if (node.loading) {
					if (raw.slice(openIdx + 2, closeIdx).includes(hrefStr)) node.loading = false;
				}
			}
		}
		pushParsed(node);
	}
	function handleReference(token) {
		resetCurrentTextNode();
		const nextToken = tokens[i + 1];
		const preToken = tokens[i - 1];
		const preResult = result[result.length - 1];
		const nextIsTextNotStartingParens = nextToken?.type === "text" && !String(nextToken.content ?? "").startsWith("(");
		const preIsTextEndingBracketOrOnlySpace = preToken?.type === "text" && /\]$|^\s*$/.test(String(preToken.content ?? ""));
		if (nextIsTextNotStartingParens || preIsTextEndingBracketOrOnlySpace) pushNode(parseReferenceToken(token));
		else if (nextToken && nextToken.type === "text") nextToken.content = String(token.markup ?? "") + String(nextToken.content ?? "");
		else if (preResult && preResult.type === "text") {
			preResult.content = String(preResult.content ?? "") + String(token.markup ?? "");
			preResult.raw = String(preResult.raw ?? "") + String(token.markup ?? "");
		}
		i++;
	}
	function handleInlineLinkContent(content, _token) {
		const linkStart = content.indexOf("[");
		if (linkStart === -1) return false;
		let textNodeContent = content.slice(0, linkStart);
		const linkEnd = content.indexOf("](", linkStart);
		if (linkEnd !== -1) {
			const textToken$1 = tokens[i + 2];
			let text$1 = content.slice(linkStart + 1, linkEnd);
			if (text$1.includes("[")) {
				const secondLinkStart = text$1.indexOf("[");
				textNodeContent += content.slice(0, linkStart + secondLinkStart + 1);
				const newLinkStart = linkStart + secondLinkStart + 1;
				text$1 = content.slice(newLinkStart + 1, linkEnd);
			}
			const nextToken = tokens[i + 1];
			if (content.endsWith("](") && nextToken?.type === "link_open" && textToken$1) {
				const last = tokens[i + 4];
				let index = 4;
				let loading$1 = true;
				if (last?.type === "text" && last.content === ")") {
					index++;
					loading$1 = false;
				} else if (last?.type === "text" && last.content === ".") i++;
				if (textNodeContent) pushText(textNodeContent, textNodeContent);
				pushParsed({
					type: "link",
					href: String(textToken$1.content ?? ""),
					title: null,
					text: text$1,
					children: [{
						type: "text",
						content: text$1,
						raw: text$1
					}],
					loading: loading$1
				});
				i += index;
				return true;
			}
			const linkContentEnd = content.indexOf(")", linkEnd);
			const href = linkContentEnd !== -1 ? content.slice(linkEnd + 2, linkContentEnd) : "";
			const loading = linkContentEnd === -1;
			let emphasisMatch = textNodeContent.match(/\*+$/);
			if (emphasisMatch) textNodeContent = textNodeContent.replace(/\*+$/, "");
			if (textNodeContent) pushText(textNodeContent, textNodeContent);
			if (!emphasisMatch) emphasisMatch = text$1.match(/^\*+/);
			if (!requireClosingStrong && emphasisMatch) {
				const type = emphasisMatch[0].length;
				text$1 = text$1.replace(/^\*+/, "").replace(/\*+$/, "");
				const newTokens = [];
				if (type === 1) newTokens.push({
					type: "em_open",
					tag: "em",
					nesting: 1
				});
				else if (type === 2) newTokens.push({
					type: "strong_open",
					tag: "strong",
					nesting: 1
				});
				else if (type === 3) {
					newTokens.push({
						type: "strong_open",
						tag: "strong",
						nesting: 1
					});
					newTokens.push({
						type: "em_open",
						tag: "em",
						nesting: 1
					});
				}
				newTokens.push({
					type: "link",
					href,
					title: null,
					text: text$1,
					children: [{
						type: "text",
						content: text$1,
						raw: text$1
					}],
					loading
				});
				if (type === 1) {
					newTokens.push({
						type: "em_close",
						tag: "em",
						nesting: -1
					});
					const { node } = parseEmphasisToken(newTokens, 0, options);
					pushNode(node);
				} else if (type === 2) {
					newTokens.push({
						type: "strong_close",
						tag: "strong",
						nesting: -1
					});
					const { node } = parseStrongToken(newTokens, 0, void 0, options);
					pushNode(node);
				} else if (type === 3) {
					newTokens.push({
						type: "em_close",
						tag: "em",
						nesting: -1
					});
					newTokens.push({
						type: "strong_close",
						tag: "strong",
						nesting: -1
					});
					const { node } = parseStrongToken(newTokens, 0, void 0, options);
					pushNode(node);
				} else {
					const { node } = parseEmphasisToken(newTokens, 0, options);
					pushNode(node);
				}
			} else pushParsed({
				type: "link",
				href,
				title: null,
				text: text$1,
				children: [{
					type: "text",
					content: text$1,
					raw: text$1
				}],
				loading
			});
			const afterText = linkContentEnd !== -1 ? content.slice(linkContentEnd + 1) : "";
			if (afterText) {
				handleToken({
					type: "text",
					content: afterText,
					raw: afterText
				});
				i--;
			}
			i++;
			return true;
		}
		return false;
	}
	function handleInlineImageContent(content, token) {
		const imageStart = content.indexOf("![");
		if (imageStart === -1) return false;
		const textNodeContent = content.slice(0, imageStart);
		if (!currentTextNode) currentTextNode = {
			type: "text",
			content: textNodeContent,
			raw: textNodeContent
		};
		else currentTextNode.content += textNodeContent;
		result.push(currentTextNode);
		currentTextNode = null;
		pushParsed(parseImageToken(token, true));
		i++;
		return true;
	}
	function handleCheckboxLike(content) {
		if (!(content?.startsWith("[") && pPreToken?.type === "list_item_open")) return false;
		const w = content.slice(1).match(/[^\s\]]/);
		if (w === null) {
			i++;
			return true;
		}
		if (w && /x/i.test(w[0])) {
			const checked = w[0] === "x" || w[0] === "X";
			pushParsed({
				type: "checkbox_input",
				checked,
				raw: checked ? "[x]" : "[ ]"
			});
			i++;
			return true;
		}
		return false;
	}
	return normalizeSingleLinkResult(raw, result);
}
function normalizeSingleLinkResult(raw, nodes) {
	if (!raw) return nodes;
	const trimmed = raw.trim();
	const m = /^\[([\s\S]+?)\]\(([^)]+)\)$/.exec(trimmed);
	if (!m) return nodes;
	const label = m[1];
	const href = m[2];
	const candidates = nodes.filter((n) => n.type === "link");
	const preferred = candidates.find((n) => String(n.href || "") === href && String(n.text || "") === label) || candidates.find((n) => String(n.href || "") === href);
	if (preferred) return [preferred];
	return nodes;
}

//#endregion
//#region src/parser/node-parsers/code-block-parser.ts
function parseCodeBlock(token) {
	if (token.info?.startsWith("diff")) return parseFenceToken(token);
	const contentStr = String(token.content ?? "");
	const match = contentStr.match(/ type="application\/vnd\.ant\.([^"]+)"/);
	if (match?.[1]) token.content = contentStr.replace(/<antArtifact[^>]*>/g, "").replace(/<\/antArtifact>/g, "");
	const hasMap = Array.isArray(token.map) && token.map.length === 2;
	return {
		type: "code_block",
		language: match ? match[1] : String(token.info ?? ""),
		code: String(token.content ?? ""),
		raw: String(token.content ?? ""),
		loading: !hasMap
	};
}

//#endregion
//#region src/parser/node-parsers/definition-list-parser.ts
function parseDefinitionList(tokens, index, options) {
	const items = [];
	let j = index + 1;
	let termNodes = [];
	let definitionNodes = [];
	while (j < tokens.length && tokens[j].type !== "dl_close") if (tokens[j].type === "dt_open") {
		const termToken = tokens[j + 1];
		termNodes = parseInlineTokens(termToken.children || [], void 0, void 0, {
			requireClosingStrong: options?.requireClosingStrong,
			customHtmlTags: options?.customHtmlTags
		});
		j += 3;
	} else if (tokens[j].type === "dd_open") {
		let k = j + 1;
		definitionNodes = [];
		while (k < tokens.length && tokens[k].type !== "dd_close") if (tokens[k].type === "paragraph_open") {
			const contentToken = tokens[k + 1];
			definitionNodes.push({
				type: "paragraph",
				children: parseInlineTokens(contentToken.children || [], String(contentToken.content ?? ""), void 0, {
					requireClosingStrong: options?.requireClosingStrong,
					customHtmlTags: options?.customHtmlTags
				}),
				raw: String(contentToken.content ?? "")
			});
			k += 3;
		} else k++;
		if (termNodes.length > 0) {
			items.push({
				type: "definition_item",
				term: termNodes,
				definition: definitionNodes,
				raw: `${termNodes.map((term) => term.raw).join("")}: ${definitionNodes.map((def) => def.raw).join("\n")}`
			});
			termNodes = [];
		}
		j = k + 1;
	} else j++;
	return [{
		type: "definition_list",
		items,
		raw: items.map((item) => item.raw).join("\n")
	}, j + 1];
}

//#endregion
//#region src/parser/node-parsers/footnote-parser.ts
function parseFootnote(tokens, index, options) {
	const meta = tokens[index].meta ?? {};
	const id = String(meta?.label ?? "0");
	const footnoteChildren = [];
	let j = index + 1;
	while (j < tokens.length && tokens[j].type !== "footnote_close") if (tokens[j].type === "paragraph_open") {
		const contentToken = tokens[j + 1];
		const children = contentToken.children || [];
		if (tokens[j + 2].type === "footnote_anchor") children.push(tokens[j + 2]);
		footnoteChildren.push({
			type: "paragraph",
			children: parseInlineTokens(contentToken.children || [], String(contentToken.content ?? ""), void 0, {
				requireClosingStrong: options?.requireClosingStrong,
				customHtmlTags: options?.customHtmlTags
			}),
			raw: String(contentToken.content ?? "")
		});
		j += 3;
	} else j++;
	return [{
		type: "footnote",
		id,
		children: footnoteChildren,
		raw: `[^${id}]: ${footnoteChildren.map((child) => child.raw).join("\n")}`
	}, j + 1];
}

//#endregion
//#region src/parser/node-parsers/heading-parser.ts
function parseHeading(tokens, index, options) {
	const token = tokens[index];
	const levelStr = String(token.tag?.substring(1) ?? "1");
	const headingLevel = Number.parseInt(levelStr, 10);
	const headingContentToken = tokens[index + 1];
	const headingContent = String(headingContentToken.content ?? "");
	return {
		type: "heading",
		level: headingLevel,
		text: headingContent,
		children: parseInlineTokens(headingContentToken.children || [], headingContent, void 0, {
			requireClosingStrong: options?.requireClosingStrong,
			customHtmlTags: options?.customHtmlTags
		}),
		raw: headingContent
	};
}

//#endregion
//#region src/parser/node-parsers/html-block-parser.ts
const VOID_TAGS = new Set([
	"area",
	"base",
	"br",
	"col",
	"embed",
	"hr",
	"img",
	"input",
	"link",
	"meta",
	"param",
	"source",
	"track",
	"wbr"
]);
const CLOSE_TAG_RE_CACHE = /* @__PURE__ */ new Map();
function parseHtmlBlock(token) {
	const raw = String(token.content ?? "");
	if (/^\s*<!--/.test(raw) || /^\s*<!/.test(raw) || /^\s*<\?/.test(raw)) return {
		type: "html_block",
		content: raw,
		raw,
		tag: "",
		loading: false
	};
	const tag = (raw.match(/^\s*<([A-Z][\w:-]*)/i)?.[1] || "").toLowerCase();
	if (!tag) return {
		type: "html_block",
		content: raw,
		raw,
		tag: "",
		loading: false
	};
	const selfClosing = /^\s*<[^>]*\/\s*>/.test(raw);
	const isVoid = VOID_TAGS.has(tag);
	let closeRe = CLOSE_TAG_RE_CACHE.get(tag);
	if (!closeRe) {
		closeRe = new RegExp(`<\\s*\\/\\s*${tag}\\s*>`, "i");
		CLOSE_TAG_RE_CACHE.set(tag, closeRe);
	}
	const hasClosing = closeRe.test(raw);
	const loading = !(isVoid || selfClosing || hasClosing);
	return {
		type: "html_block",
		content: loading ? `${raw.replace(/<[^>]*$/, "")}\n</${tag}>` : raw,
		raw,
		tag,
		loading
	};
}

//#endregion
//#region src/parser/node-parsers/math-block-parser.ts
function parseMathBlock(token) {
	const content = String(token.content ?? "");
	const raw = token.raw === "$$" ? `$$${content}$$` : String(token.raw ?? "");
	return {
		type: "math_block",
		content,
		loading: !!token.loading,
		raw
	};
}

//#endregion
//#region src/parser/node-parsers/table-parser.ts
function extractAlign(attrs) {
	if (!attrs) return "left";
	for (const a of attrs) {
		if (!a) continue;
		const [key, val] = a;
		if (!val) continue;
		const value = String(val).trim().toLowerCase();
		if (key === "style") {
			const m = /text-align\s*:\s*(left|right|center)/i.exec(value);
			if (m) return m[1].toLowerCase();
		}
	}
	return "left";
}
function parseTable(tokens, index, options) {
	let j = index + 1;
	let headerRow = null;
	const rows = [];
	let isHeader = false;
	while (j < tokens.length && tokens[j].type !== "table_close") if (tokens[j].type === "thead_open") {
		isHeader = true;
		j++;
	} else if (tokens[j].type === "thead_close") {
		isHeader = false;
		j++;
	} else if (tokens[j].type === "tbody_open" || tokens[j].type === "tbody_close") j++;
	else if (tokens[j].type === "tr_open") {
		const cells = [];
		let k = j + 1;
		while (k < tokens.length && tokens[k].type !== "tr_close") if (tokens[k].type === "th_open" || tokens[k].type === "td_open") {
			const isHeaderCell = tokens[k].type === "th_open";
			const contentToken = tokens[k + 1];
			const content = String(contentToken.content ?? "");
			const align = extractAlign(tokens[k].attrs);
			cells.push({
				type: "table_cell",
				header: isHeaderCell || isHeader,
				children: parseInlineTokens(contentToken.children || [], content, void 0, {
					requireClosingStrong: options?.requireClosingStrong,
					customHtmlTags: options?.customHtmlTags
				}),
				raw: content,
				align
			});
			k += 3;
		} else k++;
		const rowNode = {
			type: "table_row",
			cells,
			raw: cells.map((cell) => cell.raw).join("|")
		};
		if (isHeader) headerRow = rowNode;
		else rows.push(rowNode);
		j = k + 1;
	} else j++;
	if (!headerRow) headerRow = {
		type: "table_row",
		cells: [],
		raw: ""
	};
	return [{
		type: "table",
		header: headerRow,
		rows,
		loading: tokens[index].loading ?? false,
		raw: [headerRow, ...rows].map((row) => row.raw).join("\n")
	}, j + 1];
}

//#endregion
//#region src/parser/node-parsers/thematic-break-parser.ts
function parseThematicBreak() {
	return {
		type: "thematic_break",
		raw: "---"
	};
}

//#endregion
//#region src/parser/node-parsers/block-token-parser.ts
function findTagCloseIndexOutsideQuotes(input) {
	let inSingle = false;
	let inDouble = false;
	for (let i = 0; i < input.length; i++) {
		const ch = input[i];
		if (ch === "\\") {
			i++;
			continue;
		}
		if (!inDouble && ch === "'") {
			inSingle = !inSingle;
			continue;
		}
		if (!inSingle && ch === "\"") {
			inDouble = !inDouble;
			continue;
		}
		if (!inSingle && !inDouble && ch === ">") return i;
	}
	return -1;
}
function stripWrapperNewlines(s) {
	return s.replace(/^\r?\n/, "").replace(/\r?\n$/, "");
}
function stripTrailingPartialClosingTag(inner, tag) {
	if (!inner || !tag) return inner;
	const re = new RegExp(String.raw`[\t ]*<\s*\/\s*${tag}[^>]*$`, "i");
	return inner.replace(re, "");
}
function findNextCustomHtmlBlockFromSource(source, tag, startIndex) {
	if (!source || !tag) return null;
	const lowerTag = tag.toLowerCase();
	const openRe = new RegExp(String.raw`<\s*${lowerTag}(?=\s|>|/)`, "gi");
	openRe.lastIndex = Math.max(0, startIndex || 0);
	const openMatch = openRe.exec(source);
	if (!openMatch || openMatch.index == null) return null;
	const openStart = openMatch.index;
	const openSlice = source.slice(openStart);
	const openEndRel = findTagCloseIndexOutsideQuotes(openSlice);
	if (openEndRel === -1) return null;
	const openEnd = openStart + openEndRel;
	if (/\/\s*>\s*$/.test(openSlice.slice(0, openEndRel + 1))) {
		const end = openEnd + 1;
		return {
			raw: source.slice(openStart, end),
			end
		};
	}
	let depth = 1;
	let i = openEnd + 1;
	const isOpenAt = (pos) => {
		const s = source.slice(pos);
		return new RegExp(String.raw`^<\s*${lowerTag}(?=\s|>|/)`, "i").test(s);
	};
	const isCloseAt = (pos) => {
		const s = source.slice(pos);
		return new RegExp(String.raw`^<\s*\/\s*${lowerTag}(?=\s|>)`, "i").test(s);
	};
	while (i < source.length) {
		const lt = source.indexOf("<", i);
		if (lt === -1) return {
			raw: source.slice(openStart),
			end: source.length
		};
		if (isCloseAt(lt)) {
			const gt = source.indexOf(">", lt);
			if (gt === -1) return null;
			depth--;
			if (depth === 0) {
				const end = gt + 1;
				return {
					raw: source.slice(openStart, end),
					end
				};
			}
			i = gt + 1;
			continue;
		}
		if (isOpenAt(lt)) {
			const rel = findTagCloseIndexOutsideQuotes(source.slice(lt));
			if (rel === -1) return null;
			depth++;
			i = lt + rel + 1;
			continue;
		}
		i = lt + 1;
	}
	return {
		raw: source.slice(openStart),
		end: source.length
	};
}
function parseBasicBlockToken(tokens, index, options) {
	const token = tokens[index];
	switch (token.type) {
		case "heading_open": return [parseHeading(tokens, index, options), index + 3];
		case "code_block": return [parseCodeBlock(token), index + 1];
		case "fence": return [parseFenceToken(token), index + 1];
		case "math_block": return [parseMathBlock(token), index + 1];
		case "html_block": {
			const htmlBlockNode = parseHtmlBlock(token);
			if (options?.customHtmlTags && htmlBlockNode.tag) {
				if (new Set(options.customHtmlTags.map((t) => {
					const m = String(t ?? "").trim().match(/^[<\s/]*([A-Z][\w-]*)/i);
					return m ? m[1].toLowerCase() : "";
				}).filter(Boolean)).has(htmlBlockNode.tag)) {
					const tag = htmlBlockNode.tag;
					const fromSource = findNextCustomHtmlBlockFromSource(String(options?.__sourceMarkdown ?? ""), tag, Number(options?.__customHtmlBlockCursor ?? 0));
					if (fromSource) options.__customHtmlBlockCursor = fromSource.end;
					const rawHtml = String(fromSource?.raw ?? htmlBlockNode.content ?? "");
					const openEnd = findTagCloseIndexOutsideQuotes(rawHtml);
					const closeMatch = new RegExp(`<\\s*\\/\\s*${tag}\\s*>`, "i").exec(rawHtml);
					const closeIndex = closeMatch ? closeMatch.index : -1;
					let inner = "";
					if (openEnd !== -1) if (closeIndex !== -1 && openEnd < closeIndex) inner = rawHtml.slice(openEnd + 1, closeIndex);
					else inner = rawHtml.slice(openEnd + 1);
					if (closeIndex === -1) inner = stripTrailingPartialClosingTag(inner, tag);
					const attrs = [];
					const openTag = openEnd !== -1 ? rawHtml.slice(0, openEnd + 1) : rawHtml;
					const attrRegex = /\s([\w:-]+)(?:\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s"'>]+)))?/g;
					let m;
					while ((m = attrRegex.exec(openTag)) !== null) {
						const name = m[1];
						if (!name || name.toLowerCase() === tag) continue;
						const value = m[2] || m[3] || m[4] || "";
						attrs.push([name, value]);
					}
					return [{
						type: tag,
						tag,
						content: stripWrapperNewlines(inner),
						raw: String(fromSource?.raw ?? htmlBlockNode.raw ?? rawHtml),
						loading: htmlBlockNode.loading,
						attrs: attrs.length ? attrs : void 0
					}, index + 1];
				}
			}
			return [htmlBlockNode, index + 1];
		}
		case "table_open": {
			const [tableNode, newIndex] = parseTable(tokens, index, options);
			return [tableNode, newIndex];
		}
		case "dl_open": {
			const [definitionListNode, newIndex] = parseDefinitionList(tokens, index, options);
			return [definitionListNode, newIndex];
		}
		case "footnote_open": {
			const [footnoteNode, newIndex] = parseFootnote(tokens, index, options);
			return [footnoteNode, newIndex];
		}
		case "hr": return [parseThematicBreak(), index + 1];
		default: break;
	}
	return null;
}
function parseCommonBlockToken(tokens, index, options, handlers) {
	const basicResult = parseBasicBlockToken(tokens, index, options);
	if (basicResult) return basicResult;
	switch (tokens[index].type) {
		case "container_warning_open":
		case "container_info_open":
		case "container_note_open":
		case "container_tip_open":
		case "container_danger_open":
		case "container_caution_open":
		case "container_error_open":
			if (handlers?.parseContainer) return handlers.parseContainer(tokens, index, options);
			break;
		case "container_open":
			if (handlers?.matchAdmonition) {
				const result = handlers.matchAdmonition(tokens, index, options);
				if (result) return result;
			}
			break;
		default: break;
	}
	return null;
}

//#endregion
//#region src/parser/node-parsers/list-parser.ts
function parseList(tokens, index, options) {
	const token = tokens[index];
	const listItems = [];
	let j = index + 1;
	while (j < tokens.length && tokens[j].type !== "bullet_list_close" && tokens[j].type !== "ordered_list_close") if (tokens[j].type === "list_item_open") {
		const itemChildren = [];
		let k = j + 1;
		while (k < tokens.length && tokens[k].type !== "list_item_close") if (tokens[k].type === "paragraph_open") {
			const contentToken = tokens[k + 1];
			const preToken = tokens[k - 1];
			const contentStr = String(contentToken.content ?? "");
			if (/\n\d+$/.test(contentStr)) {
				contentToken.content = contentStr.replace(/\n\d+$/, "");
				contentToken.children?.splice(-1, 1);
			}
			itemChildren.push({
				type: "paragraph",
				children: parseInlineTokens(contentToken.children || [], String(contentToken.content ?? ""), preToken, {
					requireClosingStrong: options?.requireClosingStrong,
					customHtmlTags: options?.customHtmlTags
				}),
				raw: String(contentToken.content ?? "")
			});
			k += 3;
		} else if (tokens[k].type === "blockquote_open") {
			const [blockquoteNode, newIndex] = parseBlockquote(tokens, k, options);
			itemChildren.push(blockquoteNode);
			k = newIndex;
		} else if (tokens[k].type === "bullet_list_open" || tokens[k].type === "ordered_list_open") {
			const [nestedListNode, newIndex] = parseList(tokens, k, options);
			itemChildren.push(nestedListNode);
			k = newIndex;
		} else {
			const handled = parseCommonBlockToken(tokens, k, options, containerTokenHandlers);
			if (handled) {
				itemChildren.push(handled[0]);
				k = handled[1];
			} else k += 1;
		}
		listItems.push({
			type: "list_item",
			children: itemChildren,
			raw: itemChildren.map((child) => child.raw).join("")
		});
		j = k + 1;
	} else j += 1;
	return [{
		type: "list",
		ordered: token.type === "ordered_list_open",
		start: (() => {
			if (token.attrs && token.attrs.length) {
				const found = token.attrs.find((a) => a[0] === "start");
				if (found) {
					const parsed = Number(found[1]);
					return Number.isFinite(parsed) && parsed !== 0 ? parsed : 1;
				}
			}
		})(),
		items: listItems,
		raw: listItems.map((item) => item.raw).join("\n")
	}, j + 1];
}

//#endregion
//#region src/parser/node-parsers/admonition-parser.ts
function parseAdmonition(tokens, index, match, options) {
	const kind = String(match[1] ?? "note");
	const title = String(match[2] ?? kind.charAt(0).toUpperCase() + kind.slice(1));
	const admonitionChildren = [];
	let j = index + 1;
	while (j < tokens.length && tokens[j].type !== "container_close") if (tokens[j].type === "paragraph_open") {
		const contentToken = tokens[j + 1];
		if (contentToken) admonitionChildren.push({
			type: "paragraph",
			children: parseInlineTokens(contentToken.children || [], String(contentToken.content ?? ""), void 0, {
				requireClosingStrong: options?.requireClosingStrong,
				customHtmlTags: options?.customHtmlTags
			}),
			raw: String(contentToken.content ?? "")
		});
		j += 3;
	} else if (tokens[j].type === "bullet_list_open" || tokens[j].type === "ordered_list_open") {
		const [listNode, newIndex] = parseList(tokens, j, options);
		admonitionChildren.push(listNode);
		j = newIndex;
	} else if (tokens[j].type === "blockquote_open") {
		const [blockquoteNode, newIndex] = parseBlockquote(tokens, j, options);
		admonitionChildren.push(blockquoteNode);
		j = newIndex;
	} else {
		const handled = parseBasicBlockToken(tokens, j, options);
		if (handled) {
			admonitionChildren.push(handled[0]);
			j = handled[1];
		} else j++;
	}
	return [{
		type: "admonition",
		kind,
		title,
		children: admonitionChildren,
		raw: `:::${kind} ${title}\n${admonitionChildren.map((child) => child.raw).join("\n")}\n:::`
	}, j + 1];
}

//#endregion
//#region src/parser/node-parsers/container-parser.ts
function parseContainer(tokens, index, options) {
	const openToken = tokens[index];
	let kind = "note";
	let title = "";
	const typeMatch = openToken.type.match(/^container_(\w+)_open$/);
	if (typeMatch) {
		kind = typeMatch[1];
		const info = String(openToken.info ?? "").trim();
		if (info && !info.startsWith(":::")) {
			const maybe = info.replace(/* @__PURE__ */ new RegExp(`^${kind}`), "").trim();
			if (maybe) title = maybe;
		}
	} else {
		const info = String(openToken.info ?? "").trim();
		const match = /^:{1,3}\s*(warning|info|note|tip|danger|caution)\s*(.*)$/i.exec(info);
		if (match) {
			kind = match[1];
			title = String(match[2] ?? "");
		}
	}
	if (!title) title = kind.charAt(0).toUpperCase() + kind.slice(1);
	const children = [];
	let j = index + 1;
	const closeType = /* @__PURE__ */ new RegExp(`^container_${kind}_close$`);
	while (j < tokens.length && tokens[j].type !== "container_close" && !closeType.test(tokens[j].type)) if (tokens[j].type === "paragraph_open") {
		const contentToken = tokens[j + 1];
		if (contentToken) {
			const childrenArr = contentToken.children || [];
			let i = -1;
			for (let k = childrenArr.length - 1; k >= 0; k--) {
				const t = childrenArr[k];
				if (t.type === "text" && /:+/.test(t.content)) {
					i = k;
					break;
				}
			}
			const _children = i !== -1 ? childrenArr.slice(0, i) : childrenArr;
			children.push({
				type: "paragraph",
				children: parseInlineTokens(_children || [], void 0, void 0, {
					requireClosingStrong: options?.requireClosingStrong,
					customHtmlTags: options?.customHtmlTags
				}),
				raw: String(contentToken.content ?? "").replace(/\n:+$/, "").replace(/\n\s*:::\s*$/, "")
			});
		}
		j += 3;
	} else if (tokens[j].type === "bullet_list_open" || tokens[j].type === "ordered_list_open") {
		const [listNode, newIndex] = parseList(tokens, j, options);
		children.push(listNode);
		j = newIndex;
	} else if (tokens[j].type === "blockquote_open") {
		const [blockquoteNode, newIndex] = parseBlockquote(tokens, j, options);
		children.push(blockquoteNode);
		j = newIndex;
	} else {
		const handled = parseBasicBlockToken(tokens, j, options);
		if (handled) {
			children.push(handled[0]);
			j = handled[1];
		} else j++;
	}
	return [{
		type: "admonition",
		kind,
		title,
		children,
		raw: `:::${kind} ${title}\n${children.map((c) => c.raw).join("\n")}\n:::`
	}, j + 1];
}

//#endregion
//#region src/parser/node-parsers/container-token-handlers.ts
const CONTAINER_REGEX = /^::: ?(warning|info|note|tip|danger|caution|error) ?(.*)$/;
function handleContainerOpen(tokens, index, options) {
	const token = tokens[index];
	if (token.type !== "container_open") return null;
	const match = CONTAINER_REGEX.exec(String(token.info ?? ""));
	if (!match) return null;
	return parseAdmonition(tokens, index, match, options);
}
const containerTokenHandlers = {
	parseContainer: (tokens, index, options) => parseContainer(tokens, index, options),
	matchAdmonition: handleContainerOpen
};

//#endregion
//#region src/parser/node-parsers/blockquote-parser.ts
function parseBlockquote(tokens, index, options) {
	const blockquoteChildren = [];
	let j = index + 1;
	while (j < tokens.length && tokens[j].type !== "blockquote_close") switch (tokens[j].type) {
		case "paragraph_open": {
			const contentToken = tokens[j + 1];
			blockquoteChildren.push({
				type: "paragraph",
				children: parseInlineTokens(contentToken.children || [], String(contentToken.content ?? ""), void 0, {
					requireClosingStrong: options?.requireClosingStrong,
					customHtmlTags: options?.customHtmlTags
				}),
				raw: String(contentToken.content ?? "")
			});
			j += 3;
			break;
		}
		case "bullet_list_open":
		case "ordered_list_open": {
			const [listNode, newIndex] = parseList(tokens, j, options);
			blockquoteChildren.push(listNode);
			j = newIndex;
			break;
		}
		case "blockquote_open": {
			const [nestedBlockquote, newIndex] = parseBlockquote(tokens, j, options);
			blockquoteChildren.push(nestedBlockquote);
			j = newIndex;
			break;
		}
		default: {
			const handled = parseCommonBlockToken(tokens, j, options, containerTokenHandlers);
			if (handled) {
				blockquoteChildren.push(handled[0]);
				j = handled[1];
			} else j++;
			break;
		}
	}
	return [{
		type: "blockquote",
		children: blockquoteChildren,
		raw: blockquoteChildren.map((child) => child.raw).join("\n")
	}, j + 1];
}

//#endregion
//#region src/parser/node-parsers/hardbreak-parser.ts
function parseHardBreak() {
	return {
		type: "hardbreak",
		raw: "\\\n"
	};
}

//#endregion
//#region src/parser/node-parsers/paragraph-parser.ts
function parseParagraph(tokens, index, options) {
	const paragraphContentToken = tokens[index + 1];
	const paragraphContent = String(paragraphContentToken.content ?? "");
	return {
		type: "paragraph",
		children: parseInlineTokens(paragraphContentToken.children || [], paragraphContent, void 0, {
			requireClosingStrong: options?.requireClosingStrong,
			customHtmlTags: options?.customHtmlTags
		}),
		raw: paragraphContent
	};
}

//#endregion
//#region src/parser/index.ts
function stripDanglingHtmlLikeTail(markdown) {
	const s = String(markdown ?? "");
	const lastLt = s.lastIndexOf("<");
	if (lastLt === -1) return s;
	const tail = s.slice(lastLt);
	if (tail.includes(">")) return s;
	if (!/^<\s*(?:\/\s*)?[A-Z!][\s\S]*$/i.test(tail)) return s;
	return s.slice(0, lastLt);
}
function parseMarkdownToStructure(markdown, md, options = {}) {
	let safeMarkdown = (markdown ?? "").toString().replace(/([^\\])\r(ight|ho)/g, "$1\\r$2").replace(/([^\\])\n(abla|eq|ot|exists)/g, "$1\\n$2");
	if (safeMarkdown.endsWith("- *")) safeMarkdown = safeMarkdown.replace(/- \*$/, "- \\*");
	if (/(?:^|\n)\s*-\s*$/.test(safeMarkdown)) safeMarkdown = safeMarkdown.replace(/(?:^|\n)\s*-\s*$/, (m) => {
		return m.startsWith("\n") ? "\n" : "";
	});
	else if (/(?:^|\n)\s*--\s*$/.test(safeMarkdown)) safeMarkdown = safeMarkdown.replace(/(?:^|\n)\s*--\s*$/, (m) => {
		return m.startsWith("\n") ? "\n" : "";
	});
	else if (/(?:^|\n)\s*>\s*$/.test(safeMarkdown)) safeMarkdown = safeMarkdown.replace(/(?:^|\n)\s*>\s*$/, (m) => {
		return m.startsWith("\n") ? "\n" : "";
	});
	else if (/\n\s*[*+]\s*$/.test(safeMarkdown)) safeMarkdown = safeMarkdown.replace(/\n\s*[*+]\s*$/, "\n");
	else if (/\n[[(]\n*$/.test(safeMarkdown)) safeMarkdown = safeMarkdown.replace(/(\n\[|\n\()+\n*$/g, "\n");
	if (options.customHtmlTags?.length) {
		const tags = options.customHtmlTags.map((t) => String(t ?? "").trim()).filter(Boolean).map((t) => {
			return (t.match(/^[<\s/]*([A-Z][\w-]*)/i)?.[1] ?? "").toLowerCase();
		}).filter(Boolean);
		if (tags.length) if (!safeMarkdown.includes("</")) {} else for (const tag of tags) {
			const re = new RegExp(String.raw`(^[\t ]*<\s*\/\s*${tag}\s*>[\t ]*)(\r?\n)(?![\t ]*\r?\n|$)`, "gim");
			safeMarkdown = safeMarkdown.replace(re, "$1$2$2");
		}
	}
	safeMarkdown = stripDanglingHtmlLikeTail(safeMarkdown);
	const tokens = md.parse(safeMarkdown, {});
	if (!tokens || !Array.isArray(tokens)) return [];
	const pre = options.preTransformTokens;
	const post = options.postTransformTokens;
	let transformedTokens = tokens;
	if (pre && typeof pre === "function") transformedTokens = pre(transformedTokens) || transformedTokens;
	const internalOptions = {
		...options,
		__sourceMarkdown: safeMarkdown,
		__customHtmlBlockCursor: 0
	};
	let result = processTokens(transformedTokens, internalOptions);
	if (post && typeof post === "function") {
		const postResult = post(transformedTokens);
		if (Array.isArray(postResult)) {
			const first = postResult[0];
			const firstType = first?.type;
			if (first && typeof firstType === "string") result = processTokens(postResult);
			else result = postResult;
		}
	}
	if (options.debug) console.log("Parsed Markdown Tree Structure:", result);
	return result;
}
function processTokens(tokens, options) {
	if (!tokens || !Array.isArray(tokens)) return [];
	const result = [];
	let i = 0;
	while (i < tokens.length) {
		const handled = parseCommonBlockToken(tokens, i, options, containerTokenHandlers);
		if (handled) {
			result.push(handled[0]);
			i = handled[1];
			continue;
		}
		const token = tokens[i];
		switch (token.type) {
			case "paragraph_open":
				result.push(parseParagraph(tokens, i, options));
				i += 3;
				break;
			case "bullet_list_open":
			case "ordered_list_open": {
				const [listNode, newIndex] = parseList(tokens, i, options);
				result.push(listNode);
				i = newIndex;
				break;
			}
			case "blockquote_open": {
				const [blockquoteNode, newIndex] = parseBlockquote(tokens, i, options);
				result.push(blockquoteNode);
				i = newIndex;
				break;
			}
			case "footnote_anchor": {
				const meta = token.meta ?? {};
				const id = String(meta.label ?? token.content ?? "");
				result.push({
					type: "footnote_anchor",
					id,
					raw: String(token.content ?? "")
				});
				i++;
				break;
			}
			case "hardbreak":
				result.push(parseHardBreak());
				i++;
				break;
			case "text": {
				const content = String(token.content ?? "");
				result.push({
					type: "paragraph",
					raw: content,
					children: content ? [{
						type: "text",
						content,
						raw: content
					}] : []
				});
				i++;
				break;
			}
			case "inline":
				result.push(...parseInlineTokens(token.children || [], String(token.content ?? ""), void 0, {
					requireClosingStrong: options?.requireClosingStrong,
					customHtmlTags: options?.customHtmlTags
				}));
				i += 1;
				break;
			default:
				i += 1;
				break;
		}
	}
	return result;
}

//#endregion
//#region src/index.ts
const _registeredMarkdownPlugins = [];
function registerMarkdownPlugin(plugin) {
	_registeredMarkdownPlugins.push(plugin);
}
function clearRegisteredMarkdownPlugins() {
	_registeredMarkdownPlugins.length = 0;
}
function getMarkdown(msgId = `editor-${Date.now()}`, options = {}) {
	const md = factory(options);
	const defaultTranslations = { "common.copy": "Copy" };
	let t;
	if (typeof options.i18n === "function") t = options.i18n;
	else if (options.i18n && typeof options.i18n === "object") {
		const i18nMap = options.i18n;
		t = (key) => i18nMap[key] ?? defaultTranslations[key] ?? key;
	} else t = (key) => defaultTranslations[key] ?? key;
	if (Array.isArray(options.plugin)) for (const p of options.plugin) {
		const pluginItem = p;
		if (Array.isArray(pluginItem)) {
			const fn = pluginItem[0];
			const opts = pluginItem[1];
			if (typeof fn === "function") md.use(fn, opts);
		} else if (typeof pluginItem === "function") md.use(pluginItem);
	}
	if (Array.isArray(options.apply)) for (const fn of options.apply) try {
		fn(md);
	} catch (e) {
		console.error("[getMarkdown] apply function threw an error", e);
	}
	if (_registeredMarkdownPlugins.length) {
		for (const p of _registeredMarkdownPlugins) if (Array.isArray(p)) {
			const fn = p[0];
			const opts = p[1];
			if (typeof fn === "function") md.use(fn, opts);
		} else if (typeof p === "function") md.use(p);
	}
	md.use(sub_plugin);
	md.use(sup_plugin);
	md.use(ins_plugin$1);
	const markdownItCheckboxPlugin = import_markdown_it_task_checkbox.default ?? import_markdown_it_task_checkbox;
	md.use(markdownItCheckboxPlugin);
	md.use(ins_plugin);
	md.use(footnote_plugin);
	md.core.ruler.after("block", "mark_fence_closed", (state) => {
		const s = state;
		const lines = s.src.split(/\r?\n/);
		for (const token of s.tokens) {
			if (token.type !== "fence" || !token.map || !token.markup) continue;
			const openLine = token.map[0];
			const endLine = token.map[1];
			const markup = token.markup;
			const marker = markup[0];
			const minLen = markup.length;
			const line = lines[Math.max(0, endLine - 1)] ?? "";
			let i = 0;
			while (i < line.length && (line[i] === " " || line[i] === "	")) i++;
			let count = 0;
			while (i + count < line.length && line[i + count] === marker) count++;
			let j = i + count;
			while (j < line.length && (line[j] === " " || line[j] === "	")) j++;
			const closed = endLine > openLine + 1 && count >= minLen && j === line.length;
			const tokenShape = token;
			tokenShape.meta = tokenShape.meta ?? {};
			tokenShape.meta.unclosed = !closed;
			tokenShape.meta.closed = !!closed;
		}
	});
	const waveRule = (state, silent) => {
		const s = state;
		const start = s.pos;
		if (s.src[start] !== "~") return false;
		const prevChar = s.src[start - 1];
		const nextChar = s.src[start + 1];
		if (/\d/.test(prevChar) && /\d/.test(nextChar)) {
			if (!silent) {
				const token = s.push("text", "", 0);
				token.content = "~";
			}
			s.pos += 1;
			return true;
		}
		return false;
	};
	md.inline.ruler.before("sub", "wave", waveRule);
	md.renderer.rules.fence = (tokens, idx) => {
		const tokenShape = tokens[idx];
		const info = String(tokenShape.info ?? "").trim();
		const str = String(tokenShape.content ?? "");
		const encodedCode = btoa(unescape(encodeURIComponent(str)));
		const language = String(info ?? "text");
		return `<div class="code-block" data-code="${encodedCode}" data-lang="${language}" id="${`editor-${msgId}-${idx}-${language}`}">
      <div class="code-header">
        <span class="code-lang">${language.toUpperCase()}</span>
        <button class="copy-button" data-code="${encodedCode}">${t("common.copy")}</button>
      </div>
      <div class="code-editor"></div>
    </div>`;
	};
	const RE_REFERENCE = /^\[(\d+)\]/;
	const referenceInline = (state, silent) => {
		const s = state;
		if (s.src[s.pos] !== "[") return false;
		const match = RE_REFERENCE.exec(s.src.slice(s.pos));
		if (!match) return false;
		if (!silent) {
			const id = match[1];
			const token = s.push("reference", "span", 0);
			token.content = id;
			token.markup = match[0];
		}
		s.pos += match[0].length;
		return true;
	};
	md.inline.ruler.before("escape", "reference", referenceInline);
	md.renderer.rules.reference = (tokens, idx) => {
		const tokensAny = tokens;
		const id = String(tokensAny[idx].content ?? "");
		return `<span class="reference-link" data-reference-id="${id}" role="button" tabindex="0" title="Click to view reference">${id}</span>`;
	};
	return md;
}

//#endregion
export { ESCAPED_TEX_BRACE_COMMANDS, KATEX_COMMANDS, TEX_BRACE_COMMANDS, applyContainers, applyMath, clearRegisteredMarkdownPlugins, findMatchingClose, getMarkdown, isMathLike, normalizeStandaloneBackslashT, parseFenceToken, parseInlineTokens, parseMarkdownToStructure, processTokens, registerMarkdownPlugin, setDefaultMathOptions };
//# sourceMappingURL=index.js.map